/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { AxiosResponse } from 'axios'
import { z } from 'zod'

import * as AdminAnalyticsTypes from './admin-analytics-types'
import * as AdminAssetsTypes from './admin-assets-types'
import * as AdminBillingTypes from './admin-billing-types'
import * as AdminCompaniesTypes from './admin-companies-types'
import * as AdminCountryTypes from './admin-country-types'
import * as AdminCustomerGroupsTypes from './admin-customer-groups-types'
import * as AdminCustomersTypes from './admin-customers-types'
import * as AdminDashboardFeaturesTypes from './admin-dashboard-features-types'
import * as AdminDevicesTypes from './admin-devices-types'
import * as AdminGiftCardTypes from './admin-gift-card-types'
import * as AdminIntegrationsTypes from './admin-integrations-types'
import * as AdminInventoryTypes from './admin-inventory-types'
import * as AdminLoyaltyCardTypes from './admin-loyalty-card-types'
import * as AdminMarketingChannelsTypes from './admin-marketing-channels-types'
import * as AdminMarketingContentTypes from './admin-marketing-content-types'
import * as AdminOrdersTypes from './admin-orders-types'
import * as AdminProductsTypes from './admin-products-types'
import * as AdminPromotionGroupsTypes from './admin-promotion-groups-types'
import * as AdminPromotionsTypes from './admin-promotions-types'
import * as AdminSalesChannelsTypes from './admin-sales-channels-types'
import * as AdminTypes from './admin-types'
import * as CommonTypes from './common-types'
import * as PublicTypes from './public-types'

export enum HttpMethod {
	Get = 'GET',
	Post = 'POST',
	Put = 'PUT',
	Delete = 'DELETE',
	Patch = 'PATCH'
}

export enum Endpoint {
	/**
	 * @example Path*
/v1/admin/api-key*/
	GetApiKey = 'GetApiKey',
	/**
	 * @example Path*
/v1/admin/auth/login*/
	Login = 'Login',
	/**
	 * @example Path*
/v1/admin/auth/register*/
	Register = 'Register',
	/**
	 * @example Path*
/v1/admin/auth/reset-password*/
	ResetPassword = 'ResetPassword',
	/**
	 * @example Path*
/v1/admin/auth/reset-password/update*/
	UpdatePassword = 'UpdatePassword',
	/**
	 * @example Path*
/v1/admin/users*/
	ListUsers = 'ListUsers',
	/**
	 * @example Path*
/v1/admin/users/me*/
	GetMe = 'GetMe',
	/**
	 * @example Path*
/v1/admin/users/me*/
	UpdateMe = 'UpdateMe',
	/**
	 * @example Path*
/v1/admin/users/me/sign-in-pin*/
	ValidateMySignInPin = 'ValidateMySignInPin',
	/**
	 * @example Path*
/v1/admin/users/me/sign-in-pin*/
	SetMySignInPin = 'SetMySignInPin',
	/**
	 * @example Path*
/v1/admin/users/:userUuid*/
	GetUser = 'GetUser',
	/**
	 * @example Path*
/v1/admin/users/:userUuid*/
	UpdateUser = 'UpdateUser',
	/**
	 * @example Path*
/v1/admin/users/:userUuid*/
	DeleteUser = 'DeleteUser',
	/**
	 * @example Path*
/v1/admin/users/:userUuid/sign-in-credentials*/
	GetUserSignInCredentials = 'GetUserSignInCredentials',
	/**
	 * @example Path*
/v1/admin/users/:userUuid/sign-in-credentials*/
	SetUserSignInCredentials = 'SetUserSignInCredentials',
	/**
	 * @example Path*
/v1/admin/invites*/
	ListInvites = 'ListInvites',
	/**
	 * @example Path*
/v1/admin/invites*/
	CreateInvite = 'CreateInvite',
	/**
	 * @example Path*
/v1/admin/invites/:inviteUuid*/
	DeleteInvite = 'DeleteInvite',
	/**
	 * @example Path*
/v1/admin/sales-channel-types*/
	ListSalesChannelTypes = 'ListSalesChannelTypes',
	/**
	 * @example Path*
/v1/admin/sales-channel-types*/
	CreateSalesChannelType = 'CreateSalesChannelType',
	/**
	 * @example Path*
/v1/admin/sales-channel-types/:salesChannelTypeUuid*/
	GetSalesChannelType = 'GetSalesChannelType',
	/**
	 * @example Path*
/v1/admin/sales-channel-types/:salesChannelTypeUuid*/
	UpdateSalesChannelType = 'UpdateSalesChannelType',
	/**
	 * @example Path*
/v1/admin/sales-channel-types/:salesChannelTypeUuid*/
	DeleteSalesChannelType = 'DeleteSalesChannelType',
	/**
	 * @example Path*
/v1/admin/sales-channel-groups*/
	ListSalesChannelGroups = 'ListSalesChannelGroups',
	/**
	 * @example Path*
/v1/admin/sales-channel-groups*/
	CreateSalesChannelGroup = 'CreateSalesChannelGroup',
	/**
	 * @example Path*
/v1/admin/sales-channel-groups/:salesChannelGroupUuid*/
	GetSalesChannelGroup = 'GetSalesChannelGroup',
	/**
	 * @example Path*
/v1/admin/sales-channel-groups/:salesChannelGroupUuid*/
	UpdateSalesChannelGroup = 'UpdateSalesChannelGroup',
	/**
	 * @example Path*
/v1/admin/sales-channel-groups/:salesChannelGroupUuid*/
	DeleteSalesChannelGroup = 'DeleteSalesChannelGroup',
	/**
	 * @example Path*
/v1/admin/sales-channels*/
	ListSalesChannels = 'ListSalesChannels',
	/**
	 * @example Path*
/v1/admin/sales-channels*/
	CreateSalesChannel = 'CreateSalesChannel',
	/**
	 * @example Path*
/v1/admin/sales-channels/:salesChannelUuid*/
	GetSalesChannel = 'GetSalesChannel',
	/**
	 * @example Path*
/v1/admin/sales-channels/:salesChannelUuid*/
	UpdateSalesChannel = 'UpdateSalesChannel',
	/**
	 * @example Path*
/v1/admin/sales-channels/:salesChannelUuid*/
	DeleteSalesChannel = 'DeleteSalesChannel',
	/**
	 * @example Path*
/v1/admin/point-of-sale-groups*/
	ListPointOfSaleGroups = 'ListPointOfSaleGroups',
	/**
	 * @example Path*
/v1/admin/point-of-sale-groups*/
	CreatePointOfSaleGroup = 'CreatePointOfSaleGroup',
	/**
	 * @example Path*
/v1/admin/point-of-sale-groups/:pointOfSaleGroupUuid*/
	GetPointOfSaleGroup = 'GetPointOfSaleGroup',
	/**
	 * @example Path*
/v1/admin/point-of-sale-groups/:pointOfSaleGroupUuid*/
	UpdatePointOfSaleGroup = 'UpdatePointOfSaleGroup',
	/**
	 * @example Path*
/v1/admin/point-of-sale-groups/:pointOfSaleGroupUuid*/
	DeletePointOfSaleGroup = 'DeletePointOfSaleGroup',
	/**
	 * @example Path*
/v1/admin/point-of-sale*/
	ListPointsOfSale = 'ListPointsOfSale',
	/**
	 * @example Path*
/v1/admin/point-of-sale*/
	CreatePointOfSale = 'CreatePointOfSale',
	/**
	 * @example Path*
/v1/admin/point-of-sale/hierarchy*/
	GetPointOfSaleHierarchy = 'GetPointOfSaleHierarchy',
	/**
	 * @example Path*
/v1/admin/point-of-sale/info*/
	GetCurrentPointOfSale = 'GetCurrentPointOfSale',
	/**
	 * @example Path*
/v1/admin/point-of-sale/ws-ticket*/
	CreatePointOfSaleWebSocketTicket = 'CreatePointOfSaleWebSocketTicket',
	/**
	 * @example Path*
/v1/admin/point-of-sale/:pointOfSaleUuid*/
	GetPointOfSale = 'GetPointOfSale',
	/**
	 * @example Path*
/v1/admin/point-of-sale/:pointOfSaleUuid*/
	UpdatePointOfSale = 'UpdatePointOfSale',
	/**
	 * @example Path*
/v1/admin/point-of-sale/:pointOfSaleUuid/open-cooler*/
	OpenCooler = 'OpenCooler',
	/**
	 * @example Path*
/v1/admin/point-of-sale/:pointOfSaleUuid/cash-float/open*/
	OpenCashFloat = 'OpenCashFloat',
	/**
	 * @example Path*
/v1/admin/point-of-sale/:pointOfSaleUuid/cash-float/pay-in*/
	CashPayIn = 'CashPayIn',
	/**
	 * @example Path*
/v1/admin/point-of-sale/:pointOfSaleUuid/cash-float/pay-out*/
	CashPayOut = 'CashPayOut',
	/**
	 * @example Path*
/v1/admin/point-of-sale/:pointOfSaleUuid/cash-float/count*/
	CashCount = 'CashCount',
	/**
	 * @example Path*
/v1/admin/point-of-sale/:pointOfSaleUuid/device-status*/
	GetPointOfSaleDeviceStatus = 'GetPointOfSaleDeviceStatus',
	/**
	 * @example Path*
/v1/admin/point-of-sale/:pointOfSaleUuid/device-status/refresh*/
	RefreshPointOfSaleDeviceStatus = 'RefreshPointOfSaleDeviceStatus',
	/**
	 * @example Path*
/v1/admin/point-of-sale/:pointOfSaleUuid/device-enrollment/by-code/:code*/
	LookupDeviceEnrollmentByCode = 'LookupDeviceEnrollmentByCode',
	/**
	 * @example Path*
/v1/admin/point-of-sale/:pointOfSaleUuid/device-enrollment/enroll*/
	EnrollPointOfSaleDevice = 'EnrollPointOfSaleDevice',
	/**
	 * @example Path*
/v1/admin/point-of-sale/:pointOfSaleUuid/device-enrollment/unenroll*/
	UnenrollPointOfSaleDevice = 'UnenrollPointOfSaleDevice',
	/**
	 * @example Path*
/v1/admin/point-of-sale/:pointOfSaleUuid/notify-app-update*/
	NotifyPointOfSaleAppUpdate = 'NotifyPointOfSaleAppUpdate',
	/**
	 * @example Path*
/v1/admin/point-of-sale/:pointOfSaleUuid/restart-app*/
	RestartPointOfSaleApp = 'RestartPointOfSaleApp',
	/**
	 * @example Path*
/v1/admin/point-of-sale/:pointOfSaleUuid/lock-kiosk*/
	LockPointOfSaleKiosk = 'LockPointOfSaleKiosk',
	/**
	 * @example Path*
/v1/admin/point-of-sale/:pointOfSaleUuid/unlock-kiosk*/
	UnlockPointOfSaleKiosk = 'UnlockPointOfSaleKiosk',
	/**
	 * @example Path*
/v1/admin/point-of-sale/:pointOfSaleUuid/door/unlock*/
	UnlockPointOfSaleDoor = 'UnlockPointOfSaleDoor',
	/**
	 * @example Path*
/v1/admin/gms-tracks*/
	GetGmsPlayTracks = 'GetGmsPlayTracks',
	/**
	 * @example Path*
/v1/admin/publishable-keys*/
	ListPublishableKeys = 'ListPublishableKeys',
	/**
	 * @example Path*
/v1/admin/publishable-keys*/
	CreatePublishableKey = 'CreatePublishableKey',
	/**
	 * @example Path*
/v1/admin/publishable-keys/:publishableKeyUuid*/
	GetPublishableKey = 'GetPublishableKey',
	/**
	 * @example Path*
/v1/admin/publishable-keys/:publishableKeyUuid*/
	UpdatePublishableKey = 'UpdatePublishableKey',
	/**
	 * @example Path*
/v1/admin/publishable-keys/:publishableKeyUuid*/
	DeletePublishableKey = 'DeletePublishableKey',
	/**
	 * @example Path*
/v1/admin/secret-keys*/
	CreateSecretKey = 'CreateSecretKey',
	/**
	 * @example Path*
/v1/admin/secret-keys/:secretKeyUuid*/
	UpdateSecretKey = 'UpdateSecretKey',
	/**
	 * @example Path*
/v1/admin/devices*/
	ListDevices = 'ListDevices',
	/**
	 * @example Path*
/v1/admin/devices*/
	CreateDevice = 'CreateDevice',
	/**
	 * @example Path*
/v1/admin/devices/current*/
	GetCurrentDevice = 'GetCurrentDevice',
	/**
	 * @example Path*
/v1/admin/devices/current/info*/
	GetDeviceInfo = 'GetDeviceInfo',
	/**
	 * @example Path*
/v1/admin/devices/current/device-status*/
	ReportDeviceStatus = 'ReportDeviceStatus',
	/**
	 * @example Path*
/v1/admin/devices/current/unenroll*/
	UnenrollCurrentDevice = 'UnenrollCurrentDevice',
	/**
	 * @example Path*
/v1/admin/devices/:deviceUuid*/
	GetDevice = 'GetDevice',
	/**
	 * @example Path*
/v1/admin/devices/:deviceUuid*/
	UpdateDevice = 'UpdateDevice',
	/**
	 * @example Path*
/v1/admin/devices/:deviceUuid*/
	DeleteDevice = 'DeleteDevice',
	/**
	 * @example Path*
/v1/admin/devices/:deviceUuid/link*/
	LinkDeviceToPointOfSale = 'LinkDeviceToPointOfSale',
	/**
	 * @example Path*
/v1/admin/devices/:deviceUuid/unlink*/
	UnlinkDeviceFromPointOfSale = 'UnlinkDeviceFromPointOfSale',
	/**
	 * @example Path*
/v1/admin/devices/:deviceUuid/secret-key*/
	CreateDeviceSecretKey = 'CreateDeviceSecretKey',
	/**
	 * @example Path*
/v1/admin/devices/:deviceUuid/device-status*/
	GetDeviceStatus = 'GetDeviceStatus',
	/**
	 * @example Path*
/v1/admin/devices/:deviceUuid/device-status/refresh*/
	RefreshDeviceStatus = 'RefreshDeviceStatus',
	/**
	 * @example Path*
/v1/admin/devices/:deviceUuid/device-enrollment/by-code/:code*/
	LookupDeviceEnrollmentByCodeForDevice = 'LookupDeviceEnrollmentByCodeForDevice',
	/**
	 * @example Path*
/v1/admin/devices/:deviceUuid/device-enrollment/enroll*/
	EnrollDevice = 'EnrollDevice',
	/**
	 * @example Path*
/v1/admin/devices/:deviceUuid/device-enrollment/unenroll*/
	UnenrollDevice = 'UnenrollDevice',
	/**
	 * @example Path*
/v1/admin/devices/:deviceUuid/gms*/
	DeleteDeviceGmsDevice = 'DeleteDeviceGmsDevice',
	/**
	 * @example Path*
/v1/admin/devices/:deviceUuid/gms/enroll*/
	CreateDeviceGmsEnrollment = 'CreateDeviceGmsEnrollment',
	/**
	 * @example Path*
/v1/admin/devices/:deviceUuid/gms/policy*/
	SyncDeviceGmsPolicy = 'SyncDeviceGmsPolicy',
	/**
	 * @example Path*
/v1/admin/devices/:deviceUuid/gms/reboot*/
	RebootDeviceGmsDevice = 'RebootDeviceGmsDevice',
	/**
	 * @example Path*
/v1/admin/products*/
	ListProducts = 'ListProducts',
	/**
	 * @example Path*
/v1/admin/products*/
	CreateProduct = 'CreateProduct',
	/**
	 * @example Path*
/v1/admin/products/point-of-sale/:pointOfSaleUuid*/
	ListProductGroupsForPointOfSale = 'ListProductGroupsForPointOfSale',
	/**
	 * @example Path*
/v1/admin/products/point-of-sale/:pointOfSaleUuid*/
	UpdateProductGroupsForPointOfSale = 'UpdateProductGroupsForPointOfSale',
	/**
	 * @example Path*
/v1/admin/products/point-of-sale/:pointOfSaleUuid/product-menu*/
	GetProductMenu = 'GetProductMenu',
	/**
	 * @example Path*
/v1/admin/products/sales-channel/:salesChannelUuid*/
	ListAvailableProductsForSalesChannel = 'ListAvailableProductsForSalesChannel',
	/**
	 * @example Path*
/v1/admin/products/barcode/:barcode*/
	GetProductFromBarcode = 'GetProductFromBarcode',
	/**
	 * @example Path*
/v1/admin/products/groups*/
	ListProductGroups = 'ListProductGroups',
	/**
	 * @example Path*
/v1/admin/products/groups*/
	CreateProductGroup = 'CreateProductGroup',
	/**
	 * @example Path*
/v1/admin/products/groups/:groupUuid*/
	GetProductGroup = 'GetProductGroup',
	/**
	 * @example Path*
/v1/admin/products/groups/:groupUuid*/
	DeleteProductGroup = 'DeleteProductGroup',
	/**
	 * @example Path*
/v1/admin/products/groups/:groupUuid*/
	UpdateProductGroup = 'UpdateProductGroup',
	/**
	 * @example Path*
/v1/admin/products/groups/:groupUuid/image*/
	SetProductGroupImage = 'SetProductGroupImage',
	/**
	 * @example Path*
/v1/admin/products/groups/:groupUuid/image*/
	DeleteProductGroupImage = 'DeleteProductGroupImage',
	/**
	 * @example Path*
/v1/admin/products/groups/:groupUuid/products*/
	AddProductsToProductGroup = 'AddProductsToProductGroup',
	/**
	 * @example Path*
/v1/admin/products/groups/:groupUuid/fees*/
	ListProductGroupFees = 'ListProductGroupFees',
	/**
	 * @example Path*
/v1/admin/products/groups/:groupUuid/fees*/
	CreateProductGroupFee = 'CreateProductGroupFee',
	/**
	 * @example Path*
/v1/admin/products/groups/:groupUuid/fees/:feeUuid*/
	GetProductGroupFee = 'GetProductGroupFee',
	/**
	 * @example Path*
/v1/admin/products/groups/:groupUuid/fees/:feeUuid*/
	DeleteProductGroupFee = 'DeleteProductGroupFee',
	/**
	 * @example Path*
/v1/admin/products/groups/:groupUuid/fees/:feeUuid*/
	UpdateProductGroupFee = 'UpdateProductGroupFee',
	/**
	 * @example Path*
/v1/admin/products/categories*/
	ListProductCategories = 'ListProductCategories',
	/**
	 * @example Path*
/v1/admin/products/categories*/
	CreateProductCategory = 'CreateProductCategory',
	/**
	 * @example Path*
/v1/admin/products/categories/hierarchy*/
	GetProductCategoryHierarchy = 'GetProductCategoryHierarchy',
	/**
	 * @example Path*
/v1/admin/products/categories/:categoryUuid*/
	GetProductCategory = 'GetProductCategory',
	/**
	 * @example Path*
/v1/admin/products/categories/:categoryUuid*/
	DeleteProductCategory = 'DeleteProductCategory',
	/**
	 * @example Path*
/v1/admin/products/categories/:categoryUuid*/
	UpdateProductCategory = 'UpdateProductCategory',
	/**
	 * @example Path*
/v1/admin/products/categories/:categoryUuid/image*/
	SetProductCategoryImage = 'SetProductCategoryImage',
	/**
	 * @example Path*
/v1/admin/products/categories/:categoryUuid/image*/
	DeleteProductCategoryImage = 'DeleteProductCategoryImage',
	/**
	 * @example Path*
/v1/admin/products/:productUuid*/
	GetProduct = 'GetProduct',
	/**
	 * @example Path*
/v1/admin/products/:productUuid*/
	DeleteProduct = 'DeleteProduct',
	/**
	 * @example Path*
/v1/admin/products/:productUuid*/
	UpdateProduct = 'UpdateProduct',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/edit*/
	GetProductEdit = 'GetProductEdit',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/barcodes*/
	ListProductBarcodes = 'ListProductBarcodes',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/barcodes*/
	CreateProductBarcode = 'CreateProductBarcode',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/barcodes/:barcode*/
	DeleteProductBarcode = 'DeleteProductBarcode',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/units-of-measure*/
	CreateProductUnitOfMeasure = 'CreateProductUnitOfMeasure',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/units-of-measure/base*/
	SetProductBaseUnit = 'SetProductBaseUnit',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/units-of-measure/:unitUuid*/
	UpdateProductUnitOfMeasure = 'UpdateProductUnitOfMeasure',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/units-of-measure/:unitUuid*/
	DeleteProductUnitOfMeasure = 'DeleteProductUnitOfMeasure',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/pricing*/
	GetProductPricing = 'GetProductPricing',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/pricing*/
	UpdateProductPricing = 'UpdateProductPricing',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/organization*/
	GetProductOrganization = 'GetProductOrganization',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/organization*/
	UpdateProductOrganization = 'UpdateProductOrganization',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/images*/
	ListProductImages = 'ListProductImages',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/images*/
	AttachProductImage = 'AttachProductImage',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/images/reorder*/
	ReorderProductImages = 'ReorderProductImages',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/images/:imageUuid*/
	DeleteProductImage = 'DeleteProductImage',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/images/:imageUuid/primary*/
	SetPrimaryProductImage = 'SetPrimaryProductImage',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/variants*/
	ListProductVariants = 'ListProductVariants',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/variants*/
	CreateProductVariant = 'CreateProductVariant',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/variants/:variantUuid*/
	GetProductVariant = 'GetProductVariant',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/variants/:variantUuid*/
	UpdateProductVariant = 'UpdateProductVariant',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/variants/:variantUuid/barcodes*/
	CreateVariantBarcode = 'CreateVariantBarcode',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/variants/:variantUuid/barcodes*/
	ListVariantBarcodes = 'ListVariantBarcodes',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/variants/:variantUuid/barcodes/:barcode*/
	DeleteVariantBarcode = 'DeleteVariantBarcode',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/variants/:variantUuid/pricing*/
	GetVariantPricing = 'GetVariantPricing',
	/**
	 * @example Path*
/v1/admin/products/:productUuid/variants/:variantUuid/pricing*/
	UpdateVariantPricing = 'UpdateVariantPricing',
	/**
	 * @example Path*
/v1/admin/products/units-of-measure-catalog*/
	ListUnitsOfMeasure = 'ListUnitsOfMeasure',
	/**
	 * @example Path*
/v1/admin/products/units-of-measure-catalog*/
	CreateUnitOfMeasure = 'CreateUnitOfMeasure',
	/**
	 * @example Path*
/v1/admin/products/units-of-measure-catalog/:unitUuid*/
	UpdateUnitOfMeasure = 'UpdateUnitOfMeasure',
	/**
	 * @example Path*
/v1/admin/products/units-of-measure-catalog/:unitUuid*/
	DeleteUnitOfMeasure = 'DeleteUnitOfMeasure',
	/**
	 * @example Path*
/v1/admin/products/export*/
	ExportProducts = 'ExportProducts',
	/**
	 * @example Path*
/v1/admin/products/import*/
	ImportProducts = 'ImportProducts',
	/**
	 * @example Path*
/v1/admin/products/import/validate*/
	ValidateProductImport = 'ValidateProductImport',
	/**
	 * @example Path*
/v1/admin/assets*/
	ListAssets = 'ListAssets',
	/**
	 * @example Path*
/v1/admin/assets/upload-init*/
	InitAssetUpload = 'InitAssetUpload',
	/**
	 * @example Path*
/v1/admin/assets/tags*/
	ListAssetTags = 'ListAssetTags',
	/**
	 * @example Path*
/v1/admin/assets/tags*/
	CreateAssetTag = 'CreateAssetTag',
	/**
	 * @example Path*
/v1/admin/assets/remove-tag*/
	RemoveTagFromAssets = 'RemoveTagFromAssets',
	/**
	 * @example Path*
/v1/admin/assets/rename-tag*/
	RenameAssetTag = 'RenameAssetTag',
	/**
	 * @example Path*
/v1/admin/assets/:assetUuid*/
	GetAsset = 'GetAsset',
	/**
	 * @example Path*
/v1/admin/assets/:assetUuid*/
	UpdateAsset = 'UpdateAsset',
	/**
	 * @example Path*
/v1/admin/assets/:assetUuid*/
	DeleteAsset = 'DeleteAsset',
	/**
	 * @example Path*
/v1/admin/assets/:assetUuid/upload-complete*/
	CompleteAssetUpload = 'CompleteAssetUpload',
	/**
	 * @example Path*
/v1/admin/marketing-channels*/
	ListMarketingChannels = 'ListMarketingChannels',
	/**
	 * @example Path*
/v1/admin/marketing-channels*/
	CreateMarketingChannel = 'CreateMarketingChannel',
	/**
	 * @example Path*
/v1/admin/marketing-channels/:marketingChannelUuid*/
	GetMarketingChannel = 'GetMarketingChannel',
	/**
	 * @example Path*
/v1/admin/marketing-channels/:marketingChannelUuid*/
	UpdateMarketingChannel = 'UpdateMarketingChannel',
	/**
	 * @example Path*
/v1/admin/marketing-channels/:marketingChannelUuid*/
	DeleteMarketingChannel = 'DeleteMarketingChannel',
	/**
	 * @example Path*
/v1/admin/marketing-channels/:marketingChannelUuid/layout*/
	GetFeedLayout = 'GetFeedLayout',
	/**
	 * @example Path*
/v1/admin/marketing-channels/:marketingChannelUuid/layout*/
	ReplaceFeedLayoutBlocks = 'ReplaceFeedLayoutBlocks',
	/**
	 * @example Path*
/v1/admin/marketing-channels/:marketingChannelUuid/content-layout*/
	GetChannelLayout = 'GetChannelLayout',
	/**
	 * @example Path*
/v1/admin/marketing-channels/:marketingChannelUuid/content-layout*/
	ReplaceChannelLayout = 'ReplaceChannelLayout',
	/**
	 * @example Path*
/v1/admin/marketing-channels/:marketingChannelUuid/resolved-content*/
	GetChannelResolvedContent = 'GetChannelResolvedContent',
	/**
	 * @example Path*
/v1/admin/marketing-content*/
	ListMarketingContent = 'ListMarketingContent',
	/**
	 * @example Path*
/v1/admin/marketing-content*/
	CreateMarketingContent = 'CreateMarketingContent',
	/**
	 * @example Path*
/v1/admin/marketing-content/:contentUuid*/
	GetMarketingContent = 'GetMarketingContent',
	/**
	 * @example Path*
/v1/admin/marketing-content/:contentUuid*/
	UpdateMarketingContent = 'UpdateMarketingContent',
	/**
	 * @example Path*
/v1/admin/marketing-content/:contentUuid*/
	DeleteMarketingContent = 'DeleteMarketingContent',
	/**
	 * @example Path*
/v1/admin/marketing-content/:contentUuid/blocks*/
	ReplaceMarketingContentBlocks = 'ReplaceMarketingContentBlocks',
	/**
	 * @example Path*
/v1/admin/marketing-content/:contentUuid/duplicate*/
	DuplicateMarketingContent = 'DuplicateMarketingContent',
	/**
	 * @example Path*
/v1/admin/orders*/
	ListOrders = 'ListOrders',
	/**
	 * @example Path*
/v1/admin/orders/:orderUuid*/
	GetOrder = 'GetOrder',
	/**
	 * @example Path*
/v1/admin/orders/:orderUuid/refund*/
	RefundOrder = 'RefundOrder',
	/**
	 * @example Path*
/v1/admin/orders/:orderUuid/cancel*/
	CancelOrder = 'CancelOrder',
	/**
	 * @example Path*
/v1/admin/orders/:orderUuid/exit-code*/
	GetExitCode = 'GetExitCode',
	/**
	 * @example Path*
/v1/admin/orders/:orderUuid/receipt*/
	GetOrderReceipt = 'GetOrderReceipt',
	/**
	 * @example Path*
/v1/admin/orders/:orderUuid/receipt/url*/
	GetOrderReceiptUrl = 'GetOrderReceiptUrl',
	/**
	 * @example Path*
/v1/admin/orders/:orderUuid/receipt/invalidate*/
	InvalidateOrderReceipt = 'InvalidateOrderReceipt',
	/**
	 * @example Path*
/v1/admin/orders/:orderUuid/receipt-link*/
	CreateOrderReceiptLink = 'CreateOrderReceiptLink',
	/**
	 * @example Path*
/v1/admin/orders/:orderUuid/fulfillment*/
	UpdateFulfillmentStatus = 'UpdateFulfillmentStatus',
	/**
	 * @example Path*
/v1/admin/orders/:orderUuid/:transactionUuid*/
	GetOrderTransaction = 'GetOrderTransaction',
	/**
	 * @example Path*
/v1/admin/orders/export*/
	ExportOrders = 'ExportOrders',
	/**
	 * @example Path*
/v1/admin/bag-check*/
	CreateBagCheck = 'CreateBagCheck',
	/**
	 * @example Path*
/v1/admin/bag-check/:checkUuid*/
	GetBagCheck = 'GetBagCheck',
	/**
	 * @example Path*
/v1/admin/bag-check/:checkUuid/items*/
	BagCheckAddItem = 'BagCheckAddItem',
	/**
	 * @example Path*
/v1/admin/bag-check/:checkUuid/items/:itemUuid*/
	BagCheckUpdateItemQuantity = 'BagCheckUpdateItemQuantity',
	/**
	 * @example Path*
/v1/admin/bag-check/:checkUuid/restart*/
	RestartBagCheck = 'RestartBagCheck',
	/**
	 * @example Path*
/v1/admin/bag-check/:checkUuid/approve*/
	BagCheckApprove = 'BagCheckApprove',
	/**
	 * @example Path*
/v1/admin/bag-check/:checkUuid/reject*/
	BagCheckReject = 'BagCheckReject',
	/**
	 * @example Path*
/v1/admin/promotions*/
	ListPromotions = 'ListPromotions',
	/**
	 * @example Path*
/v1/admin/promotions*/
	CreatePromotion = 'CreatePromotion',
	/**
	 * @example Path*
/v1/admin/promotions/:promotionUuid*/
	GetPromotion = 'GetPromotion',
	/**
	 * @example Path*
/v1/admin/promotions/:promotionUuid*/
	DeletePromotion = 'DeletePromotion',
	/**
	 * @example Path*
/v1/admin/promotions/:promotionUuid*/
	UpdatePromotion = 'UpdatePromotion',
	/**
	 * @example Path*
/v1/admin/promotion-groups*/
	ListPromotionGroups = 'ListPromotionGroups',
	/**
	 * @example Path*
/v1/admin/countries*/
	ListCountries = 'ListCountries',
	/**
	 * @example Path*
/v1/admin/countries/:countryCode*/
	GetCountry = 'GetCountry',
	/**
	 * @example Path*
/v1/admin/countries/:countryCode/tax-rates*/
	ListCountryTaxRates = 'ListCountryTaxRates',
	/**
	 * @example Path*
/v1/admin/tax-rates*/
	ListTaxRates = 'ListTaxRates',
	/**
	 * @example Path*
/v1/admin/export*/
	GetAvailableExports = 'GetAvailableExports',
	/**
	 * @example Path*
/v1/admin/export/pricer*/
	PricerProductExport = 'PricerProductExport',
	/**
	 * @example Path*
/v1/admin/export/visma*/
	VismaExport = 'VismaExport',
	/**
	 * @example Path*
/v1/admin/export/digi*/
	DigiScaleProductExport = 'DigiScaleProductExport',
	/**
	 * @example Path*
/v1/admin/export/saft*/
	GetSAFTExportInfo = 'GetSAFTExportInfo',
	/**
	 * @example Path*
/v1/admin/export/saft/cash-register*/
	SAFTExportCashRegister = 'SAFTExportCashRegister',
	/**
	 * @example Path*
/v1/admin/export/saft/financial*/
	SAFTExportFinancial = 'SAFTExportFinancial',
	/**
	 * @example Path*
/v1/admin/gift-cards*/
	ListGiftCards = 'ListGiftCards',
	/**
	 * @example Path*
/v1/admin/gift-cards*/
	CreateGiftCard = 'CreateGiftCard',
	/**
	 * @example Path*
/v1/admin/gift-cards/:giftCardUuid*/
	GetGiftCard = 'GetGiftCard',
	/**
	 * @example Path*
/v1/admin/gift-cards/:giftCardUuid*/
	UpdateGiftCard = 'UpdateGiftCard',
	/**
	 * @example Path*
/v1/admin/gift-cards/:giftCardUuid*/
	DeleteGiftCard = 'DeleteGiftCard',
	/**
	 * @example Path*
/v1/admin/companies*/
	ListCompanies = 'ListCompanies',
	/**
	 * @example Path*
/v1/admin/companies*/
	CreateCompany = 'CreateCompany',
	/**
	 * @example Path*
/v1/admin/companies/:companyUuid*/
	GetCompany = 'GetCompany',
	/**
	 * @example Path*
/v1/admin/companies/:companyUuid*/
	UpdateCompany = 'UpdateCompany',
	/**
	 * @example Path*
/v1/admin/companies/:companyUuid*/
	DeleteCompany = 'DeleteCompany',
	/**
	 * @example Path*
/v1/admin/companies/:companyUuid/business-cards*/
	CreateBusinessCard = 'CreateBusinessCard',
	/**
	 * @example Path*
/v1/admin/companies/:companyUuid/settlements*/
	ListCompanySettlements = 'ListCompanySettlements',
	/**
	 * @example Path*
/v1/admin/companies/:companyUuid/settlements*/
	CreateSettlement = 'CreateSettlement',
	/**
	 * @example Path*
/v1/admin/business-cards*/
	ListBusinessCards = 'ListBusinessCards',
	/**
	 * @example Path*
/v1/admin/business-cards/:cardUuid*/
	GetBusinessCard = 'GetBusinessCard',
	/**
	 * @example Path*
/v1/admin/business-cards/:cardUuid*/
	UpdateBusinessCard = 'UpdateBusinessCard',
	/**
	 * @example Path*
/v1/admin/business-cards/:cardUuid*/
	DeleteBusinessCard = 'DeleteBusinessCard',
	/**
	 * @example Path*
/v1/admin/business-cards/:cardUuid/reset-pin*/
	ResetBusinessCardPin = 'ResetBusinessCardPin',
	/**
	 * @example Path*
/v1/admin/business-cards/:cardUuid/verify-pin*/
	VerifyBusinessCardPin = 'VerifyBusinessCardPin',
	/**
	 * @example Path*
/v1/admin/business-cards/:cardUuid/transactions*/
	GetBusinessCardTransactions = 'GetBusinessCardTransactions',
	/**
	 * @example Path*
/v1/admin/settlements/:settlementUuid*/
	GetSettlement = 'GetSettlement',
	/**
	 * @example Path*
/v1/admin/settlements/:settlementUuid/mark-settled*/
	MarkSettlementSettled = 'MarkSettlementSettled',
	/**
	 * @example Path*
/v1/admin/analytics*/
	GetAnalytics = 'GetAnalytics',
	/**
	 * @example Path*
/v1/admin/analytics/basket*/
	GetBasketAnalysis = 'GetBasketAnalysis',
	/**
	 * @example Path*
/v1/admin/analytics/users*/
	GetUserAnalytics = 'GetUserAnalytics',
	/**
	 * @example Path*
/v1/admin/analytics/reports/revenue*/
	GetRevenueReport = 'GetRevenueReport',
	/**
	 * @example Path*
/v1/admin/analytics/reports/products*/
	GetProductReport = 'GetProductReport',
	/**
	 * @example Path*
/v1/admin/customers*/
	ListCustomers = 'ListCustomers',
	/**
	 * @example Path*
/v1/admin/customers*/
	CreateCustomer = 'CreateCustomer',
	/**
	 * @example Path*
/v1/admin/customers/:customerUuid*/
	GetCustomer = 'GetCustomer',
	/**
	 * @example Path*
/v1/admin/customers/:customerUuid*/
	UpdateCustomer = 'UpdateCustomer',
	/**
	 * @example Path*
/v1/admin/customers/:customerUuid*/
	RevokeCustomerTokens = 'RevokeCustomerTokens',
	/**
	 * @example Path*
/v1/admin/customers/:customerUuid/assume-token*/
	AssumeCustomerToken = 'AssumeCustomerToken',
	/**
	 * @example Path*
/v1/admin/customer-groups*/
	ListCustomerGroups = 'ListCustomerGroups',
	/**
	 * @example Path*
/v1/admin/customer-groups*/
	CreateCustomerGroup = 'CreateCustomerGroup',
	/**
	 * @example Path*
/v1/admin/customer-groups/:customerGroupUuid*/
	GetCustomerGroup = 'GetCustomerGroup',
	/**
	 * @example Path*
/v1/admin/customer-groups/:customerGroupUuid*/
	UpdateCustomerGroup = 'UpdateCustomerGroup',
	/**
	 * @example Path*
/v1/admin/customer-groups/:customerGroupUuid*/
	DeleteCustomerGroup = 'DeleteCustomerGroup',
	/**
	 * @example Path*
/v1/admin/loyalty-cards*/
	ListLoyaltyCards = 'ListLoyaltyCards',
	/**
	 * @example Path*
/v1/admin/loyalty-cards*/
	CreateLoyaltyCard = 'CreateLoyaltyCard',
	/**
	 * @example Path*
/v1/admin/loyalty-cards/:cardUuid*/
	GetLoyaltyCard = 'GetLoyaltyCard',
	/**
	 * @example Path*
/v1/admin/loyalty-cards/:cardUuid*/
	UpdateLoyaltyCard = 'UpdateLoyaltyCard',
	/**
	 * @example Path*
/v1/admin/loyalty-cards/:cardUuid*/
	DeleteLoyaltyCard = 'DeleteLoyaltyCard',
	/**
	 * @example Path*
/v1/admin/loyalty-cards/:cardUuid/redemptions*/
	GetLoyaltyCardRedemptions = 'GetLoyaltyCardRedemptions',
	/**
	 * @example Path*
/v1/admin/dashboard-features*/
	GetDashboardFeatures = 'GetDashboardFeatures',
	/**
	 * @example Path*
/v1/admin/developer-feedback*/
	SubmitDeveloperFeedback = 'SubmitDeveloperFeedback',
	/**
	 * @example Path*
/v1/admin/inventory-locations*/
	ListInventoryLocations = 'ListInventoryLocations',
	/**
	 * @example Path*
/v1/admin/inventory-locations*/
	CreateInventoryLocation = 'CreateInventoryLocation',
	/**
	 * @example Path*
/v1/admin/inventory-locations/search-variants*/
	SearchInventoryVariants = 'SearchInventoryVariants',
	/**
	 * @example Path*
/v1/admin/inventory-locations/:inventoryLocationUuid*/
	GetInventoryLocation = 'GetInventoryLocation',
	/**
	 * @example Path*
/v1/admin/inventory-locations/:inventoryLocationUuid*/
	UpdateInventoryLocation = 'UpdateInventoryLocation',
	/**
	 * @example Path*
/v1/admin/inventory-locations/:inventoryLocationUuid*/
	ProvisionInventoryLocationLevels = 'ProvisionInventoryLocationLevels',
	/**
	 * @example Path*
/v1/admin/inventory-settings*/
	GetInventorySettings = 'GetInventorySettings',
	/**
	 * @example Path*
/v1/admin/inventory-settings*/
	UpdateInventorySettings = 'UpdateInventorySettings',
	/**
	 * @example Path*
/v1/admin/inventory-levels*/
	ListInventoryLevels = 'ListInventoryLevels',
	/**
	 * @example Path*
/v1/admin/inventory-levels/summary*/
	GetInventorySummary = 'GetInventorySummary',
	/**
	 * @example Path*
/v1/admin/inventory-levels/:inventoryLevelUuid*/
	GetInventoryLevel = 'GetInventoryLevel',
	/**
	 * @example Path*
/v1/admin/inventory-levels/:inventoryLevelUuid*/
	UpdateInventoryLevel = 'UpdateInventoryLevel',
	/**
	 * @example Path*
/v1/admin/inventory-levels/:inventoryLevelUuid*/
	AdjustInventoryLevel = 'AdjustInventoryLevel',
	/**
	 * @example Path*
/v1/admin/stock-movements*/
	ListStockMovements = 'ListStockMovements',
	/**
	 * @example Path*
/v1/admin/suppliers*/
	ListSuppliers = 'ListSuppliers',
	/**
	 * @example Path*
/v1/admin/suppliers*/
	CreateSupplier = 'CreateSupplier',
	/**
	 * @example Path*
/v1/admin/suppliers/:supplierUuid*/
	GetSupplier = 'GetSupplier',
	/**
	 * @example Path*
/v1/admin/suppliers/:supplierUuid*/
	UpdateSupplier = 'UpdateSupplier',
	/**
	 * @example Path*
/v1/admin/purchase-orders*/
	ListPurchaseOrders = 'ListPurchaseOrders',
	/**
	 * @example Path*
/v1/admin/purchase-orders*/
	CreatePurchaseOrder = 'CreatePurchaseOrder',
	/**
	 * @example Path*
/v1/admin/purchase-orders/replenish*/
	CreateReplenishmentPurchaseOrders = 'CreateReplenishmentPurchaseOrders',
	/**
	 * @example Path*
/v1/admin/purchase-orders/:purchaseOrderUuid*/
	GetPurchaseOrder = 'GetPurchaseOrder',
	/**
	 * @example Path*
/v1/admin/purchase-orders/:purchaseOrderUuid*/
	ReceivePurchaseOrder = 'ReceivePurchaseOrder',
	/**
	 * @example Path*
/v1/admin/purchase-orders/:purchaseOrderUuid/mark-ordered*/
	MarkPurchaseOrderOrdered = 'MarkPurchaseOrderOrdered',
	/**
	 * @example Path*
/v1/admin/purchase-orders/:purchaseOrderUuid/cancel*/
	CancelPurchaseOrder = 'CancelPurchaseOrder',
	/**
	 * @example Path*
/v1/admin/inventory-transfers*/
	ListInventoryTransfers = 'ListInventoryTransfers',
	/**
	 * @example Path*
/v1/admin/inventory-transfers*/
	CreateInventoryTransfer = 'CreateInventoryTransfer',
	/**
	 * @example Path*
/v1/admin/inventory-transfers/:inventoryTransferUuid*/
	GetInventoryTransfer = 'GetInventoryTransfer',
	/**
	 * @example Path*
/v1/admin/inventory-transfers/:inventoryTransferUuid/ship*/
	ShipInventoryTransfer = 'ShipInventoryTransfer',
	/**
	 * @example Path*
/v1/admin/inventory-transfers/:inventoryTransferUuid/receive*/
	ReceiveInventoryTransfer = 'ReceiveInventoryTransfer',
	/**
	 * @example Path*
/v1/admin/inventory-transfers/:inventoryTransferUuid/cancel*/
	CancelInventoryTransfer = 'CancelInventoryTransfer',
	/**
	 * @example Path*
/v1/admin/inventory-reports*/
	GetInventoryReportSummary = 'GetInventoryReportSummary',
	/**
	 * @example Path*
/v1/admin/variant-suppliers*/
	ListVariantSuppliers = 'ListVariantSuppliers',
	/**
	 * @example Path*
/v1/admin/variant-suppliers*/
	UpsertVariantSupplier = 'UpsertVariantSupplier',
	/**
	 * @example Path*
/v1/admin/variant-suppliers/:variantSupplierUuid*/
	SetPreferredVariantSupplier = 'SetPreferredVariantSupplier',
	/**
	 * @example Path*
/v1/admin/variant-suppliers/:variantSupplierUuid*/
	DeleteVariantSupplier = 'DeleteVariantSupplier',
	/**
	 * @example Path*
/v1/admin/integrations*/
	ListIntegrations = 'ListIntegrations',
	/**
	 * @example Path*
/v1/admin/integrations/teya*/
	GetTeyaIntegration = 'GetTeyaIntegration',
	/**
	 * @example Path*
/v1/admin/integrations/teya/connect-url*/
	CreateTeyaConnectUrl = 'CreateTeyaConnectUrl',
	/**
	 * @example Path*
/v1/admin/integrations/teya/disconnect*/
	DisconnectTeya = 'DisconnectTeya',
	/**
	 * @example Path*
/v1/admin/integrations/teya/stores*/
	ListTeyaStores = 'ListTeyaStores',
	/**
	 * @example Path*
/v1/admin/integrations/teya/stores/:storeId/terminals*/
	ListTeyaTerminals = 'ListTeyaTerminals',
	/**
	 * @example Path*
/v1/admin/integrations/rapyd-cloudlink/register*/
	RegisterRapydDevice = 'RegisterRapydDevice',
	/**
	 * @example Path*
/v1/admin/integrations/rapyd-cloudlink/device-token/:serialNumber*/
	PollRapydDeviceToken = 'PollRapydDeviceToken',
	/**
	 * @example Path*
/v1/admin/integrations/:provider/config*/
	GetIntegrationConfig = 'GetIntegrationConfig',
	/**
	 * @example Path*
/v1/admin/integrations/:provider/config/global*/
	PutIntegrationGlobalConfig = 'PutIntegrationGlobalConfig',
	/**
	 * @example Path*
/v1/admin/integrations/:provider/overrides*/
	CreateIntegrationOverride = 'CreateIntegrationOverride',
	/**
	 * @example Path*
/v1/admin/integrations/:provider/overrides/:featureId*/
	UpdateIntegrationOverride = 'UpdateIntegrationOverride',
	/**
	 * @example Path*
/v1/admin/integrations/:provider/overrides/:featureId*/
	DeleteIntegrationOverride = 'DeleteIntegrationOverride',
	/**
	 * @example Path*
/v1/admin/billing/plan*/
	GetBillingPlan = 'GetBillingPlan',
	/**
	 * @example Path*
/v1/admin/billing/plan/accept*/
	AcceptBillingPlan = 'AcceptBillingPlan',
	/**
	 * @example Path*
/v1/admin/app-updates*/
	GetAppUpdateBranches = 'GetAppUpdateBranches',
	/**
	 * @example Path*
/v1/admin/app-updates/:branchName/updates*/
	GetAppUpdates = 'GetAppUpdates'
}

export const EndpointRequestValidators = {
	[Endpoint.GetApiKey]: {
		input: z.object({})
	},
	[Endpoint.Login]: {
		input: z.object({
			body: z.object({
				email: z.string().email(),
				password: z.string().min(1)
			})
		})
	},
	[Endpoint.Register]: {
		input: z.object({
			body: z.object({
				inviteToken: z.string().min(1),
				firstName: z.string().min(1),
				lastName: z.string().min(1),
				password: z.string().min(8).max(72)
			})
		})
	},
	[Endpoint.ResetPassword]: {
		input: z.object({
			body: z.object({
				email: z.string().email()
			})
		})
	},
	[Endpoint.UpdatePassword]: {
		input: z.object({
			body: z.object({
				token: z.string(),
				newPassword: z.string().min(8).max(72)
			})
		})
	},
	[Endpoint.ListUsers]: {
		input: z.object({})
	},
	[Endpoint.GetMe]: {
		input: z.object({})
	},
	[Endpoint.UpdateMe]: {
		input: z.object({
			body: z.object({
				firstName: z.string().optional(),
				lastName: z.string().optional(),
				locale: z.string().optional()
			})
		})
	},
	[Endpoint.ValidateMySignInPin]: {
		input: z.object({
			body: z.object({
				pin: z.string().min(1)
			})
		})
	},
	[Endpoint.SetMySignInPin]: {
		input: z.object({
			body: z.object({
				password: z.string().min(1),
				pin: z.string()
			})
		})
	},
	[Endpoint.GetUser]: {
		input: z.object({
			path: z.object({
				userUuid: z.string()
			})
		})
	},
	[Endpoint.UpdateUser]: {
		input: z.object({
			path: z.object({
				userUuid: z.string()
			}),
			body: z.object({
				firstName: z.string().optional(),
				lastName: z.string().optional(),
				role: AdminTypes.zUserRole.optional()
			})
		})
	},
	[Endpoint.DeleteUser]: {
		input: z.object({
			path: z.object({
				userUuid: z.string()
			})
		})
	},
	[Endpoint.GetUserSignInCredentials]: {
		input: z.object({
			path: z.object({
				userUuid: z.string()
			})
		})
	},
	[Endpoint.SetUserSignInCredentials]: {
		input: z.object({
			path: z.object({
				userUuid: z.string()
			}),
			body: z.object({
				signInId: z.string().optional().nullable(),
				pin: z.string().optional().nullable()
			})
		})
	},
	[Endpoint.ListInvites]: {
		input: z.object({})
	},
	[Endpoint.CreateInvite]: {
		input: z.object({
			body: z.object({
				email: z.string().email(),
				role: AdminTypes.zUserRole.optional()
			})
		})
	},
	[Endpoint.DeleteInvite]: {
		input: z.object({
			path: z.object({
				inviteUuid: z.string()
			})
		})
	},
	[Endpoint.ListSalesChannelTypes]: {
		input: z.object({})
	},
	[Endpoint.CreateSalesChannelType]: {
		input: z.object({
			body: z.object({
				name: z.string(),
				fulfillmentProvider: CommonTypes.zFulfillmentProvider.optional(),
				preauthorizationAmount: CommonTypes.zAmount.optional().nullable(),
				allowCompletingUnderpaidOrders: z.boolean().optional()
			})
		})
	},
	[Endpoint.GetSalesChannelType]: {
		input: z.object({
			path: z.object({
				salesChannelTypeUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdateSalesChannelType]: {
		input: z.object({
			path: z.object({
				salesChannelTypeUuid: z.string().min(1)
			}),
			body: z.object({
				name: z.string().optional(),
				fulfillmentProvider: CommonTypes.zFulfillmentProvider.optional(),
				preauthorizationAmount: CommonTypes.zAmount.optional().nullable(),
				allowCompletingUnderpaidOrders: z.boolean().optional()
			})
		})
	},
	[Endpoint.DeleteSalesChannelType]: {
		input: z.object({
			path: z.object({
				salesChannelTypeUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.ListSalesChannelGroups]: {
		input: z.object({})
	},
	[Endpoint.CreateSalesChannelGroup]: {
		input: z.object({
			body: z.object({
				name: z.string().min(1)
			})
		})
	},
	[Endpoint.GetSalesChannelGroup]: {
		input: z.object({
			path: z.object({
				salesChannelGroupUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdateSalesChannelGroup]: {
		input: z.object({
			path: z.object({
				salesChannelGroupUuid: z.string().min(1)
			}),
			body: z.object({
				name: z.string().min(1).optional(),
				memberUuids: z.array(z.string()).optional()
			})
		})
	},
	[Endpoint.DeleteSalesChannelGroup]: {
		input: z.object({
			path: z.object({
				salesChannelGroupUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.ListSalesChannels]: {
		input: z.object({})
	},
	[Endpoint.CreateSalesChannel]: {
		input: z.object({
			body: z.object({
				name: z.string(),
				currencyCode: z.string(),
				countryCode: AdminCountryTypes.zCountryCode,
				salesChannelTypeUuid: z.string().optional(),
				inventoryLocationUuid: z.string().optional(),
				salesChannelGroupUuid: z.string().optional()
			})
		})
	},
	[Endpoint.GetSalesChannel]: {
		input: z.object({
			path: z.object({
				salesChannelUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdateSalesChannel]: {
		input: z.object({
			path: z.object({
				salesChannelUuid: z.string().min(1)
			}),
			body: z.object({
				name: z.string().optional(),
				salesChannelTypeUuid: z.string().optional(),
				branchName: z.string().optional(),
				inventoryLocationUuid: z.string().optional(),
				storefrontUrl: z.string().optional(),
				salesChannelGroupUuid: z.string().optional()
			})
		})
	},
	[Endpoint.DeleteSalesChannel]: {
		input: z.object({
			path: z.object({
				salesChannelUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.ListPointOfSaleGroups]: {
		input: z.object({})
	},
	[Endpoint.CreatePointOfSaleGroup]: {
		input: z.object({
			body: z.object({
				name: z.string().min(1)
			})
		})
	},
	[Endpoint.GetPointOfSaleGroup]: {
		input: z.object({
			path: z.object({
				pointOfSaleGroupUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdatePointOfSaleGroup]: {
		input: z.object({
			path: z.object({
				pointOfSaleGroupUuid: z.string().min(1)
			}),
			body: z.object({
				name: z.string().min(1).optional(),
				memberUuids: z.array(z.string()).optional()
			})
		})
	},
	[Endpoint.DeletePointOfSaleGroup]: {
		input: z.object({
			path: z.object({
				pointOfSaleGroupUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.ListPointsOfSale]: {
		input: z.object({})
	},
	[Endpoint.CreatePointOfSale]: {
		input: z.object({
			body: z.object({
				name: z.string(),
				identifier: z.string(),
				salesChannelUuids: z.array(z.string()),
				productGroupRelations: z
					.array(
						z.object({
							productGroupUuid: z.string(),
							icon: z.string().optional()
						})
					)
					.optional(),
				allowedOperatingModes: z.array(AdminSalesChannelsTypes.zOperatingMode).optional(),
				pointOfSaleGroupUuid: z.string().optional()
			})
		})
	},
	[Endpoint.GetPointOfSaleHierarchy]: {
		input: z.object({})
	},
	[Endpoint.GetCurrentPointOfSale]: {
		input: z.object({})
	},
	[Endpoint.CreatePointOfSaleWebSocketTicket]: {
		input: z.object({
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.GetPointOfSale]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdatePointOfSale]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			}),
			body: z.object({
				name: z.string().optional(),
				identifier: z.string().optional(),
				salesChannelUuids: z.array(z.string()).optional(),
				productGroupRelations: z
					.array(
						z.object({
							productGroupUuid: z.string(),
							icon: z.string().optional()
						})
					)
					.optional(),
				allowedOperatingModes: z.array(AdminSalesChannelsTypes.zOperatingMode).optional(),
				logStreamLevel: AdminSalesChannelsTypes.zLogStreamLevel.optional(),
				logStreamId: z.string().optional().nullable(),
				forcedOrientation: AdminSalesChannelsTypes.zForcedOrientation.optional().nullable(),
				forcedFormFactor: AdminSalesChannelsTypes.zForcedFormFactor.optional().nullable(),
				inactivityThresholdSeconds: z.number().optional(),
				abandonCountdownSeconds: z.number().optional(),
				coolerReadyTimeoutSeconds: z.number().optional(),
				safeAreaInsets: AdminSalesChannelsTypes.zSafeAreaInsetOverrides.optional().nullable(),
				pointOfSaleGroupUuid: z.string().optional(),
				checkoutModeTheme: AdminSalesChannelsTypes.zCheckoutModeTheme.optional().nullable(),
				checkoutModeIdleTimeoutSeconds: z.number().optional().nullable()
			})
		})
	},
	[Endpoint.OpenCooler]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.OpenCashFloat]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			}),
			body: z.object({
				amount: CommonTypes.zAmount,
				employeeId: z.string().optional()
			})
		})
	},
	[Endpoint.CashPayIn]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			}),
			body: z.object({
				amount: CommonTypes.zAmount,
				reason: z.string().optional(),
				employeeId: z.string().optional()
			})
		})
	},
	[Endpoint.CashPayOut]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			}),
			body: z.object({
				amount: CommonTypes.zAmount,
				reason: z.string().optional(),
				employeeId: z.string().optional()
			})
		})
	},
	[Endpoint.CashCount]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			}),
			body: z.object({
				countedAmount: CommonTypes.zAmount
			})
		})
	},
	[Endpoint.GetPointOfSaleDeviceStatus]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.RefreshPointOfSaleDeviceStatus]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.LookupDeviceEnrollmentByCode]: {
		input: z.object({
			path: z
				.object({
					pointOfSaleUuid: z.string().min(1)
				})
				.and(
					z.object({
						code: z.string().min(1)
					})
				)
		})
	},
	[Endpoint.EnrollPointOfSaleDevice]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			}),
			body: z.object({
				code: z.string()
			})
		})
	},
	[Endpoint.UnenrollPointOfSaleDevice]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.NotifyPointOfSaleAppUpdate]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			}),
			body: z.object({
				channel: z.string().optional()
			})
		})
	},
	[Endpoint.RestartPointOfSaleApp]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.LockPointOfSaleKiosk]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.UnlockPointOfSaleKiosk]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.UnlockPointOfSaleDoor]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			}),
			body: z.object({
				durationMs: z.number().optional(),
				reason: z.string().optional()
			})
		})
	},
	[Endpoint.GetGmsPlayTracks]: {
		input: z.object({})
	},
	[Endpoint.ListPublishableKeys]: {
		input: z.object({
			query: z.object({
				salesChannelUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				pointOfSaleUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				])
			})
		})
	},
	[Endpoint.CreatePublishableKey]: {
		input: z.object({
			body: z.object({
				name: z.string(),
				salesChannelUuids: z.array(z.string()).optional(),
				pointOfSaleUuid: z.string().optional(),
				marketingChannelUuid: z.string().optional()
			})
		})
	},
	[Endpoint.GetPublishableKey]: {
		input: z.object({
			path: z.object({
				publishableKeyUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdatePublishableKey]: {
		input: z.object({
			path: z.object({
				publishableKeyUuid: z.string().min(1)
			}),
			body: z.object({
				name: z.string().optional(),
				salesChannelUuids: z.array(z.string()).optional(),
				pointOfSaleUuid: z.string().optional(),
				marketingChannelUuid: z.string().optional().nullable()
			})
		})
	},
	[Endpoint.DeletePublishableKey]: {
		input: z.object({
			path: z.object({
				publishableKeyUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.CreateSecretKey]: {
		input: z.object({
			body: z.object({
				name: z.string(),
				salesChannelUuids: z.array(z.string()).optional(),
				pointOfSaleUuid: z.string().optional(),
				admin: z.boolean().optional(),
				developmentMode: z.boolean().optional()
			})
		})
	},
	[Endpoint.UpdateSecretKey]: {
		input: z.object({
			path: z.object({
				secretKeyUuid: z.string().min(1)
			}),
			body: z.object({
				developmentMode: z.boolean()
			})
		})
	},
	[Endpoint.ListDevices]: {
		input: z.object({})
	},
	[Endpoint.CreateDevice]: {
		input: z.object({
			body: z.object({
				name: z.string(),
				identifier: z.string().optional(),
				allowedOperatingModes: z.array(AdminSalesChannelsTypes.zOperatingMode).optional(),
				pointOfSaleUuid: z.string().optional(),
				marketingChannelUuid: z.string().optional()
			})
		})
	},
	[Endpoint.GetCurrentDevice]: {
		input: z.object({})
	},
	[Endpoint.GetDeviceInfo]: {
		input: z.object({})
	},
	[Endpoint.ReportDeviceStatus]: {
		input: z.object({
			body: AdminSalesChannelsTypes.zPointOfSaleDeviceStatusReport
		})
	},
	[Endpoint.UnenrollCurrentDevice]: {
		input: z.object({
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.GetDevice]: {
		input: z.object({
			path: z.object({
				deviceUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdateDevice]: {
		input: z.object({
			path: z.object({
				deviceUuid: z.string().min(1)
			}),
			body: z.object({
				name: z.string().optional(),
				identifier: z.string().optional(),
				allowedOperatingModes: z.array(AdminSalesChannelsTypes.zOperatingMode).optional(),
				marketingChannelUuid: z.string().optional().nullable(),
				defaultPaymentMethod: z.string().optional().nullable(),
				forcedOrientation: AdminSalesChannelsTypes.zForcedOrientation.optional().nullable(),
				language: z.string().optional().nullable(),
				showPrinterDisconnected: z.boolean().optional().nullable(),
				productListColumns: z.number().optional().nullable(),
				browseEnabled: AdminSalesChannelsTypes.zPosMutationPermission.optional().nullable(),
				adjustQuantity: AdminSalesChannelsTypes.zPosMutationPermission.optional().nullable(),
				clearCart: AdminSalesChannelsTypes.zPosMutationPermission.optional().nullable(),
				itemDeletion: AdminSalesChannelsTypes.zPosMutationPermission.optional().nullable(),
				orderRestart: AdminSalesChannelsTypes.zPosMutationPermission.optional().nullable(),
				splitPercentHorizontal: z.number().optional().nullable(),
				splitPercentVertical: z.number().optional().nullable(),
				itemAddedSound: z.string().optional().nullable(),
				productNotFoundSound: z.string().optional().nullable(),
				addToCartFailedSound: z.string().optional().nullable(),
				paymentSuccessSound: z.string().optional().nullable(),
				paymentFailedSound: z.string().optional().nullable(),
				logStreamLevel: AdminSalesChannelsTypes.zLogStreamLevel.optional().nullable(),
				logStreamId: z.string().optional().nullable(),
				forcedFormFactor: AdminSalesChannelsTypes.zForcedFormFactor.optional().nullable(),
				inactivityThresholdSeconds: z.number().optional().nullable(),
				abandonCountdownSeconds: z.number().optional().nullable(),
				coolerReadyTimeoutSeconds: z.number().optional().nullable(),
				safeAreaInsets: AdminSalesChannelsTypes.zSafeAreaInsetOverrides.optional().nullable(),
				checkoutModeTheme: AdminSalesChannelsTypes.zCheckoutModeTheme.optional().nullable(),
				checkoutModeIdleTimeoutSeconds: z.number().optional().nullable()
			})
		})
	},
	[Endpoint.DeleteDevice]: {
		input: z.object({
			path: z.object({
				deviceUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.LinkDeviceToPointOfSale]: {
		input: z.object({
			path: z.object({
				deviceUuid: z.string().min(1)
			}),
			body: z.object({
				pointOfSaleUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UnlinkDeviceFromPointOfSale]: {
		input: z.object({
			path: z.object({
				deviceUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.CreateDeviceSecretKey]: {
		input: z.object({
			path: z.object({
				deviceUuid: z.string().min(1)
			}),
			body: z.object({
				name: z.string(),
				developmentMode: z.boolean().optional()
			})
		})
	},
	[Endpoint.GetDeviceStatus]: {
		input: z.object({
			path: z.object({
				deviceUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.RefreshDeviceStatus]: {
		input: z.object({
			path: z.object({
				deviceUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.LookupDeviceEnrollmentByCodeForDevice]: {
		input: z.object({
			path: z
				.object({
					deviceUuid: z.string().min(1)
				})
				.and(
					z.object({
						code: z.string().min(1)
					})
				)
		})
	},
	[Endpoint.EnrollDevice]: {
		input: z.object({
			path: z.object({
				deviceUuid: z.string().min(1)
			}),
			body: z.object({
				code: z.string()
			})
		})
	},
	[Endpoint.UnenrollDevice]: {
		input: z.object({
			path: z.object({
				deviceUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.DeleteDeviceGmsDevice]: {
		input: z.object({
			path: z.object({
				deviceUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.CreateDeviceGmsEnrollment]: {
		input: z.object({
			path: z.object({
				deviceUuid: z.string().min(1)
			}),
			body: z.object({
				wifiSsid: z.string().optional(),
				wifiPassword: z.string().optional(),
				policyPresets: z.array(AdminSalesChannelsTypes.zGmsPolicyPreset).optional()
			})
		})
	},
	[Endpoint.SyncDeviceGmsPolicy]: {
		input: z.object({
			path: z.object({
				deviceUuid: z.string().min(1)
			}),
			body: z.object({
				minimumVersionCode: z.number().optional().nullable(),
				policyPresets: z.array(AdminSalesChannelsTypes.zGmsPolicyPreset).optional(),
				wifiNetworks: z.array(AdminSalesChannelsTypes.zGmsWifiNetworkInput).optional(),
				trackId: z.string().optional().nullable(),
				policyOverrides: z.any().nullable().optional()
			})
		})
	},
	[Endpoint.RebootDeviceGmsDevice]: {
		input: z.object({
			path: z.object({
				deviceUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.ListProducts]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortBy: z.enum(['title', 'status']).optional(),
				sortOrder: z.enum(['desc', 'asc']).optional().default('asc'),
				groupUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				categoryUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				salesChannels: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				status: z.union([
					z.array(AdminProductsTypes.zProductStatus),
					z
						.string()
						.transform(str => str.split(',').map(id => AdminProductsTypes.zProductStatus.parse(id.trim())))
						.optional()
				]),
				pricingMethod: z.union([
					z.array(CommonTypes.zPricingMethod),
					z
						.string()
						.transform(str => str.split(',').map(id => CommonTypes.zPricingMethod.parse(id.trim())))
						.optional()
				])
			})
		})
	},
	[Endpoint.CreateProduct]: {
		input: z.object({
			body: z.object({
				title: z.string().min(1),
				subtitle: z.string().optional(),
				description: z.string().optional(),
				status: AdminProductsTypes.zProductStatus,
				salesChannelUuids: z.array(z.string()).optional(),
				barcodes: z.array(z.string()).optional(),
				sku: z.string().optional(),
				pricingMethod: CommonTypes.zPricingMethod.optional()
			})
		})
	},
	[Endpoint.ListProductGroupsForPointOfSale]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			}),
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortOrder: z.enum(['desc', 'asc']).optional().default('asc')
			})
		})
	},
	[Endpoint.UpdateProductGroupsForPointOfSale]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			}),
			body: z.object({
				groups: z.array(
					z.object({
						productGroupUuid: z.string(),
						icon: z.string().optional(),
						isDefault: z.boolean().optional()
					})
				)
			})
		})
	},
	[Endpoint.GetProductMenu]: {
		input: z.object({
			path: z.object({
				pointOfSaleUuid: z.string().min(1)
			}),
			query: z.object({
				q: z.string().optional(),
				salesChannelUuid: z.string().optional()
			})
		})
	},
	[Endpoint.ListAvailableProductsForSalesChannel]: {
		input: z.object({
			path: z.object({
				salesChannelUuid: z.string().min(1)
			}),
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortOrder: z.enum(['desc', 'asc']).optional().default('asc'),
				groupUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				categoryUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				])
			})
		})
	},
	[Endpoint.GetProductFromBarcode]: {
		input: z.object({
			path: z.object({
				barcode: z.string().min(1)
			})
		})
	},
	[Endpoint.ListProductGroups]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortBy: z.enum(['name', 'productCount']).optional(),
				sortOrder: z.enum(['desc', 'asc']).optional().default('asc')
			})
		})
	},
	[Endpoint.CreateProductGroup]: {
		input: z.object({
			body: z.object({
				name: z.string().min(1)
			})
		})
	},
	[Endpoint.GetProductGroup]: {
		input: z.object({
			path: z.object({
				groupUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.DeleteProductGroup]: {
		input: z.object({
			path: z.object({
				groupUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdateProductGroup]: {
		input: z.object({
			path: z.object({
				groupUuid: z.string().min(1)
			}),
			body: z.object({
				name: z.string()
			})
		})
	},
	[Endpoint.SetProductGroupImage]: {
		input: z.object({
			path: z.object({
				groupUuid: z.string().min(1)
			}),
			body: z.object({
				assetUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.DeleteProductGroupImage]: {
		input: z.object({
			path: z.object({
				groupUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.AddProductsToProductGroup]: {
		input: z.object({
			path: z.object({
				groupUuid: z.string().min(1)
			}),
			body: z.object({
				productUuids: z.array(z.string().min(1))
			})
		})
	},
	[Endpoint.ListProductGroupFees]: {
		input: z.object({
			path: z.object({
				groupUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.CreateProductGroupFee]: {
		input: z.object({
			path: z.object({
				groupUuid: z.string().min(1)
			}),
			body: z.object({
				name: z.string(),
				prices: z.array(AdminProductsTypes.zPriceInput)
			})
		})
	},
	[Endpoint.GetProductGroupFee]: {
		input: z.object({
			path: z
				.object({
					groupUuid: z.string().min(1)
				})
				.and(
					z.object({
						feeUuid: z.string().min(1)
					})
				)
		})
	},
	[Endpoint.DeleteProductGroupFee]: {
		input: z.object({
			path: z
				.object({
					groupUuid: z.string().min(1)
				})
				.and(
					z.object({
						feeUuid: z.string().min(1)
					})
				)
		})
	},
	[Endpoint.UpdateProductGroupFee]: {
		input: z.object({
			path: z
				.object({
					groupUuid: z.string().min(1)
				})
				.and(
					z.object({
						feeUuid: z.string().min(1)
					})
				),
			body: z.object({
				name: z.string(),
				prices: z.array(AdminProductsTypes.zPriceInput)
			})
		})
	},
	[Endpoint.ListProductCategories]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0)
			})
		})
	},
	[Endpoint.CreateProductCategory]: {
		input: z.object({
			body: z.object({
				name: z.string().min(1),
				parentCategoryUuid: z.string().optional()
			})
		})
	},
	[Endpoint.GetProductCategoryHierarchy]: {
		input: z.object({})
	},
	[Endpoint.GetProductCategory]: {
		input: z.object({
			path: z.object({
				categoryUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.DeleteProductCategory]: {
		input: z.object({
			path: z.object({
				categoryUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdateProductCategory]: {
		input: z.object({
			path: z.object({
				categoryUuid: z.string().min(1)
			}),
			body: z.object({
				name: z.string(),
				parentCategoryUuid: z.string().optional()
			})
		})
	},
	[Endpoint.SetProductCategoryImage]: {
		input: z.object({
			path: z.object({
				categoryUuid: z.string().min(1)
			}),
			body: z.object({
				assetUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.DeleteProductCategoryImage]: {
		input: z.object({
			path: z.object({
				categoryUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.GetProduct]: {
		input: z.object({
			path: z.object({
				productUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.DeleteProduct]: {
		input: z.object({
			path: z.object({
				productUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdateProduct]: {
		input: z.object({
			path: z.object({
				productUuid: z.string().min(1)
			}),
			body: z.object({
				title: z.string().min(1).optional(),
				subtitle: z.string().optional(),
				description: z.string().optional(),
				status: AdminProductsTypes.zProductStatus.optional(),
				barcodes: z.array(z.string()).optional(),
				sku: z.string().optional(),
				pricingMethod: CommonTypes.zPricingMethod.optional()
			})
		})
	},
	[Endpoint.GetProductEdit]: {
		input: z.object({
			path: z.object({
				productUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.ListProductBarcodes]: {
		input: z.object({
			path: z.object({
				productUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.CreateProductBarcode]: {
		input: z.object({
			path: z.object({
				productUuid: z.string().min(1)
			}),
			body: z.object({
				barcode: z.string(),
				unitOfMeasureUuid: z.string().optional()
			})
		})
	},
	[Endpoint.DeleteProductBarcode]: {
		input: z.object({
			path: z
				.object({
					productUuid: z.string().min(1)
				})
				.and(
					z.object({
						barcode: z.string().min(1)
					})
				)
		})
	},
	[Endpoint.CreateProductUnitOfMeasure]: {
		input: z.object({
			path: z.object({
				productUuid: z.string().min(1)
			}),
			body: AdminProductsTypes.zUnitOfMeasureInput
		})
	},
	[Endpoint.SetProductBaseUnit]: {
		input: z.object({
			path: z.object({
				productUuid: z.string().min(1)
			}),
			body: z.object({
				unitOfMeasureUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdateProductUnitOfMeasure]: {
		input: z.object({
			path: z
				.object({
					productUuid: z.string().min(1)
				})
				.and(
					z.object({
						unitUuid: z.string().min(1)
					})
				),
			body: AdminProductsTypes.zUnitOfMeasureInput
		})
	},
	[Endpoint.DeleteProductUnitOfMeasure]: {
		input: z.object({
			path: z
				.object({
					productUuid: z.string().min(1)
				})
				.and(
					z.object({
						unitUuid: z.string().min(1)
					})
				)
		})
	},
	[Endpoint.GetProductPricing]: {
		input: z.object({
			path: z.object({
				productUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdateProductPricing]: {
		input: z.object({
			path: z.object({
				productUuid: z.string().min(1)
			}),
			body: z.array(AdminProductsTypes.zPriceInput)
		})
	},
	[Endpoint.GetProductOrganization]: {
		input: z.object({
			path: z.object({
				productUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdateProductOrganization]: {
		input: z.object({
			path: z.object({
				productUuid: z.string().min(1)
			}),
			body: z.object({
				groups: z.array(z.string()),
				categories: z.array(z.string())
			})
		})
	},
	[Endpoint.ListProductImages]: {
		input: z.object({
			path: z.object({
				productUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.AttachProductImage]: {
		input: z.object({
			path: z.object({
				productUuid: z.string().min(1)
			}),
			body: z.object({
				assetUuid: z.string().min(1),
				variantUuid: z.string().optional(),
				position: z.number().optional(),
				isPrimary: z.boolean().optional()
			})
		})
	},
	[Endpoint.ReorderProductImages]: {
		input: z.object({
			path: z.object({
				productUuid: z.string().min(1)
			}),
			body: z.array(
				z.object({
					uuid: z.string().min(1),
					position: z.number()
				})
			)
		})
	},
	[Endpoint.DeleteProductImage]: {
		input: z.object({
			path: z
				.object({
					productUuid: z.string().min(1)
				})
				.and(
					z.object({
						imageUuid: z.string().min(1)
					})
				)
		})
	},
	[Endpoint.SetPrimaryProductImage]: {
		input: z.object({
			path: z
				.object({
					productUuid: z.string().min(1)
				})
				.and(
					z.object({
						imageUuid: z.string().min(1)
					})
				),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.ListProductVariants]: {
		input: z.object({
			path: z.object({
				productUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.CreateProductVariant]: {
		input: z.object({
			path: z.object({
				productUuid: z.string().min(1)
			}),
			body: AdminProductsTypes.zProductVariant
		})
	},
	[Endpoint.GetProductVariant]: {
		input: z.object({
			path: z
				.object({
					productUuid: z.string().min(1)
				})
				.and(
					z.object({
						variantUuid: z.string().min(1)
					})
				)
		})
	},
	[Endpoint.UpdateProductVariant]: {
		input: z.object({
			path: z
				.object({
					productUuid: z.string().min(1)
				})
				.and(
					z.object({
						variantUuid: z.string().min(1)
					})
				),
			body: z.object({
				trackInventory: z.boolean().optional()
			})
		})
	},
	[Endpoint.CreateVariantBarcode]: {
		input: z.object({
			path: z
				.object({
					productUuid: z.string().min(1)
				})
				.and(
					z.object({
						variantUuid: z.string().min(1)
					})
				),
			body: z.object({
				barcode: z.string()
			})
		})
	},
	[Endpoint.ListVariantBarcodes]: {
		input: z.object({
			path: z
				.object({
					productUuid: z.string().min(1)
				})
				.and(
					z.object({
						variantUuid: z.string().min(1)
					})
				)
		})
	},
	[Endpoint.DeleteVariantBarcode]: {
		input: z.object({
			path: z
				.object({
					productUuid: z.string().min(1)
				})
				.and(
					z.object({
						variantUuid: z.string().min(1)
					})
				)
				.and(
					z.object({
						barcode: z.string().min(1)
					})
				)
		})
	},
	[Endpoint.GetVariantPricing]: {
		input: z.object({
			path: z
				.object({
					productUuid: z.string().min(1)
				})
				.and(
					z.object({
						variantUuid: z.string().min(1)
					})
				)
		})
	},
	[Endpoint.UpdateVariantPricing]: {
		input: z.object({
			path: z
				.object({
					productUuid: z.string().min(1)
				})
				.and(
					z.object({
						variantUuid: z.string().min(1)
					})
				),
			body: z.array(AdminProductsTypes.zPriceInput)
		})
	},
	[Endpoint.ListUnitsOfMeasure]: {
		input: z.object({})
	},
	[Endpoint.CreateUnitOfMeasure]: {
		input: z.object({
			body: AdminProductsTypes.zCatalogUnitOfMeasureInput
		})
	},
	[Endpoint.UpdateUnitOfMeasure]: {
		input: z.object({
			path: z.object({
				unitUuid: z.string().min(1)
			}),
			body: AdminProductsTypes.zCatalogUnitOfMeasureInput
		})
	},
	[Endpoint.DeleteUnitOfMeasure]: {
		input: z.object({
			path: z.object({
				unitUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.ExportProducts]: {
		input: z.object({
			body: z.object({
				format: z.any(),
				schema: z.any(),
				salesChannelUuid: z.string()
			})
		})
	},
	[Endpoint.ImportProducts]: {
		input: z.object({
			query: z.object({
				conflictMode: AdminProductsTypes.zImportConflictMode.optional()
			}),
			body: z.any()
		})
	},
	[Endpoint.ValidateProductImport]: {
		input: z.object({
			query: z.object({
				conflictMode: AdminProductsTypes.zImportConflictMode.optional()
			}),
			body: z.any()
		})
	},
	[Endpoint.ListAssets]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				category: z.union([
					z.array(CommonTypes.zAssetCategory),
					z
						.string()
						.transform(str => str.split(',').map(id => CommonTypes.zAssetCategory.parse(id.trim())))
						.optional()
				]),
				status: z.union([
					z.array(CommonTypes.zAssetStatus),
					z
						.string()
						.transform(str => str.split(',').map(id => CommonTypes.zAssetStatus.parse(id.trim())))
						.optional()
				]),
				tags: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				usage: CommonTypes.zAssetUsageFilter.optional(),
				channelUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				contentUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				])
			})
		})
	},
	[Endpoint.InitAssetUpload]: {
		input: z.object({
			body: z.object({
				filename: z.string().min(1),
				contentType: z.string().min(1),
				size: z.number().min(1),
				category: CommonTypes.zAssetCategory,
				tags: z.array(z.string()).optional()
			})
		})
	},
	[Endpoint.ListAssetTags]: {
		input: z.object({
			query: z.object({
				category: CommonTypes.zAssetCategory
			})
		})
	},
	[Endpoint.CreateAssetTag]: {
		input: z.object({
			body: z.object({
				name: z.string().min(1),
				category: CommonTypes.zAssetCategory
			})
		})
	},
	[Endpoint.RemoveTagFromAssets]: {
		input: z.object({
			body: z.object({
				tag: z.string().min(1),
				category: CommonTypes.zAssetCategory
			})
		})
	},
	[Endpoint.RenameAssetTag]: {
		input: z.object({
			body: z.object({
				fromName: z.string().min(1),
				toName: z.string().min(1),
				category: CommonTypes.zAssetCategory
			})
		})
	},
	[Endpoint.GetAsset]: {
		input: z.object({
			path: z.object({
				assetUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdateAsset]: {
		input: z.object({
			path: z.object({
				assetUuid: z.string().min(1)
			}),
			body: z.object({
				tags: z.array(z.string())
			})
		})
	},
	[Endpoint.DeleteAsset]: {
		input: z.object({
			path: z.object({
				assetUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.CompleteAssetUpload]: {
		input: z.object({
			path: z.object({
				assetUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.ListMarketingChannels]: {
		input: z.object({})
	},
	[Endpoint.CreateMarketingChannel]: {
		input: z.object({
			body: z.object({
				name: z.string().min(1),
				description: z.string().optional(),
				surfaces: z.array(AdminMarketingContentTypes.zMarketingSurface).optional(),
				publishableKeyUuids: z.array(z.string()).optional()
			})
		})
	},
	[Endpoint.GetMarketingChannel]: {
		input: z.object({
			path: z.object({
				marketingChannelUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdateMarketingChannel]: {
		input: z.object({
			path: z.object({
				marketingChannelUuid: z.string().min(1)
			}),
			body: z.object({
				name: z.string().min(1).optional(),
				description: z.string().optional().nullable(),
				surfaces: z.array(AdminMarketingContentTypes.zMarketingSurface).optional(),
				publishableKeyUuids: z.array(z.string()).optional()
			})
		})
	},
	[Endpoint.DeleteMarketingChannel]: {
		input: z.object({
			path: z.object({
				marketingChannelUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.GetFeedLayout]: {
		input: z.object({
			path: z.object({
				marketingChannelUuid: z.string().min(1)
			}),
			query: z.object({
				surface: AdminMarketingContentTypes.zMarketingSurface.optional()
			})
		})
	},
	[Endpoint.ReplaceFeedLayoutBlocks]: {
		input: z.object({
			path: z.object({
				marketingChannelUuid: z.string().min(1)
			}),
			query: z.object({
				surface: AdminMarketingContentTypes.zMarketingSurface.optional()
			}),
			body: z.object({
				blocks: z
					.array(
						z.object({
							kind: AdminMarketingContentTypes.zContentBlockKind,
							type: z.enum(['BANNER', 'LIST', 'MODAL', 'SEPARATOR']).optional(),
							data: z.any().optional()
						})
					)
					.max(100)
			})
		})
	},
	[Endpoint.GetChannelLayout]: {
		input: z.object({
			path: z.object({
				marketingChannelUuid: z.string().min(1)
			}),
			query: z.object({
				surface: AdminMarketingContentTypes.zMarketingSurface.optional(),
				screenState: AdminMarketingContentTypes.zMarketingScreenState.optional()
			})
		})
	},
	[Endpoint.ReplaceChannelLayout]: {
		input: z.object({
			path: z.object({
				marketingChannelUuid: z.string().min(1)
			}),
			query: z.object({
				surface: AdminMarketingContentTypes.zMarketingSurface.optional(),
				screenState: AdminMarketingContentTypes.zMarketingScreenState.optional()
			}),
			body: z.object({
				contentUuids: z.array(z.string()).max(100)
			})
		})
	},
	[Endpoint.GetChannelResolvedContent]: {
		input: z.object({
			path: z.object({
				marketingChannelUuid: z.string().min(1)
			}),
			query: z.object({
				surface: AdminMarketingContentTypes.zMarketingSurface.optional(),
				screenState: AdminMarketingContentTypes.zMarketingScreenState.optional()
			})
		})
	},
	[Endpoint.ListMarketingContent]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				status: z.union([
					z.array(AdminMarketingContentTypes.zMarketingContentStatus),
					z
						.string()
						.transform(str =>
							str
								.split(',')
								.map(id => AdminMarketingContentTypes.zMarketingContentStatus.parse(id.trim()))
						)
						.optional()
				]),
				windowStatus: z.union([
					z.array(z.enum(['ACTIVE', 'SCHEDULED', 'ENDED', 'DRAFT'])),
					z
						.string()
						.transform(str =>
							str.split(',').map(id => z.enum(['ACTIVE', 'SCHEDULED', 'ENDED', 'DRAFT']).parse(id.trim()))
						)
						.optional()
				]),
				formats: z.union([
					z.array(AdminMarketingContentTypes.zMarketingContentFormat),
					z
						.string()
						.transform(str =>
							str
								.split(',')
								.map(id => AdminMarketingContentTypes.zMarketingContentFormat.parse(id.trim()))
						)
						.optional()
				]),
				channels: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				])
			})
		})
	},
	[Endpoint.CreateMarketingContent]: {
		input: z.object({
			body: z.object({
				name: z.string().min(1),
				description: z.string().optional(),
				format: AdminMarketingContentTypes.zMarketingContentFormat.optional(),
				status: AdminMarketingContentTypes.zMarketingContentStatus.optional(),
				startsAt: z.number().optional(),
				endsAt: z.number().optional(),
				blocks: z
					.array(
						z.object({
							type: z.enum(['BANNER', 'LIST', 'MODAL', 'SEPARATOR']),
							data: z.any()
						})
					)
					.max(100)
					.optional()
			})
		})
	},
	[Endpoint.GetMarketingContent]: {
		input: z.object({
			path: z.object({
				contentUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdateMarketingContent]: {
		input: z.object({
			path: z.object({
				contentUuid: z.string().min(1)
			}),
			body: z.object({
				name: z.string().min(1).optional(),
				description: z.string().optional().nullable(),
				status: AdminMarketingContentTypes.zMarketingContentStatus.optional(),
				startsAt: z.number().optional().nullable(),
				endsAt: z.number().optional().nullable()
			})
		})
	},
	[Endpoint.DeleteMarketingContent]: {
		input: z.object({
			path: z.object({
				contentUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.ReplaceMarketingContentBlocks]: {
		input: z.object({
			path: z.object({
				contentUuid: z.string().min(1)
			}),
			body: z.object({
				blocks: z
					.array(
						z.object({
							type: z.enum(['BANNER', 'LIST', 'MODAL', 'SEPARATOR']),
							data: z.any()
						})
					)
					.max(100)
			})
		})
	},
	[Endpoint.DuplicateMarketingContent]: {
		input: z.object({
			path: z.object({
				contentUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.ListOrders]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortBy: z.enum(['date', 'displayId', 'total']).optional(),
				sortOrder: z.enum(['desc', 'asc']).optional().default('desc'),
				salesChannelUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				pointOfSaleUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				fulfillmentStatuses: z.union([
					z.array(AdminOrdersTypes.zOrderFulfillmentStatus),
					z
						.string()
						.transform(str =>
							str.split(',').map(id => AdminOrdersTypes.zOrderFulfillmentStatus.parse(id.trim()))
						)
						.optional()
				]),
				paymentStatus: z.union([
					z.array(CommonTypes.zOrderPaymentStatus),
					z
						.string()
						.transform(str => str.split(',').map(id => CommonTypes.zOrderPaymentStatus.parse(id.trim())))
						.optional()
				]),
				minAmount: z.coerce.number().optional(),
				maxAmount: z.coerce.number().optional(),
				fromDate: z.coerce.number().optional(),
				toDate: z.coerce.number().optional(),
				customerUuid: z.string().optional(),
				customerCardUuid: z.string().optional()
			})
		})
	},
	[Endpoint.GetOrder]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.RefundOrder]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			}),
			body: z.discriminatedUnion('type', [
				z.object({
					type: z.enum(['ITEM_BASED']),
					items: z.array(
						z.object({
							orderItemUuid: z.string(),
							quantity: z.number(),
							restock: z.boolean().optional()
						})
					),
					additionalAmount: CommonTypes.zAmount.optional().nullable(),
					note: z.string().optional()
				}),
				z.object({
					type: z.enum(['AMOUNT_ONLY']),
					amount: CommonTypes.zAmount,
					note: z.string().optional()
				})
			])
		})
	},
	[Endpoint.CancelOrder]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.GetExitCode]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.GetOrderReceipt]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.GetOrderReceiptUrl]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.InvalidateOrderReceipt]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.CreateOrderReceiptLink]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.UpdateFulfillmentStatus]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			}),
			body: z.object({
				status: CommonTypes.zFulfillmentStatus
			})
		})
	},
	[Endpoint.GetOrderTransaction]: {
		input: z.object({
			path: z
				.object({
					orderUuid: z.string().min(1)
				})
				.and(
					z.object({
						transactionUuid: z.string().min(1)
					})
				)
		})
	},
	[Endpoint.ExportOrders]: {
		input: z.object({
			body: z.object({
				format: z.enum(['CSV', 'JSON']),
				startDate: z.number().optional(),
				endDate: z.number().optional()
			})
		})
	},
	[Endpoint.CreateBagCheck]: {
		input: z.object({
			body: z.object({
				orderUuid: z.string()
			})
		})
	},
	[Endpoint.GetBagCheck]: {
		input: z.object({
			path: z.object({
				checkUuid: z.string()
			})
		})
	},
	[Endpoint.BagCheckAddItem]: {
		input: z.object({
			path: z.object({
				checkUuid: z.string()
			}),
			body: z.object({
				barcode: z.string()
			})
		})
	},
	[Endpoint.BagCheckUpdateItemQuantity]: {
		input: z.object({
			path: z
				.object({
					checkUuid: z.string()
				})
				.and(
					z.object({
						itemUuid: z.string()
					})
				),
			body: z.object({
				quantityChange: z.number().optional(),
				removeFromCart: z.boolean().optional()
			})
		})
	},
	[Endpoint.RestartBagCheck]: {
		input: z.object({
			path: z.object({
				checkUuid: z.string()
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.BagCheckApprove]: {
		input: z.object({
			path: z.object({
				checkUuid: z.string()
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.BagCheckReject]: {
		input: z.object({
			path: z.object({
				checkUuid: z.string()
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.ListPromotions]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.string().optional(),
				offset: z.string().optional(),
				sortBy: z.enum(['name', 'enabled', 'rank', 'startDate', 'endDate']).optional(),
				sortOrder: z.enum(['asc', 'desc']).optional(),
				salesChannels: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				promotionGroups: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				status: z.union([
					z.array(AdminPromotionsTypes.zPromotionScheduleStatus),
					z
						.string()
						.transform(str =>
							str.split(',').map(id => AdminPromotionsTypes.zPromotionScheduleStatus.parse(id.trim()))
						)
						.optional()
				])
			})
		})
	},
	[Endpoint.CreatePromotion]: {
		input: z.object({
			body: z.object({
				name: z.string().min(1),
				displayTitle: z.string().optional(),
				salesChannels: z.array(z.string()),
				salesChannelGroups: z.array(z.string()).optional(),
				startDate: z.number().optional(),
				endDate: z.number().optional(),
				discountDefinition: AdminPromotionsTypes.zDiscountDefinition.optional().nullable(),
				applicationRule: AdminPromotionsTypes.zApplicationRule.optional().nullable(),
				shouldOverridePrice: z.boolean().optional(),
				applyToAllProducts: z.boolean().optional(),
				productGroupUuids: z.array(z.string()).optional(),
				productUuids: z.array(z.string()).optional(),
				productCategoryUuids: z.array(z.string()).optional(),
				customerUuids: z.array(z.string()).optional(),
				customerGroupUuids: z.array(z.string()).optional(),
				daysOfWeek: z.array(AdminPromotionsTypes.zPromotionDayOfWeek).optional(),
				prices: z.array(AdminProductsTypes.zPriceInput).optional(),
				includeFees: z.boolean().optional(),
				enabled: z.boolean().optional(),
				rank: z.number().int().min(0).optional(),
				appliesToAllUnits: z.boolean().optional(),
				unitOfMeasureUuid: z.string().optional()
			})
		})
	},
	[Endpoint.GetPromotion]: {
		input: z.object({
			path: z.object({
				promotionUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.DeletePromotion]: {
		input: z.object({
			path: z.object({
				promotionUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdatePromotion]: {
		input: z.object({
			path: z.object({
				promotionUuid: z.string().min(1)
			}),
			body: z.object({
				name: z.string().min(1).optional(),
				displayTitle: z.string().optional(),
				startDate: z.number().optional(),
				endDate: z.number().optional(),
				discountDefinition: AdminPromotionsTypes.zDiscountDefinition.optional().nullable(),
				applicationRule: AdminPromotionsTypes.zApplicationRule.optional().nullable(),
				shouldOverridePrice: z.boolean().optional(),
				salesChannels: z.array(z.string()).optional(),
				salesChannelGroups: z.array(z.string()).optional(),
				applyToAllProducts: z.boolean().optional(),
				productGroupUuids: z.array(z.string()).optional(),
				productUuids: z.array(z.string()).optional(),
				productCategoryUuids: z.array(z.string()).optional(),
				customerUuids: z.array(z.string()).optional(),
				customerGroupUuids: z.array(z.string()).optional(),
				daysOfWeek: z.array(AdminPromotionsTypes.zPromotionDayOfWeek).optional(),
				prices: z.array(AdminProductsTypes.zPriceInput).optional(),
				includeFees: z.boolean().optional(),
				enabled: z.boolean().optional(),
				rank: z.number().int().min(0).optional(),
				appliesToAllUnits: z.boolean().optional(),
				unitOfMeasureUuid: z.string().optional()
			})
		})
	},
	[Endpoint.ListPromotionGroups]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				uuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				sortBy: z.enum(['name']).optional(),
				sortOrder: z.enum(['desc', 'asc']).optional().default('asc')
			})
		})
	},
	[Endpoint.ListCountries]: {
		input: z.object({})
	},
	[Endpoint.GetCountry]: {
		input: z.object({
			path: z.object({
				countryCode: AdminCountryTypes.zCountryCode
			})
		})
	},
	[Endpoint.ListCountryTaxRates]: {
		input: z.object({
			path: z.object({
				countryCode: AdminCountryTypes.zCountryCode
			})
		})
	},
	[Endpoint.ListTaxRates]: {
		input: z.object({})
	},
	[Endpoint.GetAvailableExports]: {
		input: z.object({})
	},
	[Endpoint.PricerProductExport]: {
		input: z.object({
			body: z.object({
				salesChannelUuid: z.string()
			})
		})
	},
	[Endpoint.VismaExport]: {
		input: z.object({
			body: z.object({
				startDate: z.number(),
				endDate: z.number().optional()
			})
		})
	},
	[Endpoint.DigiScaleProductExport]: {
		input: z.object({
			body: z.object({
				salesChannelUuids: z.array(z.string()),
				groupUuids: z.array(z.string())
			})
		})
	},
	[Endpoint.GetSAFTExportInfo]: {
		input: z.object({})
	},
	[Endpoint.SAFTExportCashRegister]: {
		input: z.object({
			body: z.object({
				year: z.number(),
				month: z.number()
			})
		})
	},
	[Endpoint.SAFTExportFinancial]: {
		input: z.object({
			body: z.object({
				startDate: z.number(),
				endDate: z.number().optional()
			})
		})
	},
	[Endpoint.ListGiftCards]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortOrder: z.enum(['desc', 'asc']).optional().default('desc'),
				sortBy: z.enum(['name', 'code', 'status']).optional(),
				code: z.string().optional(),
				status: AdminGiftCardTypes.zGiftCardStatus.optional(),
				currencyCode: z.string().optional()
			})
		})
	},
	[Endpoint.CreateGiftCard]: {
		input: z.object({
			body: z.object({
				name: z.string(),
				amount: CommonTypes.zAmount,
				currencyCode: z.string()
			})
		})
	},
	[Endpoint.GetGiftCard]: {
		input: z.object({
			path: z.object({
				giftCardUuid: z.string()
			})
		})
	},
	[Endpoint.UpdateGiftCard]: {
		input: z.object({
			path: z.object({
				giftCardUuid: z.string()
			}),
			body: z.object({
				name: z.string().optional()
			})
		})
	},
	[Endpoint.DeleteGiftCard]: {
		input: z.object({
			path: z.object({
				giftCardUuid: z.string()
			})
		})
	},
	[Endpoint.ListCompanies]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortOrder: z.enum(['desc', 'asc']).optional().default('desc'),
				sortBy: z.enum(['name', 'email', 'phone', 'externalId', 'settlementCount']).optional(),
				name: z.string().optional(),
				externalId: z.string().optional()
			})
		})
	},
	[Endpoint.CreateCompany]: {
		input: z.object({
			body: z.object({
				name: z.string(),
				email: z.string().optional(),
				phone: z.string().optional(),
				orgNumber: z.string().optional(),
				externalId: z.string().optional()
			})
		})
	},
	[Endpoint.GetCompany]: {
		input: z.object({
			path: z.object({
				companyUuid: z.string()
			})
		})
	},
	[Endpoint.UpdateCompany]: {
		input: z.object({
			path: z.object({
				companyUuid: z.string()
			}),
			body: z.object({
				name: z.string().optional(),
				email: z.string().optional().nullable(),
				phone: z.string().optional().nullable(),
				orgNumber: z.string().optional().nullable(),
				externalId: z.string().optional()
			})
		})
	},
	[Endpoint.DeleteCompany]: {
		input: z.object({
			path: z.object({
				companyUuid: z.string()
			})
		})
	},
	[Endpoint.CreateBusinessCard]: {
		input: z.object({
			path: z.object({
				companyUuid: z.string()
			}),
			body: z.object({
				name: z.string(),
				cardNumber: z.string(),
				externalId: z.string().optional(),
				customerUuid: z.string().optional()
			})
		})
	},
	[Endpoint.ListCompanySettlements]: {
		input: z.object({
			path: z.object({
				companyUuid: z.string()
			}),
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortOrder: z.enum(['desc', 'asc']).optional().default('desc')
			})
		})
	},
	[Endpoint.CreateSettlement]: {
		input: z.object({
			path: z.object({
				companyUuid: z.string()
			}),
			body: z.object({
				periodStart: z.number(),
				periodEnd: z.number()
			})
		})
	},
	[Endpoint.ListBusinessCards]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortOrder: z.enum(['desc', 'asc']).optional().default('desc'),
				sortBy: z.enum(['name', 'cardNumber', 'status', 'externalId']).optional(),
				name: z.string().optional(),
				cardNumber: z.string().optional(),
				status: AdminCompaniesTypes.zBusinessCardStatus.optional(),
				externalId: z.string().optional(),
				companyUuid: z.string().optional(),
				customerUuid: z.string().optional(),
				assignedToCustomer: z.enum(['true', 'false']).optional()
			})
		})
	},
	[Endpoint.GetBusinessCard]: {
		input: z.object({
			path: z.object({
				cardUuid: z.string()
			})
		})
	},
	[Endpoint.UpdateBusinessCard]: {
		input: z.object({
			path: z.object({
				cardUuid: z.string()
			}),
			body: z.object({
				name: z.string().optional(),
				status: AdminCompaniesTypes.zBusinessCardStatus.optional(),
				externalId: z.string().optional(),
				companyUuid: z.string().optional().nullable(),
				customerUuid: z.string().optional().nullable()
			})
		})
	},
	[Endpoint.DeleteBusinessCard]: {
		input: z.object({
			path: z.object({
				cardUuid: z.string()
			})
		})
	},
	[Endpoint.ResetBusinessCardPin]: {
		input: z.object({
			path: z.object({
				cardUuid: z.string()
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.VerifyBusinessCardPin]: {
		input: z.object({
			path: z.object({
				cardUuid: z.string()
			}),
			body: z.object({
				pin: z.string()
			})
		})
	},
	[Endpoint.GetBusinessCardTransactions]: {
		input: z.object({
			path: z.object({
				cardUuid: z.string()
			}),
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortOrder: z.enum(['desc', 'asc']).optional().default('desc')
			})
		})
	},
	[Endpoint.GetSettlement]: {
		input: z.object({
			path: z.object({
				settlementUuid: z.string()
			})
		})
	},
	[Endpoint.MarkSettlementSettled]: {
		input: z.object({
			path: z.object({
				settlementUuid: z.string()
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.GetAnalytics]: {
		input: z.object({
			query: z.object({
				interval: AdminAnalyticsTypes.zAnalyticsInterval,
				periodStart: z.string().optional(),
				comparePeriod: z.string().optional(),
				salesChannelUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				salesChannelGroupUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				compareSalesChannelUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				])
			})
		})
	},
	[Endpoint.GetBasketAnalysis]: {
		input: z.object({
			query: z.object({
				interval: AdminAnalyticsTypes.zAnalyticsInterval,
				periodStart: z.string().optional(),
				productUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				categoryUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				excludeProductUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				excludeCategoryUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				salesChannelUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				pointOfSaleUuid: z.string().optional(),
				minSupport: z.coerce.number().int().min(1).optional(),
				productSortBy: AdminAnalyticsTypes.zBasketPairSortField.optional(),
				productSortOrder: AdminAnalyticsTypes.zBasketSortOrder.optional(),
				categorySortBy: AdminAnalyticsTypes.zBasketPairSortField.optional(),
				categorySortOrder: AdminAnalyticsTypes.zBasketSortOrder.optional()
			})
		})
	},
	[Endpoint.GetUserAnalytics]: {
		input: z.object({
			query: z.object({
				interval: AdminAnalyticsTypes.zAnalyticsInterval,
				periodStart: z.string().optional(),
				comparePeriod: z.string().optional()
			})
		})
	},
	[Endpoint.GetRevenueReport]: {
		input: z.object({
			query: z.object({
				interval: AdminAnalyticsTypes.zAnalyticsInterval,
				periodStart: z.string().optional(),
				comparePeriod: z.string().optional(),
				salesChannelUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				compareSalesChannelUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				groupBy: AdminAnalyticsTypes.zRevenueReportGroupBy.optional()
			})
		})
	},
	[Endpoint.GetProductReport]: {
		input: z.object({
			query: z.object({
				interval: AdminAnalyticsTypes.zAnalyticsInterval,
				periodStart: z.string().optional(),
				comparePeriod: z.string().optional(),
				salesChannelUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				compareSalesChannelUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				productUuids: z.union([
					z.array(z.string()),
					z
						.string()
						.transform(str => str.split(',').map(id => z.string().parse(id.trim())))
						.optional()
				]),
				sortBy: AdminAnalyticsTypes.zProductReportSortField.optional(),
				sortOrder: AdminAnalyticsTypes.zBasketSortOrder.optional(),
				limit: z.coerce.number().int().min(1).max(500).optional(),
				offset: z.coerce.number().int().min(0).optional()
			})
		})
	},
	[Endpoint.ListCustomers]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortBy: z.enum(['name', 'createdAt', 'email']).optional(),
				sortOrder: z.enum(['desc', 'asc']).optional().default('desc'),
				firstName: z.string().optional(),
				lastName: z.string().optional(),
				email: z.string().optional(),
				phone: z.string().optional(),
				ssn: z.string().optional(),
				externalId: z.string().optional()
			})
		})
	},
	[Endpoint.CreateCustomer]: {
		input: z.object({
			body: AdminCustomersTypes.zCustomerParams
		})
	},
	[Endpoint.GetCustomer]: {
		input: z.object({
			path: z.object({
				customerUuid: z.string()
			})
		})
	},
	[Endpoint.UpdateCustomer]: {
		input: z.object({
			path: z.object({
				customerUuid: z.string()
			}),
			body: AdminCustomersTypes.zCustomerParams
		})
	},
	[Endpoint.RevokeCustomerTokens]: {
		input: z.object({
			path: z.object({
				customerUuid: z.string()
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.AssumeCustomerToken]: {
		input: z.object({
			path: z.object({
				customerUuid: z.string()
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.ListCustomerGroups]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortBy: z.enum(['name', 'createdAt']).optional(),
				sortOrder: z.enum(['desc', 'asc']).optional().default('asc')
			})
		})
	},
	[Endpoint.CreateCustomerGroup]: {
		input: z.object({
			body: z.object({
				name: z.string().min(1),
				description: z.string().optional(),
				externalId: z.string().optional(),
				customerUuids: z.array(z.string()).optional()
			})
		})
	},
	[Endpoint.GetCustomerGroup]: {
		input: z.object({
			path: z.object({
				customerGroupUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.UpdateCustomerGroup]: {
		input: z.object({
			path: z.object({
				customerGroupUuid: z.string().min(1)
			}),
			body: z.object({
				name: z.string().min(1).optional(),
				description: z.string().optional(),
				externalId: z.string().optional(),
				customerUuids: z.array(z.string()).optional()
			})
		})
	},
	[Endpoint.DeleteCustomerGroup]: {
		input: z.object({
			path: z.object({
				customerGroupUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.ListLoyaltyCards]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortOrder: z.enum(['desc', 'asc']).optional().default('desc'),
				sortBy: z.enum(['name', 'cardNumber', 'status']).optional(),
				name: z.string().optional(),
				cardNumber: z.string().optional(),
				status: AdminLoyaltyCardTypes.zLoyaltyCardStatus.optional(),
				customerUuid: z.string().optional(),
				externalSource: z.string().optional()
			})
		})
	},
	[Endpoint.CreateLoyaltyCard]: {
		input: z.object({
			body: z.object({
				name: z.string(),
				cardNumber: z.string(),
				customerUuid: z.string().optional(),
				initialPoints: z.number().optional(),
				externalId: z.string().optional()
			})
		})
	},
	[Endpoint.GetLoyaltyCard]: {
		input: z.object({
			path: z.object({
				cardUuid: z.string()
			})
		})
	},
	[Endpoint.UpdateLoyaltyCard]: {
		input: z.object({
			path: z.object({
				cardUuid: z.string()
			}),
			body: z.object({
				name: z.string().optional(),
				status: AdminLoyaltyCardTypes.zLoyaltyCardStatus.optional(),
				customerUuid: z.string().optional().nullable(),
				availablePoints: z.number().optional(),
				totalPoints: z.number().optional()
			})
		})
	},
	[Endpoint.DeleteLoyaltyCard]: {
		input: z.object({
			path: z.object({
				cardUuid: z.string()
			})
		})
	},
	[Endpoint.GetLoyaltyCardRedemptions]: {
		input: z.object({
			path: z.object({
				cardUuid: z.string()
			}),
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortOrder: z.enum(['desc', 'asc']).optional().default('desc')
			})
		})
	},
	[Endpoint.GetDashboardFeatures]: {
		input: z.object({})
	},
	[Endpoint.SubmitDeveloperFeedback]: {
		input: z.object({
			body: z.object({
				title: z.string().min(1).max(255),
				body: z.string().max(20000).optional(),
				type: z.enum(['small-fix', 'bug', 'enhancement', 'note']),
				app: z.enum(['dashboard', 'storefront', 'customer-app', 'merchant-app']),
				appVersion: z.string().max(100).optional(),
				route: z.string().max(500).optional(),
				deviceInfo: z.string().max(2000).optional()
			})
		})
	},
	[Endpoint.ListInventoryLocations]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0)
			})
		})
	},
	[Endpoint.CreateInventoryLocation]: {
		input: z.object({
			body: z.object({
				name: z.string()
			})
		})
	},
	[Endpoint.SearchInventoryVariants]: {
		input: z.object({
			query: z.object({
				q: z.string(),
				inventoryLocationUuid: z.string().optional(),
				limit: z.coerce.number().optional()
			})
		})
	},
	[Endpoint.GetInventoryLocation]: {
		input: z.object({
			path: z.object({
				inventoryLocationUuid: z.string()
			})
		})
	},
	[Endpoint.UpdateInventoryLocation]: {
		input: z.object({
			path: z.object({
				inventoryLocationUuid: z.string()
			}),
			body: z.object({
				name: z.string(),
				salesChannelUuids: z.array(z.string()).optional()
			})
		})
	},
	[Endpoint.ProvisionInventoryLocationLevels]: {
		input: z.object({
			path: z.object({
				inventoryLocationUuid: z.string()
			}),
			body: z.object({
				batchSize: z.number().optional(),
				dryRun: z.boolean().optional()
			})
		})
	},
	[Endpoint.GetInventorySettings]: {
		input: z.object({})
	},
	[Endpoint.UpdateInventorySettings]: {
		input: z.object({
			body: z.object({
				enabled: z.boolean().optional(),
				deductOnOrderComplete: z.boolean().optional(),
				blockOversell: z.boolean().optional(),
				restockOnReturn: z.boolean().optional(),
				hideOutOfStock: z.boolean().optional()
			})
		})
	},
	[Endpoint.ListInventoryLevels]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortBy: z.enum(['quantityOnHand', 'reorderPoint']).optional(),
				sortOrder: z.enum(['asc', 'desc']).optional(),
				inventoryLocationUuid: z.string().optional(),
				lowStockOnly: z.coerce.boolean().optional(),
				stockStatus: AdminInventoryTypes.zInventoryStockStatus.optional()
			})
		})
	},
	[Endpoint.GetInventorySummary]: {
		input: z.object({
			query: z.object({
				inventoryLocationUuid: z.string().optional()
			})
		})
	},
	[Endpoint.GetInventoryLevel]: {
		input: z.object({
			path: z.object({
				inventoryLevelUuid: z.string()
			})
		})
	},
	[Endpoint.UpdateInventoryLevel]: {
		input: z.object({
			path: z.object({
				inventoryLevelUuid: z.string()
			}),
			body: z.object({
				reorderPoint: z.number().optional(),
				reorderQuantity: z.number().optional()
			})
		})
	},
	[Endpoint.AdjustInventoryLevel]: {
		input: z.object({
			path: z.object({
				inventoryLevelUuid: z.string()
			}),
			body: z.object({
				quantityDelta: z.number(),
				reason: z.string().optional()
			})
		})
	},
	[Endpoint.ListStockMovements]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortBy: z.enum(['createdAt', 'type', 'quantityDelta', 'quantityAfter', 'reason']).optional(),
				sortOrder: z.enum(['asc', 'desc']).optional(),
				inventoryLocationUuid: z.string().optional(),
				variantUuid: z.string().optional(),
				type: AdminInventoryTypes.zStockMovementType.optional(),
				fromDate: z.coerce.number().optional(),
				toDate: z.coerce.number().optional()
			})
		})
	},
	[Endpoint.ListSuppliers]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortBy: z.enum(['name', 'currencyCode', 'email', 'externalId']).optional(),
				sortOrder: z.enum(['asc', 'desc']).optional()
			})
		})
	},
	[Endpoint.CreateSupplier]: {
		input: z.object({
			body: z.object({
				name: z.string(),
				currencyCode: z.string().optional(),
				email: z.string().optional(),
				phone: z.string().optional(),
				externalId: z.string().optional()
			})
		})
	},
	[Endpoint.GetSupplier]: {
		input: z.object({
			path: z.object({
				supplierUuid: z.string()
			})
		})
	},
	[Endpoint.UpdateSupplier]: {
		input: z.object({
			path: z.object({
				supplierUuid: z.string()
			}),
			body: z.object({
				name: z.string().optional(),
				currencyCode: z.string().optional(),
				email: z.string().optional(),
				phone: z.string().optional(),
				externalId: z.string().optional()
			})
		})
	},
	[Endpoint.ListPurchaseOrders]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortBy: z.enum(['referenceNumber', 'supplierName', 'lineCount', 'status']).optional(),
				sortOrder: z.enum(['asc', 'desc']).optional(),
				inventoryLocationUuid: z.string().optional(),
				status: AdminInventoryTypes.zPurchaseOrderStatus.optional()
			})
		})
	},
	[Endpoint.CreatePurchaseOrder]: {
		input: z.object({
			body: z.object({
				inventoryLocationUuid: z.string(),
				supplierUuid: z.string().optional(),
				currencyCode: z.string().optional(),
				referenceNumber: z.string().optional(),
				expectedAt: z.number().optional(),
				notes: z.string().optional(),
				lines: z.array(
					z.object({
						variantUuid: z.string(),
						orderedQuantity: z.number(),
						unitCost: CommonTypes.zAmount.optional().nullable()
					})
				)
			})
		})
	},
	[Endpoint.CreateReplenishmentPurchaseOrders]: {
		input: z.object({
			body: z.object({
				inventoryLocationUuid: z.string()
			})
		})
	},
	[Endpoint.GetPurchaseOrder]: {
		input: z.object({
			path: z.object({
				purchaseOrderUuid: z.string()
			})
		})
	},
	[Endpoint.ReceivePurchaseOrder]: {
		input: z.object({
			path: z.object({
				purchaseOrderUuid: z.string()
			}),
			body: z.object({
				lines: z.array(
					z.object({
						lineUuid: z.string(),
						receivedQuantity: z.number()
					})
				),
				notes: z.string().optional()
			})
		})
	},
	[Endpoint.MarkPurchaseOrderOrdered]: {
		input: z.object({
			path: z.object({
				purchaseOrderUuid: z.string()
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.CancelPurchaseOrder]: {
		input: z.object({
			path: z.object({
				purchaseOrderUuid: z.string()
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.ListInventoryTransfers]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				sortBy: z.enum(['lineCount', 'status']).optional(),
				sortOrder: z.enum(['asc', 'desc']).optional(),
				status: AdminInventoryTypes.zInventoryTransferStatus.optional()
			})
		})
	},
	[Endpoint.CreateInventoryTransfer]: {
		input: z.object({
			body: z.object({
				fromInventoryLocationUuid: z.string(),
				toInventoryLocationUuid: z.string(),
				notes: z.string().optional(),
				lines: z.array(
					z.object({
						variantUuid: z.string(),
						quantity: z.number()
					})
				)
			})
		})
	},
	[Endpoint.GetInventoryTransfer]: {
		input: z.object({
			path: z.object({
				inventoryTransferUuid: z.string()
			})
		})
	},
	[Endpoint.ShipInventoryTransfer]: {
		input: z.object({
			path: z.object({
				inventoryTransferUuid: z.string()
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.ReceiveInventoryTransfer]: {
		input: z.object({
			path: z.object({
				inventoryTransferUuid: z.string()
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.CancelInventoryTransfer]: {
		input: z.object({
			path: z.object({
				inventoryTransferUuid: z.string()
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.GetInventoryReportSummary]: {
		input: z.object({
			query: z.object({
				inventoryLocationUuid: z.string().optional()
			})
		})
	},
	[Endpoint.ListVariantSuppliers]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0),
				variantUuid: z.string().optional(),
				supplierUuid: z.string().optional()
			})
		})
	},
	[Endpoint.UpsertVariantSupplier]: {
		input: z.object({
			body: z.object({
				variantUuid: z.string(),
				supplierUuid: z.string(),
				purchasePrice: CommonTypes.zAmount,
				currencyCode: z.string(),
				supplierProductCode: z.string().optional(),
				isPreferred: z.boolean().optional()
			})
		})
	},
	[Endpoint.SetPreferredVariantSupplier]: {
		input: z.object({
			path: z.object({
				variantSupplierUuid: z.string()
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.DeleteVariantSupplier]: {
		input: z.object({
			path: z.object({
				variantSupplierUuid: z.string()
			})
		})
	},
	[Endpoint.ListIntegrations]: {
		input: z.object({})
	},
	[Endpoint.GetTeyaIntegration]: {
		input: z.object({})
	},
	[Endpoint.CreateTeyaConnectUrl]: {
		input: z.object({
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.DisconnectTeya]: {
		input: z.object({
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.ListTeyaStores]: {
		input: z.object({})
	},
	[Endpoint.ListTeyaTerminals]: {
		input: z.object({
			path: z.object({
				storeId: z.string()
			})
		})
	},
	[Endpoint.RegisterRapydDevice]: {
		input: z.object({
			body: z.object({
				serialNumber: z.string()
			})
		})
	},
	[Endpoint.PollRapydDeviceToken]: {
		input: z.object({
			path: z.object({
				serialNumber: z.string()
			})
		})
	},
	[Endpoint.GetIntegrationConfig]: {
		input: z.object({
			path: z.object({
				provider: AdminIntegrationsTypes.zIntegrationProvider
			})
		})
	},
	[Endpoint.PutIntegrationGlobalConfig]: {
		input: z.object({
			path: z.object({
				provider: AdminIntegrationsTypes.zIntegrationProvider
			}),
			body: z.object({
				values: z.any()
			})
		})
	},
	[Endpoint.CreateIntegrationOverride]: {
		input: z.object({
			path: z.object({
				provider: AdminIntegrationsTypes.zIntegrationProvider
			}),
			body: z.object({
				targetUuid: z.string(),
				values: z.any()
			})
		})
	},
	[Endpoint.UpdateIntegrationOverride]: {
		input: z.object({
			path: z
				.object({
					provider: AdminIntegrationsTypes.zIntegrationProvider
				})
				.and(
					z.object({
						featureId: z.string()
					})
				),
			body: z.object({
				values: z.any()
			})
		})
	},
	[Endpoint.DeleteIntegrationOverride]: {
		input: z.object({
			path: z
				.object({
					provider: AdminIntegrationsTypes.zIntegrationProvider
				})
				.and(
					z.object({
						featureId: z.string()
					})
				)
		})
	},
	[Endpoint.GetBillingPlan]: {
		input: z.object({})
	},
	[Endpoint.AcceptBillingPlan]: {
		input: z.object({
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.GetAppUpdateBranches]: {
		input: z.object({})
	},
	[Endpoint.GetAppUpdates]: {
		input: z.object({
			path: z.object({
				branchName: z.string().min(1)
			}),
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().int().min(0).default(0)
			})
		})
	}
} as const
export const Paths = {
	[Endpoint.GetAnalytics]: '/v1/admin/analytics',
	[Endpoint.GetBasketAnalysis]: '/v1/admin/analytics/basket',
	[Endpoint.GetProductReport]: '/v1/admin/analytics/reports/products',
	[Endpoint.GetRevenueReport]: '/v1/admin/analytics/reports/revenue',
	[Endpoint.GetUserAnalytics]: '/v1/admin/analytics/users',
	[Endpoint.GetApiKey]: '/v1/admin/api-key',
	[Endpoint.GetAppUpdateBranches]: '/v1/admin/app-updates',
	[Endpoint.GetAppUpdates]: '/v1/admin/app-updates/:branchName/updates',
	[Endpoint.ListAssets]: '/v1/admin/assets',
	[Endpoint.GetAsset]: '/v1/admin/assets/:assetUuid',
	[Endpoint.UpdateAsset]: '/v1/admin/assets/:assetUuid',
	[Endpoint.DeleteAsset]: '/v1/admin/assets/:assetUuid',
	[Endpoint.CompleteAssetUpload]: '/v1/admin/assets/:assetUuid/upload-complete',
	[Endpoint.RemoveTagFromAssets]: '/v1/admin/assets/remove-tag',
	[Endpoint.RenameAssetTag]: '/v1/admin/assets/rename-tag',
	[Endpoint.ListAssetTags]: '/v1/admin/assets/tags',
	[Endpoint.CreateAssetTag]: '/v1/admin/assets/tags',
	[Endpoint.InitAssetUpload]: '/v1/admin/assets/upload-init',
	[Endpoint.Login]: '/v1/admin/auth/login',
	[Endpoint.Register]: '/v1/admin/auth/register',
	[Endpoint.ResetPassword]: '/v1/admin/auth/reset-password',
	[Endpoint.UpdatePassword]: '/v1/admin/auth/reset-password/update',
	[Endpoint.CreateBagCheck]: '/v1/admin/bag-check',
	[Endpoint.GetBagCheck]: '/v1/admin/bag-check/:checkUuid',
	[Endpoint.BagCheckApprove]: '/v1/admin/bag-check/:checkUuid/approve',
	[Endpoint.BagCheckAddItem]: '/v1/admin/bag-check/:checkUuid/items',
	[Endpoint.BagCheckUpdateItemQuantity]: '/v1/admin/bag-check/:checkUuid/items/:itemUuid',
	[Endpoint.BagCheckReject]: '/v1/admin/bag-check/:checkUuid/reject',
	[Endpoint.RestartBagCheck]: '/v1/admin/bag-check/:checkUuid/restart',
	[Endpoint.GetBillingPlan]: '/v1/admin/billing/plan',
	[Endpoint.AcceptBillingPlan]: '/v1/admin/billing/plan/accept',
	[Endpoint.ListBusinessCards]: '/v1/admin/business-cards',
	[Endpoint.GetBusinessCard]: '/v1/admin/business-cards/:cardUuid',
	[Endpoint.UpdateBusinessCard]: '/v1/admin/business-cards/:cardUuid',
	[Endpoint.DeleteBusinessCard]: '/v1/admin/business-cards/:cardUuid',
	[Endpoint.ResetBusinessCardPin]: '/v1/admin/business-cards/:cardUuid/reset-pin',
	[Endpoint.GetBusinessCardTransactions]: '/v1/admin/business-cards/:cardUuid/transactions',
	[Endpoint.VerifyBusinessCardPin]: '/v1/admin/business-cards/:cardUuid/verify-pin',
	[Endpoint.ListCompanies]: '/v1/admin/companies',
	[Endpoint.CreateCompany]: '/v1/admin/companies',
	[Endpoint.GetCompany]: '/v1/admin/companies/:companyUuid',
	[Endpoint.UpdateCompany]: '/v1/admin/companies/:companyUuid',
	[Endpoint.DeleteCompany]: '/v1/admin/companies/:companyUuid',
	[Endpoint.CreateBusinessCard]: '/v1/admin/companies/:companyUuid/business-cards',
	[Endpoint.ListCompanySettlements]: '/v1/admin/companies/:companyUuid/settlements',
	[Endpoint.CreateSettlement]: '/v1/admin/companies/:companyUuid/settlements',
	[Endpoint.ListCountries]: '/v1/admin/countries',
	[Endpoint.GetCountry]: '/v1/admin/countries/:countryCode',
	[Endpoint.ListCountryTaxRates]: '/v1/admin/countries/:countryCode/tax-rates',
	[Endpoint.ListCustomerGroups]: '/v1/admin/customer-groups',
	[Endpoint.CreateCustomerGroup]: '/v1/admin/customer-groups',
	[Endpoint.GetCustomerGroup]: '/v1/admin/customer-groups/:customerGroupUuid',
	[Endpoint.UpdateCustomerGroup]: '/v1/admin/customer-groups/:customerGroupUuid',
	[Endpoint.DeleteCustomerGroup]: '/v1/admin/customer-groups/:customerGroupUuid',
	[Endpoint.ListCustomers]: '/v1/admin/customers',
	[Endpoint.CreateCustomer]: '/v1/admin/customers',
	[Endpoint.GetCustomer]: '/v1/admin/customers/:customerUuid',
	[Endpoint.UpdateCustomer]: '/v1/admin/customers/:customerUuid',
	[Endpoint.RevokeCustomerTokens]: '/v1/admin/customers/:customerUuid',
	[Endpoint.AssumeCustomerToken]: '/v1/admin/customers/:customerUuid/assume-token',
	[Endpoint.GetDashboardFeatures]: '/v1/admin/dashboard-features',
	[Endpoint.SubmitDeveloperFeedback]: '/v1/admin/developer-feedback',
	[Endpoint.ListDevices]: '/v1/admin/devices',
	[Endpoint.CreateDevice]: '/v1/admin/devices',
	[Endpoint.GetDevice]: '/v1/admin/devices/:deviceUuid',
	[Endpoint.UpdateDevice]: '/v1/admin/devices/:deviceUuid',
	[Endpoint.DeleteDevice]: '/v1/admin/devices/:deviceUuid',
	[Endpoint.LookupDeviceEnrollmentByCodeForDevice]: '/v1/admin/devices/:deviceUuid/device-enrollment/by-code/:code',
	[Endpoint.EnrollDevice]: '/v1/admin/devices/:deviceUuid/device-enrollment/enroll',
	[Endpoint.UnenrollDevice]: '/v1/admin/devices/:deviceUuid/device-enrollment/unenroll',
	[Endpoint.GetDeviceStatus]: '/v1/admin/devices/:deviceUuid/device-status',
	[Endpoint.RefreshDeviceStatus]: '/v1/admin/devices/:deviceUuid/device-status/refresh',
	[Endpoint.DeleteDeviceGmsDevice]: '/v1/admin/devices/:deviceUuid/gms',
	[Endpoint.CreateDeviceGmsEnrollment]: '/v1/admin/devices/:deviceUuid/gms/enroll',
	[Endpoint.SyncDeviceGmsPolicy]: '/v1/admin/devices/:deviceUuid/gms/policy',
	[Endpoint.RebootDeviceGmsDevice]: '/v1/admin/devices/:deviceUuid/gms/reboot',
	[Endpoint.LinkDeviceToPointOfSale]: '/v1/admin/devices/:deviceUuid/link',
	[Endpoint.CreateDeviceSecretKey]: '/v1/admin/devices/:deviceUuid/secret-key',
	[Endpoint.UnlinkDeviceFromPointOfSale]: '/v1/admin/devices/:deviceUuid/unlink',
	[Endpoint.GetCurrentDevice]: '/v1/admin/devices/current',
	[Endpoint.ReportDeviceStatus]: '/v1/admin/devices/current/device-status',
	[Endpoint.GetDeviceInfo]: '/v1/admin/devices/current/info',
	[Endpoint.UnenrollCurrentDevice]: '/v1/admin/devices/current/unenroll',
	[Endpoint.GetAvailableExports]: '/v1/admin/export',
	[Endpoint.DigiScaleProductExport]: '/v1/admin/export/digi',
	[Endpoint.PricerProductExport]: '/v1/admin/export/pricer',
	[Endpoint.GetSAFTExportInfo]: '/v1/admin/export/saft',
	[Endpoint.SAFTExportCashRegister]: '/v1/admin/export/saft/cash-register',
	[Endpoint.SAFTExportFinancial]: '/v1/admin/export/saft/financial',
	[Endpoint.VismaExport]: '/v1/admin/export/visma',
	[Endpoint.ListGiftCards]: '/v1/admin/gift-cards',
	[Endpoint.CreateGiftCard]: '/v1/admin/gift-cards',
	[Endpoint.GetGiftCard]: '/v1/admin/gift-cards/:giftCardUuid',
	[Endpoint.UpdateGiftCard]: '/v1/admin/gift-cards/:giftCardUuid',
	[Endpoint.DeleteGiftCard]: '/v1/admin/gift-cards/:giftCardUuid',
	[Endpoint.GetGmsPlayTracks]: '/v1/admin/gms-tracks',
	[Endpoint.ListIntegrations]: '/v1/admin/integrations',
	[Endpoint.GetIntegrationConfig]: '/v1/admin/integrations/:provider/config',
	[Endpoint.PutIntegrationGlobalConfig]: '/v1/admin/integrations/:provider/config/global',
	[Endpoint.CreateIntegrationOverride]: '/v1/admin/integrations/:provider/overrides',
	[Endpoint.UpdateIntegrationOverride]: '/v1/admin/integrations/:provider/overrides/:featureId',
	[Endpoint.DeleteIntegrationOverride]: '/v1/admin/integrations/:provider/overrides/:featureId',
	[Endpoint.PollRapydDeviceToken]: '/v1/admin/integrations/rapyd-cloudlink/device-token/:serialNumber',
	[Endpoint.RegisterRapydDevice]: '/v1/admin/integrations/rapyd-cloudlink/register',
	[Endpoint.GetTeyaIntegration]: '/v1/admin/integrations/teya',
	[Endpoint.CreateTeyaConnectUrl]: '/v1/admin/integrations/teya/connect-url',
	[Endpoint.DisconnectTeya]: '/v1/admin/integrations/teya/disconnect',
	[Endpoint.ListTeyaStores]: '/v1/admin/integrations/teya/stores',
	[Endpoint.ListTeyaTerminals]: '/v1/admin/integrations/teya/stores/:storeId/terminals',
	[Endpoint.ListInventoryLevels]: '/v1/admin/inventory-levels',
	[Endpoint.GetInventoryLevel]: '/v1/admin/inventory-levels/:inventoryLevelUuid',
	[Endpoint.UpdateInventoryLevel]: '/v1/admin/inventory-levels/:inventoryLevelUuid',
	[Endpoint.AdjustInventoryLevel]: '/v1/admin/inventory-levels/:inventoryLevelUuid',
	[Endpoint.GetInventorySummary]: '/v1/admin/inventory-levels/summary',
	[Endpoint.ListInventoryLocations]: '/v1/admin/inventory-locations',
	[Endpoint.CreateInventoryLocation]: '/v1/admin/inventory-locations',
	[Endpoint.GetInventoryLocation]: '/v1/admin/inventory-locations/:inventoryLocationUuid',
	[Endpoint.UpdateInventoryLocation]: '/v1/admin/inventory-locations/:inventoryLocationUuid',
	[Endpoint.ProvisionInventoryLocationLevels]: '/v1/admin/inventory-locations/:inventoryLocationUuid',
	[Endpoint.SearchInventoryVariants]: '/v1/admin/inventory-locations/search-variants',
	[Endpoint.GetInventoryReportSummary]: '/v1/admin/inventory-reports',
	[Endpoint.GetInventorySettings]: '/v1/admin/inventory-settings',
	[Endpoint.UpdateInventorySettings]: '/v1/admin/inventory-settings',
	[Endpoint.ListInventoryTransfers]: '/v1/admin/inventory-transfers',
	[Endpoint.CreateInventoryTransfer]: '/v1/admin/inventory-transfers',
	[Endpoint.GetInventoryTransfer]: '/v1/admin/inventory-transfers/:inventoryTransferUuid',
	[Endpoint.CancelInventoryTransfer]: '/v1/admin/inventory-transfers/:inventoryTransferUuid/cancel',
	[Endpoint.ReceiveInventoryTransfer]: '/v1/admin/inventory-transfers/:inventoryTransferUuid/receive',
	[Endpoint.ShipInventoryTransfer]: '/v1/admin/inventory-transfers/:inventoryTransferUuid/ship',
	[Endpoint.ListInvites]: '/v1/admin/invites',
	[Endpoint.CreateInvite]: '/v1/admin/invites',
	[Endpoint.DeleteInvite]: '/v1/admin/invites/:inviteUuid',
	[Endpoint.ListLoyaltyCards]: '/v1/admin/loyalty-cards',
	[Endpoint.CreateLoyaltyCard]: '/v1/admin/loyalty-cards',
	[Endpoint.GetLoyaltyCard]: '/v1/admin/loyalty-cards/:cardUuid',
	[Endpoint.UpdateLoyaltyCard]: '/v1/admin/loyalty-cards/:cardUuid',
	[Endpoint.DeleteLoyaltyCard]: '/v1/admin/loyalty-cards/:cardUuid',
	[Endpoint.GetLoyaltyCardRedemptions]: '/v1/admin/loyalty-cards/:cardUuid/redemptions',
	[Endpoint.ListMarketingChannels]: '/v1/admin/marketing-channels',
	[Endpoint.CreateMarketingChannel]: '/v1/admin/marketing-channels',
	[Endpoint.GetMarketingChannel]: '/v1/admin/marketing-channels/:marketingChannelUuid',
	[Endpoint.UpdateMarketingChannel]: '/v1/admin/marketing-channels/:marketingChannelUuid',
	[Endpoint.DeleteMarketingChannel]: '/v1/admin/marketing-channels/:marketingChannelUuid',
	[Endpoint.GetChannelLayout]: '/v1/admin/marketing-channels/:marketingChannelUuid/content-layout',
	[Endpoint.ReplaceChannelLayout]: '/v1/admin/marketing-channels/:marketingChannelUuid/content-layout',
	[Endpoint.GetFeedLayout]: '/v1/admin/marketing-channels/:marketingChannelUuid/layout',
	[Endpoint.ReplaceFeedLayoutBlocks]: '/v1/admin/marketing-channels/:marketingChannelUuid/layout',
	[Endpoint.GetChannelResolvedContent]: '/v1/admin/marketing-channels/:marketingChannelUuid/resolved-content',
	[Endpoint.ListMarketingContent]: '/v1/admin/marketing-content',
	[Endpoint.CreateMarketingContent]: '/v1/admin/marketing-content',
	[Endpoint.GetMarketingContent]: '/v1/admin/marketing-content/:contentUuid',
	[Endpoint.UpdateMarketingContent]: '/v1/admin/marketing-content/:contentUuid',
	[Endpoint.DeleteMarketingContent]: '/v1/admin/marketing-content/:contentUuid',
	[Endpoint.ReplaceMarketingContentBlocks]: '/v1/admin/marketing-content/:contentUuid/blocks',
	[Endpoint.DuplicateMarketingContent]: '/v1/admin/marketing-content/:contentUuid/duplicate',
	[Endpoint.ListOrders]: '/v1/admin/orders',
	[Endpoint.GetOrder]: '/v1/admin/orders/:orderUuid',
	[Endpoint.GetOrderTransaction]: '/v1/admin/orders/:orderUuid/:transactionUuid',
	[Endpoint.CancelOrder]: '/v1/admin/orders/:orderUuid/cancel',
	[Endpoint.GetExitCode]: '/v1/admin/orders/:orderUuid/exit-code',
	[Endpoint.UpdateFulfillmentStatus]: '/v1/admin/orders/:orderUuid/fulfillment',
	[Endpoint.GetOrderReceipt]: '/v1/admin/orders/:orderUuid/receipt',
	[Endpoint.CreateOrderReceiptLink]: '/v1/admin/orders/:orderUuid/receipt-link',
	[Endpoint.InvalidateOrderReceipt]: '/v1/admin/orders/:orderUuid/receipt/invalidate',
	[Endpoint.GetOrderReceiptUrl]: '/v1/admin/orders/:orderUuid/receipt/url',
	[Endpoint.RefundOrder]: '/v1/admin/orders/:orderUuid/refund',
	[Endpoint.ExportOrders]: '/v1/admin/orders/export',
	[Endpoint.ListPointsOfSale]: '/v1/admin/point-of-sale',
	[Endpoint.CreatePointOfSale]: '/v1/admin/point-of-sale',
	[Endpoint.ListPointOfSaleGroups]: '/v1/admin/point-of-sale-groups',
	[Endpoint.CreatePointOfSaleGroup]: '/v1/admin/point-of-sale-groups',
	[Endpoint.GetPointOfSaleGroup]: '/v1/admin/point-of-sale-groups/:pointOfSaleGroupUuid',
	[Endpoint.UpdatePointOfSaleGroup]: '/v1/admin/point-of-sale-groups/:pointOfSaleGroupUuid',
	[Endpoint.DeletePointOfSaleGroup]: '/v1/admin/point-of-sale-groups/:pointOfSaleGroupUuid',
	[Endpoint.GetPointOfSale]: '/v1/admin/point-of-sale/:pointOfSaleUuid',
	[Endpoint.UpdatePointOfSale]: '/v1/admin/point-of-sale/:pointOfSaleUuid',
	[Endpoint.CashCount]: '/v1/admin/point-of-sale/:pointOfSaleUuid/cash-float/count',
	[Endpoint.OpenCashFloat]: '/v1/admin/point-of-sale/:pointOfSaleUuid/cash-float/open',
	[Endpoint.CashPayIn]: '/v1/admin/point-of-sale/:pointOfSaleUuid/cash-float/pay-in',
	[Endpoint.CashPayOut]: '/v1/admin/point-of-sale/:pointOfSaleUuid/cash-float/pay-out',
	[Endpoint.LookupDeviceEnrollmentByCode]: '/v1/admin/point-of-sale/:pointOfSaleUuid/device-enrollment/by-code/:code',
	[Endpoint.EnrollPointOfSaleDevice]: '/v1/admin/point-of-sale/:pointOfSaleUuid/device-enrollment/enroll',
	[Endpoint.UnenrollPointOfSaleDevice]: '/v1/admin/point-of-sale/:pointOfSaleUuid/device-enrollment/unenroll',
	[Endpoint.GetPointOfSaleDeviceStatus]: '/v1/admin/point-of-sale/:pointOfSaleUuid/device-status',
	[Endpoint.RefreshPointOfSaleDeviceStatus]: '/v1/admin/point-of-sale/:pointOfSaleUuid/device-status/refresh',
	[Endpoint.UnlockPointOfSaleDoor]: '/v1/admin/point-of-sale/:pointOfSaleUuid/door/unlock',
	[Endpoint.LockPointOfSaleKiosk]: '/v1/admin/point-of-sale/:pointOfSaleUuid/lock-kiosk',
	[Endpoint.NotifyPointOfSaleAppUpdate]: '/v1/admin/point-of-sale/:pointOfSaleUuid/notify-app-update',
	[Endpoint.OpenCooler]: '/v1/admin/point-of-sale/:pointOfSaleUuid/open-cooler',
	[Endpoint.RestartPointOfSaleApp]: '/v1/admin/point-of-sale/:pointOfSaleUuid/restart-app',
	[Endpoint.UnlockPointOfSaleKiosk]: '/v1/admin/point-of-sale/:pointOfSaleUuid/unlock-kiosk',
	[Endpoint.GetPointOfSaleHierarchy]: '/v1/admin/point-of-sale/hierarchy',
	[Endpoint.GetCurrentPointOfSale]: '/v1/admin/point-of-sale/info',
	[Endpoint.CreatePointOfSaleWebSocketTicket]: '/v1/admin/point-of-sale/ws-ticket',
	[Endpoint.ListProducts]: '/v1/admin/products',
	[Endpoint.CreateProduct]: '/v1/admin/products',
	[Endpoint.GetProduct]: '/v1/admin/products/:productUuid',
	[Endpoint.DeleteProduct]: '/v1/admin/products/:productUuid',
	[Endpoint.UpdateProduct]: '/v1/admin/products/:productUuid',
	[Endpoint.ListProductBarcodes]: '/v1/admin/products/:productUuid/barcodes',
	[Endpoint.CreateProductBarcode]: '/v1/admin/products/:productUuid/barcodes',
	[Endpoint.DeleteProductBarcode]: '/v1/admin/products/:productUuid/barcodes/:barcode',
	[Endpoint.GetProductEdit]: '/v1/admin/products/:productUuid/edit',
	[Endpoint.ListProductImages]: '/v1/admin/products/:productUuid/images',
	[Endpoint.AttachProductImage]: '/v1/admin/products/:productUuid/images',
	[Endpoint.DeleteProductImage]: '/v1/admin/products/:productUuid/images/:imageUuid',
	[Endpoint.SetPrimaryProductImage]: '/v1/admin/products/:productUuid/images/:imageUuid/primary',
	[Endpoint.ReorderProductImages]: '/v1/admin/products/:productUuid/images/reorder',
	[Endpoint.GetProductOrganization]: '/v1/admin/products/:productUuid/organization',
	[Endpoint.UpdateProductOrganization]: '/v1/admin/products/:productUuid/organization',
	[Endpoint.GetProductPricing]: '/v1/admin/products/:productUuid/pricing',
	[Endpoint.UpdateProductPricing]: '/v1/admin/products/:productUuid/pricing',
	[Endpoint.CreateProductUnitOfMeasure]: '/v1/admin/products/:productUuid/units-of-measure',
	[Endpoint.UpdateProductUnitOfMeasure]: '/v1/admin/products/:productUuid/units-of-measure/:unitUuid',
	[Endpoint.DeleteProductUnitOfMeasure]: '/v1/admin/products/:productUuid/units-of-measure/:unitUuid',
	[Endpoint.SetProductBaseUnit]: '/v1/admin/products/:productUuid/units-of-measure/base',
	[Endpoint.ListProductVariants]: '/v1/admin/products/:productUuid/variants',
	[Endpoint.CreateProductVariant]: '/v1/admin/products/:productUuid/variants',
	[Endpoint.GetProductVariant]: '/v1/admin/products/:productUuid/variants/:variantUuid',
	[Endpoint.UpdateProductVariant]: '/v1/admin/products/:productUuid/variants/:variantUuid',
	[Endpoint.CreateVariantBarcode]: '/v1/admin/products/:productUuid/variants/:variantUuid/barcodes',
	[Endpoint.ListVariantBarcodes]: '/v1/admin/products/:productUuid/variants/:variantUuid/barcodes',
	[Endpoint.DeleteVariantBarcode]: '/v1/admin/products/:productUuid/variants/:variantUuid/barcodes/:barcode',
	[Endpoint.GetVariantPricing]: '/v1/admin/products/:productUuid/variants/:variantUuid/pricing',
	[Endpoint.UpdateVariantPricing]: '/v1/admin/products/:productUuid/variants/:variantUuid/pricing',
	[Endpoint.GetProductFromBarcode]: '/v1/admin/products/barcode/:barcode',
	[Endpoint.ListProductCategories]: '/v1/admin/products/categories',
	[Endpoint.CreateProductCategory]: '/v1/admin/products/categories',
	[Endpoint.GetProductCategory]: '/v1/admin/products/categories/:categoryUuid',
	[Endpoint.DeleteProductCategory]: '/v1/admin/products/categories/:categoryUuid',
	[Endpoint.UpdateProductCategory]: '/v1/admin/products/categories/:categoryUuid',
	[Endpoint.SetProductCategoryImage]: '/v1/admin/products/categories/:categoryUuid/image',
	[Endpoint.DeleteProductCategoryImage]: '/v1/admin/products/categories/:categoryUuid/image',
	[Endpoint.GetProductCategoryHierarchy]: '/v1/admin/products/categories/hierarchy',
	[Endpoint.ExportProducts]: '/v1/admin/products/export',
	[Endpoint.ListProductGroups]: '/v1/admin/products/groups',
	[Endpoint.CreateProductGroup]: '/v1/admin/products/groups',
	[Endpoint.GetProductGroup]: '/v1/admin/products/groups/:groupUuid',
	[Endpoint.DeleteProductGroup]: '/v1/admin/products/groups/:groupUuid',
	[Endpoint.UpdateProductGroup]: '/v1/admin/products/groups/:groupUuid',
	[Endpoint.ListProductGroupFees]: '/v1/admin/products/groups/:groupUuid/fees',
	[Endpoint.CreateProductGroupFee]: '/v1/admin/products/groups/:groupUuid/fees',
	[Endpoint.GetProductGroupFee]: '/v1/admin/products/groups/:groupUuid/fees/:feeUuid',
	[Endpoint.DeleteProductGroupFee]: '/v1/admin/products/groups/:groupUuid/fees/:feeUuid',
	[Endpoint.UpdateProductGroupFee]: '/v1/admin/products/groups/:groupUuid/fees/:feeUuid',
	[Endpoint.SetProductGroupImage]: '/v1/admin/products/groups/:groupUuid/image',
	[Endpoint.DeleteProductGroupImage]: '/v1/admin/products/groups/:groupUuid/image',
	[Endpoint.AddProductsToProductGroup]: '/v1/admin/products/groups/:groupUuid/products',
	[Endpoint.ImportProducts]: '/v1/admin/products/import',
	[Endpoint.ValidateProductImport]: '/v1/admin/products/import/validate',
	[Endpoint.ListProductGroupsForPointOfSale]: '/v1/admin/products/point-of-sale/:pointOfSaleUuid',
	[Endpoint.UpdateProductGroupsForPointOfSale]: '/v1/admin/products/point-of-sale/:pointOfSaleUuid',
	[Endpoint.GetProductMenu]: '/v1/admin/products/point-of-sale/:pointOfSaleUuid/product-menu',
	[Endpoint.ListAvailableProductsForSalesChannel]: '/v1/admin/products/sales-channel/:salesChannelUuid',
	[Endpoint.ListUnitsOfMeasure]: '/v1/admin/products/units-of-measure-catalog',
	[Endpoint.CreateUnitOfMeasure]: '/v1/admin/products/units-of-measure-catalog',
	[Endpoint.UpdateUnitOfMeasure]: '/v1/admin/products/units-of-measure-catalog/:unitUuid',
	[Endpoint.DeleteUnitOfMeasure]: '/v1/admin/products/units-of-measure-catalog/:unitUuid',
	[Endpoint.ListPromotionGroups]: '/v1/admin/promotion-groups',
	[Endpoint.ListPromotions]: '/v1/admin/promotions',
	[Endpoint.CreatePromotion]: '/v1/admin/promotions',
	[Endpoint.GetPromotion]: '/v1/admin/promotions/:promotionUuid',
	[Endpoint.DeletePromotion]: '/v1/admin/promotions/:promotionUuid',
	[Endpoint.UpdatePromotion]: '/v1/admin/promotions/:promotionUuid',
	[Endpoint.ListPublishableKeys]: '/v1/admin/publishable-keys',
	[Endpoint.CreatePublishableKey]: '/v1/admin/publishable-keys',
	[Endpoint.GetPublishableKey]: '/v1/admin/publishable-keys/:publishableKeyUuid',
	[Endpoint.UpdatePublishableKey]: '/v1/admin/publishable-keys/:publishableKeyUuid',
	[Endpoint.DeletePublishableKey]: '/v1/admin/publishable-keys/:publishableKeyUuid',
	[Endpoint.ListPurchaseOrders]: '/v1/admin/purchase-orders',
	[Endpoint.CreatePurchaseOrder]: '/v1/admin/purchase-orders',
	[Endpoint.GetPurchaseOrder]: '/v1/admin/purchase-orders/:purchaseOrderUuid',
	[Endpoint.ReceivePurchaseOrder]: '/v1/admin/purchase-orders/:purchaseOrderUuid',
	[Endpoint.CancelPurchaseOrder]: '/v1/admin/purchase-orders/:purchaseOrderUuid/cancel',
	[Endpoint.MarkPurchaseOrderOrdered]: '/v1/admin/purchase-orders/:purchaseOrderUuid/mark-ordered',
	[Endpoint.CreateReplenishmentPurchaseOrders]: '/v1/admin/purchase-orders/replenish',
	[Endpoint.ListSalesChannelGroups]: '/v1/admin/sales-channel-groups',
	[Endpoint.CreateSalesChannelGroup]: '/v1/admin/sales-channel-groups',
	[Endpoint.GetSalesChannelGroup]: '/v1/admin/sales-channel-groups/:salesChannelGroupUuid',
	[Endpoint.UpdateSalesChannelGroup]: '/v1/admin/sales-channel-groups/:salesChannelGroupUuid',
	[Endpoint.DeleteSalesChannelGroup]: '/v1/admin/sales-channel-groups/:salesChannelGroupUuid',
	[Endpoint.ListSalesChannelTypes]: '/v1/admin/sales-channel-types',
	[Endpoint.CreateSalesChannelType]: '/v1/admin/sales-channel-types',
	[Endpoint.GetSalesChannelType]: '/v1/admin/sales-channel-types/:salesChannelTypeUuid',
	[Endpoint.UpdateSalesChannelType]: '/v1/admin/sales-channel-types/:salesChannelTypeUuid',
	[Endpoint.DeleteSalesChannelType]: '/v1/admin/sales-channel-types/:salesChannelTypeUuid',
	[Endpoint.ListSalesChannels]: '/v1/admin/sales-channels',
	[Endpoint.CreateSalesChannel]: '/v1/admin/sales-channels',
	[Endpoint.GetSalesChannel]: '/v1/admin/sales-channels/:salesChannelUuid',
	[Endpoint.UpdateSalesChannel]: '/v1/admin/sales-channels/:salesChannelUuid',
	[Endpoint.DeleteSalesChannel]: '/v1/admin/sales-channels/:salesChannelUuid',
	[Endpoint.CreateSecretKey]: '/v1/admin/secret-keys',
	[Endpoint.UpdateSecretKey]: '/v1/admin/secret-keys/:secretKeyUuid',
	[Endpoint.GetSettlement]: '/v1/admin/settlements/:settlementUuid',
	[Endpoint.MarkSettlementSettled]: '/v1/admin/settlements/:settlementUuid/mark-settled',
	[Endpoint.ListStockMovements]: '/v1/admin/stock-movements',
	[Endpoint.ListSuppliers]: '/v1/admin/suppliers',
	[Endpoint.CreateSupplier]: '/v1/admin/suppliers',
	[Endpoint.GetSupplier]: '/v1/admin/suppliers/:supplierUuid',
	[Endpoint.UpdateSupplier]: '/v1/admin/suppliers/:supplierUuid',
	[Endpoint.ListTaxRates]: '/v1/admin/tax-rates',
	[Endpoint.ListUsers]: '/v1/admin/users',
	[Endpoint.GetUser]: '/v1/admin/users/:userUuid',
	[Endpoint.UpdateUser]: '/v1/admin/users/:userUuid',
	[Endpoint.DeleteUser]: '/v1/admin/users/:userUuid',
	[Endpoint.GetUserSignInCredentials]: '/v1/admin/users/:userUuid/sign-in-credentials',
	[Endpoint.SetUserSignInCredentials]: '/v1/admin/users/:userUuid/sign-in-credentials',
	[Endpoint.GetMe]: '/v1/admin/users/me',
	[Endpoint.UpdateMe]: '/v1/admin/users/me',
	[Endpoint.ValidateMySignInPin]: '/v1/admin/users/me/sign-in-pin',
	[Endpoint.SetMySignInPin]: '/v1/admin/users/me/sign-in-pin',
	[Endpoint.ListVariantSuppliers]: '/v1/admin/variant-suppliers',
	[Endpoint.UpsertVariantSupplier]: '/v1/admin/variant-suppliers',
	[Endpoint.SetPreferredVariantSupplier]: '/v1/admin/variant-suppliers/:variantSupplierUuid',
	[Endpoint.DeleteVariantSupplier]: '/v1/admin/variant-suppliers/:variantSupplierUuid'
} as const satisfies { [key in Endpoint]: string }

export const Methods = {
	[Endpoint.GetApiKey]: HttpMethod.Get,
	[Endpoint.Login]: HttpMethod.Post,
	[Endpoint.Register]: HttpMethod.Post,
	[Endpoint.ResetPassword]: HttpMethod.Post,
	[Endpoint.UpdatePassword]: HttpMethod.Post,
	[Endpoint.ListUsers]: HttpMethod.Get,
	[Endpoint.GetMe]: HttpMethod.Get,
	[Endpoint.UpdateMe]: HttpMethod.Post,
	[Endpoint.ValidateMySignInPin]: HttpMethod.Post,
	[Endpoint.SetMySignInPin]: HttpMethod.Put,
	[Endpoint.GetUser]: HttpMethod.Get,
	[Endpoint.UpdateUser]: HttpMethod.Put,
	[Endpoint.DeleteUser]: HttpMethod.Delete,
	[Endpoint.GetUserSignInCredentials]: HttpMethod.Get,
	[Endpoint.SetUserSignInCredentials]: HttpMethod.Put,
	[Endpoint.ListInvites]: HttpMethod.Get,
	[Endpoint.CreateInvite]: HttpMethod.Post,
	[Endpoint.DeleteInvite]: HttpMethod.Delete,
	[Endpoint.ListSalesChannelTypes]: HttpMethod.Get,
	[Endpoint.CreateSalesChannelType]: HttpMethod.Post,
	[Endpoint.GetSalesChannelType]: HttpMethod.Get,
	[Endpoint.UpdateSalesChannelType]: HttpMethod.Put,
	[Endpoint.DeleteSalesChannelType]: HttpMethod.Delete,
	[Endpoint.ListSalesChannelGroups]: HttpMethod.Get,
	[Endpoint.CreateSalesChannelGroup]: HttpMethod.Post,
	[Endpoint.GetSalesChannelGroup]: HttpMethod.Get,
	[Endpoint.UpdateSalesChannelGroup]: HttpMethod.Put,
	[Endpoint.DeleteSalesChannelGroup]: HttpMethod.Delete,
	[Endpoint.ListSalesChannels]: HttpMethod.Get,
	[Endpoint.CreateSalesChannel]: HttpMethod.Post,
	[Endpoint.GetSalesChannel]: HttpMethod.Get,
	[Endpoint.UpdateSalesChannel]: HttpMethod.Put,
	[Endpoint.DeleteSalesChannel]: HttpMethod.Delete,
	[Endpoint.ListPointOfSaleGroups]: HttpMethod.Get,
	[Endpoint.CreatePointOfSaleGroup]: HttpMethod.Post,
	[Endpoint.GetPointOfSaleGroup]: HttpMethod.Get,
	[Endpoint.UpdatePointOfSaleGroup]: HttpMethod.Put,
	[Endpoint.DeletePointOfSaleGroup]: HttpMethod.Delete,
	[Endpoint.ListPointsOfSale]: HttpMethod.Get,
	[Endpoint.CreatePointOfSale]: HttpMethod.Post,
	[Endpoint.GetPointOfSaleHierarchy]: HttpMethod.Get,
	[Endpoint.GetCurrentPointOfSale]: HttpMethod.Get,
	[Endpoint.CreatePointOfSaleWebSocketTicket]: HttpMethod.Post,
	[Endpoint.GetPointOfSale]: HttpMethod.Get,
	[Endpoint.UpdatePointOfSale]: HttpMethod.Put,
	[Endpoint.OpenCooler]: HttpMethod.Post,
	[Endpoint.OpenCashFloat]: HttpMethod.Post,
	[Endpoint.CashPayIn]: HttpMethod.Post,
	[Endpoint.CashPayOut]: HttpMethod.Post,
	[Endpoint.CashCount]: HttpMethod.Post,
	[Endpoint.GetPointOfSaleDeviceStatus]: HttpMethod.Get,
	[Endpoint.RefreshPointOfSaleDeviceStatus]: HttpMethod.Post,
	[Endpoint.LookupDeviceEnrollmentByCode]: HttpMethod.Get,
	[Endpoint.EnrollPointOfSaleDevice]: HttpMethod.Post,
	[Endpoint.UnenrollPointOfSaleDevice]: HttpMethod.Post,
	[Endpoint.NotifyPointOfSaleAppUpdate]: HttpMethod.Post,
	[Endpoint.RestartPointOfSaleApp]: HttpMethod.Post,
	[Endpoint.LockPointOfSaleKiosk]: HttpMethod.Post,
	[Endpoint.UnlockPointOfSaleKiosk]: HttpMethod.Post,
	[Endpoint.UnlockPointOfSaleDoor]: HttpMethod.Post,
	[Endpoint.GetGmsPlayTracks]: HttpMethod.Get,
	[Endpoint.ListPublishableKeys]: HttpMethod.Get,
	[Endpoint.CreatePublishableKey]: HttpMethod.Post,
	[Endpoint.GetPublishableKey]: HttpMethod.Get,
	[Endpoint.UpdatePublishableKey]: HttpMethod.Put,
	[Endpoint.DeletePublishableKey]: HttpMethod.Delete,
	[Endpoint.CreateSecretKey]: HttpMethod.Post,
	[Endpoint.UpdateSecretKey]: HttpMethod.Put,
	[Endpoint.ListDevices]: HttpMethod.Get,
	[Endpoint.CreateDevice]: HttpMethod.Post,
	[Endpoint.GetCurrentDevice]: HttpMethod.Get,
	[Endpoint.GetDeviceInfo]: HttpMethod.Get,
	[Endpoint.ReportDeviceStatus]: HttpMethod.Post,
	[Endpoint.UnenrollCurrentDevice]: HttpMethod.Post,
	[Endpoint.GetDevice]: HttpMethod.Get,
	[Endpoint.UpdateDevice]: HttpMethod.Put,
	[Endpoint.DeleteDevice]: HttpMethod.Delete,
	[Endpoint.LinkDeviceToPointOfSale]: HttpMethod.Post,
	[Endpoint.UnlinkDeviceFromPointOfSale]: HttpMethod.Post,
	[Endpoint.CreateDeviceSecretKey]: HttpMethod.Post,
	[Endpoint.GetDeviceStatus]: HttpMethod.Get,
	[Endpoint.RefreshDeviceStatus]: HttpMethod.Post,
	[Endpoint.LookupDeviceEnrollmentByCodeForDevice]: HttpMethod.Get,
	[Endpoint.EnrollDevice]: HttpMethod.Post,
	[Endpoint.UnenrollDevice]: HttpMethod.Post,
	[Endpoint.DeleteDeviceGmsDevice]: HttpMethod.Delete,
	[Endpoint.CreateDeviceGmsEnrollment]: HttpMethod.Post,
	[Endpoint.SyncDeviceGmsPolicy]: HttpMethod.Put,
	[Endpoint.RebootDeviceGmsDevice]: HttpMethod.Post,
	[Endpoint.ListProducts]: HttpMethod.Get,
	[Endpoint.CreateProduct]: HttpMethod.Post,
	[Endpoint.ListProductGroupsForPointOfSale]: HttpMethod.Get,
	[Endpoint.UpdateProductGroupsForPointOfSale]: HttpMethod.Put,
	[Endpoint.GetProductMenu]: HttpMethod.Get,
	[Endpoint.ListAvailableProductsForSalesChannel]: HttpMethod.Get,
	[Endpoint.GetProductFromBarcode]: HttpMethod.Get,
	[Endpoint.ListProductGroups]: HttpMethod.Get,
	[Endpoint.CreateProductGroup]: HttpMethod.Post,
	[Endpoint.GetProductGroup]: HttpMethod.Get,
	[Endpoint.DeleteProductGroup]: HttpMethod.Delete,
	[Endpoint.UpdateProductGroup]: HttpMethod.Post,
	[Endpoint.SetProductGroupImage]: HttpMethod.Put,
	[Endpoint.DeleteProductGroupImage]: HttpMethod.Delete,
	[Endpoint.AddProductsToProductGroup]: HttpMethod.Post,
	[Endpoint.ListProductGroupFees]: HttpMethod.Get,
	[Endpoint.CreateProductGroupFee]: HttpMethod.Post,
	[Endpoint.GetProductGroupFee]: HttpMethod.Get,
	[Endpoint.DeleteProductGroupFee]: HttpMethod.Delete,
	[Endpoint.UpdateProductGroupFee]: HttpMethod.Post,
	[Endpoint.ListProductCategories]: HttpMethod.Get,
	[Endpoint.CreateProductCategory]: HttpMethod.Post,
	[Endpoint.GetProductCategoryHierarchy]: HttpMethod.Get,
	[Endpoint.GetProductCategory]: HttpMethod.Get,
	[Endpoint.DeleteProductCategory]: HttpMethod.Delete,
	[Endpoint.UpdateProductCategory]: HttpMethod.Post,
	[Endpoint.SetProductCategoryImage]: HttpMethod.Put,
	[Endpoint.DeleteProductCategoryImage]: HttpMethod.Delete,
	[Endpoint.GetProduct]: HttpMethod.Get,
	[Endpoint.DeleteProduct]: HttpMethod.Delete,
	[Endpoint.UpdateProduct]: HttpMethod.Post,
	[Endpoint.GetProductEdit]: HttpMethod.Get,
	[Endpoint.ListProductBarcodes]: HttpMethod.Get,
	[Endpoint.CreateProductBarcode]: HttpMethod.Post,
	[Endpoint.DeleteProductBarcode]: HttpMethod.Delete,
	[Endpoint.CreateProductUnitOfMeasure]: HttpMethod.Post,
	[Endpoint.SetProductBaseUnit]: HttpMethod.Post,
	[Endpoint.UpdateProductUnitOfMeasure]: HttpMethod.Put,
	[Endpoint.DeleteProductUnitOfMeasure]: HttpMethod.Delete,
	[Endpoint.GetProductPricing]: HttpMethod.Get,
	[Endpoint.UpdateProductPricing]: HttpMethod.Post,
	[Endpoint.GetProductOrganization]: HttpMethod.Get,
	[Endpoint.UpdateProductOrganization]: HttpMethod.Post,
	[Endpoint.ListProductImages]: HttpMethod.Get,
	[Endpoint.AttachProductImage]: HttpMethod.Post,
	[Endpoint.ReorderProductImages]: HttpMethod.Post,
	[Endpoint.DeleteProductImage]: HttpMethod.Delete,
	[Endpoint.SetPrimaryProductImage]: HttpMethod.Post,
	[Endpoint.ListProductVariants]: HttpMethod.Get,
	[Endpoint.CreateProductVariant]: HttpMethod.Post,
	[Endpoint.GetProductVariant]: HttpMethod.Get,
	[Endpoint.UpdateProductVariant]: HttpMethod.Put,
	[Endpoint.CreateVariantBarcode]: HttpMethod.Post,
	[Endpoint.ListVariantBarcodes]: HttpMethod.Get,
	[Endpoint.DeleteVariantBarcode]: HttpMethod.Delete,
	[Endpoint.GetVariantPricing]: HttpMethod.Get,
	[Endpoint.UpdateVariantPricing]: HttpMethod.Post,
	[Endpoint.ListUnitsOfMeasure]: HttpMethod.Get,
	[Endpoint.CreateUnitOfMeasure]: HttpMethod.Post,
	[Endpoint.UpdateUnitOfMeasure]: HttpMethod.Put,
	[Endpoint.DeleteUnitOfMeasure]: HttpMethod.Delete,
	[Endpoint.ExportProducts]: HttpMethod.Post,
	[Endpoint.ImportProducts]: HttpMethod.Post,
	[Endpoint.ValidateProductImport]: HttpMethod.Post,
	[Endpoint.ListAssets]: HttpMethod.Get,
	[Endpoint.InitAssetUpload]: HttpMethod.Post,
	[Endpoint.ListAssetTags]: HttpMethod.Get,
	[Endpoint.CreateAssetTag]: HttpMethod.Post,
	[Endpoint.RemoveTagFromAssets]: HttpMethod.Post,
	[Endpoint.RenameAssetTag]: HttpMethod.Post,
	[Endpoint.GetAsset]: HttpMethod.Get,
	[Endpoint.UpdateAsset]: HttpMethod.Put,
	[Endpoint.DeleteAsset]: HttpMethod.Delete,
	[Endpoint.CompleteAssetUpload]: HttpMethod.Post,
	[Endpoint.ListMarketingChannels]: HttpMethod.Get,
	[Endpoint.CreateMarketingChannel]: HttpMethod.Post,
	[Endpoint.GetMarketingChannel]: HttpMethod.Get,
	[Endpoint.UpdateMarketingChannel]: HttpMethod.Post,
	[Endpoint.DeleteMarketingChannel]: HttpMethod.Delete,
	[Endpoint.GetFeedLayout]: HttpMethod.Get,
	[Endpoint.ReplaceFeedLayoutBlocks]: HttpMethod.Put,
	[Endpoint.GetChannelLayout]: HttpMethod.Get,
	[Endpoint.ReplaceChannelLayout]: HttpMethod.Put,
	[Endpoint.GetChannelResolvedContent]: HttpMethod.Get,
	[Endpoint.ListMarketingContent]: HttpMethod.Get,
	[Endpoint.CreateMarketingContent]: HttpMethod.Post,
	[Endpoint.GetMarketingContent]: HttpMethod.Get,
	[Endpoint.UpdateMarketingContent]: HttpMethod.Post,
	[Endpoint.DeleteMarketingContent]: HttpMethod.Delete,
	[Endpoint.ReplaceMarketingContentBlocks]: HttpMethod.Put,
	[Endpoint.DuplicateMarketingContent]: HttpMethod.Post,
	[Endpoint.ListOrders]: HttpMethod.Get,
	[Endpoint.GetOrder]: HttpMethod.Get,
	[Endpoint.RefundOrder]: HttpMethod.Post,
	[Endpoint.CancelOrder]: HttpMethod.Post,
	[Endpoint.GetExitCode]: HttpMethod.Get,
	[Endpoint.GetOrderReceipt]: HttpMethod.Post,
	[Endpoint.GetOrderReceiptUrl]: HttpMethod.Get,
	[Endpoint.InvalidateOrderReceipt]: HttpMethod.Post,
	[Endpoint.CreateOrderReceiptLink]: HttpMethod.Post,
	[Endpoint.UpdateFulfillmentStatus]: HttpMethod.Put,
	[Endpoint.GetOrderTransaction]: HttpMethod.Get,
	[Endpoint.ExportOrders]: HttpMethod.Post,
	[Endpoint.CreateBagCheck]: HttpMethod.Post,
	[Endpoint.GetBagCheck]: HttpMethod.Get,
	[Endpoint.BagCheckAddItem]: HttpMethod.Post,
	[Endpoint.BagCheckUpdateItemQuantity]: HttpMethod.Post,
	[Endpoint.RestartBagCheck]: HttpMethod.Post,
	[Endpoint.BagCheckApprove]: HttpMethod.Post,
	[Endpoint.BagCheckReject]: HttpMethod.Post,
	[Endpoint.ListPromotions]: HttpMethod.Get,
	[Endpoint.CreatePromotion]: HttpMethod.Post,
	[Endpoint.GetPromotion]: HttpMethod.Get,
	[Endpoint.DeletePromotion]: HttpMethod.Delete,
	[Endpoint.UpdatePromotion]: HttpMethod.Post,
	[Endpoint.ListPromotionGroups]: HttpMethod.Get,
	[Endpoint.ListCountries]: HttpMethod.Get,
	[Endpoint.GetCountry]: HttpMethod.Get,
	[Endpoint.ListCountryTaxRates]: HttpMethod.Get,
	[Endpoint.ListTaxRates]: HttpMethod.Get,
	[Endpoint.GetAvailableExports]: HttpMethod.Get,
	[Endpoint.PricerProductExport]: HttpMethod.Post,
	[Endpoint.VismaExport]: HttpMethod.Post,
	[Endpoint.DigiScaleProductExport]: HttpMethod.Post,
	[Endpoint.GetSAFTExportInfo]: HttpMethod.Get,
	[Endpoint.SAFTExportCashRegister]: HttpMethod.Post,
	[Endpoint.SAFTExportFinancial]: HttpMethod.Post,
	[Endpoint.ListGiftCards]: HttpMethod.Get,
	[Endpoint.CreateGiftCard]: HttpMethod.Post,
	[Endpoint.GetGiftCard]: HttpMethod.Get,
	[Endpoint.UpdateGiftCard]: HttpMethod.Put,
	[Endpoint.DeleteGiftCard]: HttpMethod.Delete,
	[Endpoint.ListCompanies]: HttpMethod.Get,
	[Endpoint.CreateCompany]: HttpMethod.Post,
	[Endpoint.GetCompany]: HttpMethod.Get,
	[Endpoint.UpdateCompany]: HttpMethod.Put,
	[Endpoint.DeleteCompany]: HttpMethod.Delete,
	[Endpoint.CreateBusinessCard]: HttpMethod.Post,
	[Endpoint.ListCompanySettlements]: HttpMethod.Get,
	[Endpoint.CreateSettlement]: HttpMethod.Post,
	[Endpoint.ListBusinessCards]: HttpMethod.Get,
	[Endpoint.GetBusinessCard]: HttpMethod.Get,
	[Endpoint.UpdateBusinessCard]: HttpMethod.Put,
	[Endpoint.DeleteBusinessCard]: HttpMethod.Delete,
	[Endpoint.ResetBusinessCardPin]: HttpMethod.Post,
	[Endpoint.VerifyBusinessCardPin]: HttpMethod.Post,
	[Endpoint.GetBusinessCardTransactions]: HttpMethod.Get,
	[Endpoint.GetSettlement]: HttpMethod.Get,
	[Endpoint.MarkSettlementSettled]: HttpMethod.Put,
	[Endpoint.GetAnalytics]: HttpMethod.Get,
	[Endpoint.GetBasketAnalysis]: HttpMethod.Get,
	[Endpoint.GetUserAnalytics]: HttpMethod.Get,
	[Endpoint.GetRevenueReport]: HttpMethod.Get,
	[Endpoint.GetProductReport]: HttpMethod.Get,
	[Endpoint.ListCustomers]: HttpMethod.Get,
	[Endpoint.CreateCustomer]: HttpMethod.Post,
	[Endpoint.GetCustomer]: HttpMethod.Get,
	[Endpoint.UpdateCustomer]: HttpMethod.Put,
	[Endpoint.RevokeCustomerTokens]: HttpMethod.Post,
	[Endpoint.AssumeCustomerToken]: HttpMethod.Post,
	[Endpoint.ListCustomerGroups]: HttpMethod.Get,
	[Endpoint.CreateCustomerGroup]: HttpMethod.Post,
	[Endpoint.GetCustomerGroup]: HttpMethod.Get,
	[Endpoint.UpdateCustomerGroup]: HttpMethod.Put,
	[Endpoint.DeleteCustomerGroup]: HttpMethod.Delete,
	[Endpoint.ListLoyaltyCards]: HttpMethod.Get,
	[Endpoint.CreateLoyaltyCard]: HttpMethod.Post,
	[Endpoint.GetLoyaltyCard]: HttpMethod.Get,
	[Endpoint.UpdateLoyaltyCard]: HttpMethod.Put,
	[Endpoint.DeleteLoyaltyCard]: HttpMethod.Delete,
	[Endpoint.GetLoyaltyCardRedemptions]: HttpMethod.Get,
	[Endpoint.GetDashboardFeatures]: HttpMethod.Get,
	[Endpoint.SubmitDeveloperFeedback]: HttpMethod.Post,
	[Endpoint.ListInventoryLocations]: HttpMethod.Get,
	[Endpoint.CreateInventoryLocation]: HttpMethod.Post,
	[Endpoint.SearchInventoryVariants]: HttpMethod.Get,
	[Endpoint.GetInventoryLocation]: HttpMethod.Get,
	[Endpoint.UpdateInventoryLocation]: HttpMethod.Put,
	[Endpoint.ProvisionInventoryLocationLevels]: HttpMethod.Post,
	[Endpoint.GetInventorySettings]: HttpMethod.Get,
	[Endpoint.UpdateInventorySettings]: HttpMethod.Put,
	[Endpoint.ListInventoryLevels]: HttpMethod.Get,
	[Endpoint.GetInventorySummary]: HttpMethod.Get,
	[Endpoint.GetInventoryLevel]: HttpMethod.Get,
	[Endpoint.UpdateInventoryLevel]: HttpMethod.Put,
	[Endpoint.AdjustInventoryLevel]: HttpMethod.Post,
	[Endpoint.ListStockMovements]: HttpMethod.Get,
	[Endpoint.ListSuppliers]: HttpMethod.Get,
	[Endpoint.CreateSupplier]: HttpMethod.Post,
	[Endpoint.GetSupplier]: HttpMethod.Get,
	[Endpoint.UpdateSupplier]: HttpMethod.Put,
	[Endpoint.ListPurchaseOrders]: HttpMethod.Get,
	[Endpoint.CreatePurchaseOrder]: HttpMethod.Post,
	[Endpoint.CreateReplenishmentPurchaseOrders]: HttpMethod.Post,
	[Endpoint.GetPurchaseOrder]: HttpMethod.Get,
	[Endpoint.ReceivePurchaseOrder]: HttpMethod.Post,
	[Endpoint.MarkPurchaseOrderOrdered]: HttpMethod.Post,
	[Endpoint.CancelPurchaseOrder]: HttpMethod.Post,
	[Endpoint.ListInventoryTransfers]: HttpMethod.Get,
	[Endpoint.CreateInventoryTransfer]: HttpMethod.Post,
	[Endpoint.GetInventoryTransfer]: HttpMethod.Get,
	[Endpoint.ShipInventoryTransfer]: HttpMethod.Post,
	[Endpoint.ReceiveInventoryTransfer]: HttpMethod.Post,
	[Endpoint.CancelInventoryTransfer]: HttpMethod.Post,
	[Endpoint.GetInventoryReportSummary]: HttpMethod.Get,
	[Endpoint.ListVariantSuppliers]: HttpMethod.Get,
	[Endpoint.UpsertVariantSupplier]: HttpMethod.Post,
	[Endpoint.SetPreferredVariantSupplier]: HttpMethod.Post,
	[Endpoint.DeleteVariantSupplier]: HttpMethod.Delete,
	[Endpoint.ListIntegrations]: HttpMethod.Get,
	[Endpoint.GetTeyaIntegration]: HttpMethod.Get,
	[Endpoint.CreateTeyaConnectUrl]: HttpMethod.Post,
	[Endpoint.DisconnectTeya]: HttpMethod.Post,
	[Endpoint.ListTeyaStores]: HttpMethod.Get,
	[Endpoint.ListTeyaTerminals]: HttpMethod.Get,
	[Endpoint.RegisterRapydDevice]: HttpMethod.Post,
	[Endpoint.PollRapydDeviceToken]: HttpMethod.Get,
	[Endpoint.GetIntegrationConfig]: HttpMethod.Get,
	[Endpoint.PutIntegrationGlobalConfig]: HttpMethod.Put,
	[Endpoint.CreateIntegrationOverride]: HttpMethod.Post,
	[Endpoint.UpdateIntegrationOverride]: HttpMethod.Put,
	[Endpoint.DeleteIntegrationOverride]: HttpMethod.Delete,
	[Endpoint.GetBillingPlan]: HttpMethod.Get,
	[Endpoint.AcceptBillingPlan]: HttpMethod.Post,
	[Endpoint.GetAppUpdateBranches]: HttpMethod.Get,
	[Endpoint.GetAppUpdates]: HttpMethod.Get
} as const satisfies { [key in Endpoint]: HttpMethod }

// Explicit endpoint type definitions (no z.infer)
export type EndpointDefinitions =
	| {
			endpoint: Endpoint.GetApiKey
			input: never
			response: {
				type: 'STANDALONE'
				identifier: string
				name: string
				actions?: {
					type: 'SCHEDULED_TASK'
					description: string
					options: {
						cron: string
						source: {
							type: 'API'
							request: {
								path: string
								method: 'GET' | 'POST'
								body: any
							}
						}
						destination: {
							type: 'FILE'
							pathTemplate: string
						}
					}
				}[]
			}
			errorResponses: { isSuccess: false; status: 403; response: string }
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							type: 'STANDALONE'
							identifier: string
							name: string
							actions?: {
								type: 'SCHEDULED_TASK'
								description: string
								options: {
									cron: string
									source: {
										type: 'API'
										request: {
											path: string
											method: 'GET' | 'POST'
											body: any
										}
									}
									destination: {
										type: 'FILE'
										pathTemplate: string
									}
								}
							}[]
						}
						raw?: AxiosResponse
				  }
				| ({ isSuccess: false; status: 403; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.Login
			input: {
				body: {
					email: string
					password: string
				}
			}
			response: AdminTypes.UserAuthResponse
			errorResponses: { isSuccess: false; status: 403; response: string }
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminTypes.UserAuthResponse; raw?: AxiosResponse }
				| ({ isSuccess: false; status: 403; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.Register
			input: {
				body: {
					inviteToken: string
					firstName: string
					lastName: string
					password: string
				}
			}
			response: AdminTypes.UserAuthResponse
			errorResponses:
				| { isSuccess: false; status: 400; response: string }
				| { isSuccess: false; status: 403; response: string }
				| { isSuccess: false; status: 429; response: string }
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminTypes.UserAuthResponse; raw?: AxiosResponse }
				| ({ isSuccess: false; status: 400; response: string } & { error?: any })
				| ({ isSuccess: false; status: 403; response: string } & { error?: any })
				| ({ isSuccess: false; status: 429; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.ResetPassword
			input: {
				body: {
					email: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses:
				| { isSuccess: false; status: 400; response: string }
				| { isSuccess: false; status: 403; response: string }
				| { isSuccess: false; status: 429; response: string }
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| ({ isSuccess: false; status: 400; response: string } & { error?: any })
				| ({ isSuccess: false; status: 403; response: string } & { error?: any })
				| ({ isSuccess: false; status: 429; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.UpdatePassword
			input: {
				body: {
					token: string
					newPassword: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses:
				| { isSuccess: false; status: 400; response: string }
				| { isSuccess: false; status: 403; response: string }
				| { isSuccess: false; status: 429; response: string }
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| ({ isSuccess: false; status: 400; response: string } & { error?: any })
				| ({ isSuccess: false; status: 403; response: string } & { error?: any })
				| ({ isSuccess: false; status: 429; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.ListUsers
			input: never
			response: AdminTypes.User[]
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminTypes.User[]; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetMe
			input: never
			response: AdminTypes.User
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminTypes.User; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateMe
			input: {
				body: {
					firstName?: string
					lastName?: string
					locale?: string
				}
			}
			response: AdminTypes.User
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminTypes.User; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ValidateMySignInPin
			input: {
				body: {
					pin: string
				}
			}
			response: {
				valid: boolean
			}
			errorResponses: { isSuccess: false; status: 403; response: string }
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							valid: boolean
						}
						raw?: AxiosResponse
				  }
				| ({ isSuccess: false; status: 403; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.SetMySignInPin
			input: {
				body: {
					password: string
					pin: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses:
				| { isSuccess: false; status: 400; response: string }
				| { isSuccess: false; status: 403; response: string }
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| ({ isSuccess: false; status: 400; response: string } & { error?: any })
				| ({ isSuccess: false; status: 403; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.GetUser
			input: {
				path: {
					userUuid: string
				}
			}
			response: AdminTypes.User
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminTypes.User; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateUser
			input: {
				path: {
					userUuid: string
				}
				body: {
					firstName?: string
					lastName?: string
					role?: AdminTypes.UserRoleType
				}
			}
			response: AdminTypes.User
			errorResponses: { isSuccess: false; status: 403; response: string }
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminTypes.User; raw?: AxiosResponse }
				| ({ isSuccess: false; status: 403; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.DeleteUser
			input: {
				path: {
					userUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetUserSignInCredentials
			input: {
				path: {
					userUuid: string
				}
			}
			response: {
				signInId?: string
				hasPin: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							signInId?: string
							hasPin: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.SetUserSignInCredentials
			input: {
				path: {
					userUuid: string
				}
				body: {
					signInId?: string | null
					pin?: string | null
				}
			}
			response: {
				success: boolean
			}
			errorResponses:
				| { isSuccess: false; status: 400; response: string }
				| { isSuccess: false; status: 409; response: string }
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| ({ isSuccess: false; status: 400; response: string } & { error?: any })
				| ({ isSuccess: false; status: 409; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.ListInvites
			input: never
			response: AdminTypes.Invite[]
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminTypes.Invite[]; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateInvite
			input: {
				body: {
					email: string
					role?: AdminTypes.UserRoleType
				}
			}
			response: {
				inviteLink: string
			}
			errorResponses:
				| {
						isSuccess: false
						status: 409
						type: 'USER_ALREADY_EXISTS'
						data: {
							email: string
						}
						message?: string
				  }
				| { isSuccess: false; status: number; type: 'UNKNOWN' }
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							inviteLink: string
						}
						raw?: AxiosResponse
				  }
				| {
						isSuccess: false
						status: 409
						type: 'USER_ALREADY_EXISTS'
						data: {
							email: string
						}
						message?: string
				  }
				| { isSuccess: false; status: number; type: 'UNKNOWN' }
	  }
	| {
			endpoint: Endpoint.DeleteInvite
			input: {
				path: {
					inviteUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListSalesChannelTypes
			input: never
			response: AdminSalesChannelsTypes.SalesChannelType[]
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.SalesChannelType[]
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateSalesChannelType
			input: {
				body: {
					name: string
					fulfillmentProvider?: CommonTypes.FulfillmentProviderType
					preauthorizationAmount?: CommonTypes.Amount
					allowCompletingUnderpaidOrders?: boolean
				}
			}
			response: AdminSalesChannelsTypes.SalesChannelType
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.SalesChannelType
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetSalesChannelType
			input: {
				path: {
					salesChannelTypeUuid: string
				}
			}
			response: AdminSalesChannelsTypes.SalesChannelType
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.SalesChannelType
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateSalesChannelType
			input: {
				path: {
					salesChannelTypeUuid: string
				}
				body: {
					name?: string
					fulfillmentProvider?: CommonTypes.FulfillmentProviderType
					preauthorizationAmount?: CommonTypes.Amount
					allowCompletingUnderpaidOrders?: boolean
				}
			}
			response: AdminSalesChannelsTypes.SalesChannelType
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.SalesChannelType
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteSalesChannelType
			input: {
				path: {
					salesChannelTypeUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListSalesChannelGroups
			input: never
			response: AdminSalesChannelsTypes.SalesChannelGroupListItem[]
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.SalesChannelGroupListItem[]
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateSalesChannelGroup
			input: {
				body: {
					name: string
				}
			}
			response: AdminSalesChannelsTypes.SalesChannelGroup
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.SalesChannelGroup
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetSalesChannelGroup
			input: {
				path: {
					salesChannelGroupUuid: string
				}
			}
			response: AdminSalesChannelsTypes.SalesChannelGroup
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.SalesChannelGroup
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateSalesChannelGroup
			input: {
				path: {
					salesChannelGroupUuid: string
				}
				body: {
					name?: string
					memberUuids?: string[]
				}
			}
			response: AdminSalesChannelsTypes.SalesChannelGroup
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.SalesChannelGroup
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteSalesChannelGroup
			input: {
				path: {
					salesChannelGroupUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListSalesChannels
			input: never
			response: AdminSalesChannelsTypes.SalesChannelListItem[]
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.SalesChannelListItem[]
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateSalesChannel
			input: {
				body: {
					name: string
					currencyCode: string
					countryCode: AdminCountryTypes.CountryCodeType
					salesChannelTypeUuid?: string
					inventoryLocationUuid?: string
					salesChannelGroupUuid?: string
				}
			}
			response: AdminSalesChannelsTypes.SalesChannel
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.SalesChannel
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetSalesChannel
			input: {
				path: {
					salesChannelUuid: string
				}
			}
			response: AdminSalesChannelsTypes.SalesChannel
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.SalesChannel
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateSalesChannel
			input: {
				path: {
					salesChannelUuid: string
				}
				body: {
					name?: string
					salesChannelTypeUuid?: string
					branchName?: string
					inventoryLocationUuid?: string
					storefrontUrl?: string
					salesChannelGroupUuid?: string
				}
			}
			response: AdminSalesChannelsTypes.SalesChannel
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.SalesChannel
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteSalesChannel
			input: {
				path: {
					salesChannelUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListPointOfSaleGroups
			input: never
			response: AdminSalesChannelsTypes.PointOfSaleGroupListItem[]
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.PointOfSaleGroupListItem[]
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreatePointOfSaleGroup
			input: {
				body: {
					name: string
				}
			}
			response: AdminSalesChannelsTypes.PointOfSaleGroup
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.PointOfSaleGroup
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetPointOfSaleGroup
			input: {
				path: {
					pointOfSaleGroupUuid: string
				}
			}
			response: AdminSalesChannelsTypes.PointOfSaleGroup
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.PointOfSaleGroup
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdatePointOfSaleGroup
			input: {
				path: {
					pointOfSaleGroupUuid: string
				}
				body: {
					name?: string
					memberUuids?: string[]
				}
			}
			response: AdminSalesChannelsTypes.PointOfSaleGroup
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.PointOfSaleGroup
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeletePointOfSaleGroup
			input: {
				path: {
					pointOfSaleGroupUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListPointsOfSale
			input: never
			response: AdminSalesChannelsTypes.PointOfSaleListItem[]
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.PointOfSaleListItem[]
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreatePointOfSale
			input: {
				body: {
					name: string
					identifier: string
					salesChannelUuids: string[]
					productGroupRelations?: {
						productGroupUuid: string
						icon?: string
					}[]
					allowedOperatingModes?: AdminSalesChannelsTypes.OperatingModeType[]
					pointOfSaleGroupUuid?: string
				}
			}
			response: AdminSalesChannelsTypes.PointOfSale
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.PointOfSale
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetPointOfSaleHierarchy
			input: never
			response: AdminSalesChannelsTypes.PointOfSaleInfo[]
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.PointOfSaleInfo[]
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetCurrentPointOfSale
			input: never
			response: AdminSalesChannelsTypes.PointOfSaleInfo
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.PointOfSaleInfo
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreatePointOfSaleWebSocketTicket
			input: never
			response: {
				ticket: string
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							ticket: string
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetPointOfSale
			input: {
				path: {
					pointOfSaleUuid: string
				}
			}
			response: AdminSalesChannelsTypes.PointOfSale
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.PointOfSale
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdatePointOfSale
			input: {
				path: {
					pointOfSaleUuid: string
				}
				body: {
					name?: string
					identifier?: string
					salesChannelUuids?: string[]
					productGroupRelations?: {
						productGroupUuid: string
						icon?: string
					}[]
					allowedOperatingModes?: AdminSalesChannelsTypes.OperatingModeType[]
					logStreamLevel?: AdminSalesChannelsTypes.LogStreamLevelType
					logStreamId?: string | null
					forcedOrientation?: AdminSalesChannelsTypes.ForcedOrientationType | null
					forcedFormFactor?: AdminSalesChannelsTypes.ForcedFormFactorType | null
					inactivityThresholdSeconds?: number
					abandonCountdownSeconds?: number
					coolerReadyTimeoutSeconds?: number
					safeAreaInsets?: AdminSalesChannelsTypes.SafeAreaInsetOverrides | null
					pointOfSaleGroupUuid?: string
					checkoutModeTheme?: AdminSalesChannelsTypes.CheckoutModeTheme | null
					checkoutModeIdleTimeoutSeconds?: number | null
				}
			}
			response: AdminSalesChannelsTypes.PointOfSale
			errorResponses: { isSuccess: false; status: 400; response: string }
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.PointOfSale
						raw?: AxiosResponse
				  }
				| ({ isSuccess: false; status: 400; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.OpenCooler
			input: {
				path: {
					pointOfSaleUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.OpenCashFloat
			input: {
				path: {
					pointOfSaleUuid: string
				}
				body: {
					amount: CommonTypes.Amount
					employeeId?: string
				}
			}
			response: AdminSalesChannelsTypes.CashFloatResponse
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.CashFloatResponse
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CashPayIn
			input: {
				path: {
					pointOfSaleUuid: string
				}
				body: {
					amount: CommonTypes.Amount
					reason?: string
					employeeId?: string
				}
			}
			response: AdminSalesChannelsTypes.CashFloatResponse
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.CashFloatResponse
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CashPayOut
			input: {
				path: {
					pointOfSaleUuid: string
				}
				body: {
					amount: CommonTypes.Amount
					reason?: string
					employeeId?: string
				}
			}
			response: AdminSalesChannelsTypes.CashFloatResponse
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.CashFloatResponse
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CashCount
			input: {
				path: {
					pointOfSaleUuid: string
				}
				body: {
					countedAmount: CommonTypes.Amount
				}
			}
			response: AdminSalesChannelsTypes.CashFloatResponse
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.CashFloatResponse
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetPointOfSaleDeviceStatus
			input: {
				path: {
					pointOfSaleUuid: string
				}
			}
			response: {
				status?: AdminSalesChannelsTypes.PointOfSaleDeviceStatus | null
				online: boolean
				amapi?: AdminSalesChannelsTypes.PointOfSaleAmapiStatus | null
				enrollment?: AdminSalesChannelsTypes.PointOfSaleEnrolledDevice | null
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							status?: AdminSalesChannelsTypes.PointOfSaleDeviceStatus | null
							online: boolean
							amapi?: AdminSalesChannelsTypes.PointOfSaleAmapiStatus | null
							enrollment?: AdminSalesChannelsTypes.PointOfSaleEnrolledDevice | null
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.RefreshPointOfSaleDeviceStatus
			input: {
				path: {
					pointOfSaleUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.LookupDeviceEnrollmentByCode
			input: {
				path: {
					pointOfSaleUuid: string
				} & {
					code: string
				}
			}
			response: AdminSalesChannelsTypes.DeviceEnrollmentLookupResponse
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.DeviceEnrollmentLookupResponse
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.EnrollPointOfSaleDevice
			input: {
				path: {
					pointOfSaleUuid: string
				}
				body: {
					code: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UnenrollPointOfSaleDevice
			input: {
				path: {
					pointOfSaleUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.NotifyPointOfSaleAppUpdate
			input: {
				path: {
					pointOfSaleUuid: string
				}
				body: {
					channel?: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.RestartPointOfSaleApp
			input: {
				path: {
					pointOfSaleUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.LockPointOfSaleKiosk
			input: {
				path: {
					pointOfSaleUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UnlockPointOfSaleKiosk
			input: {
				path: {
					pointOfSaleUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UnlockPointOfSaleDoor
			input: {
				path: {
					pointOfSaleUuid: string
				}
				body: {
					durationMs?: number
					reason?: string
				}
			}
			response: {
				success: boolean
				requestId: string
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
							requestId: string
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetGmsPlayTracks
			input: never
			response: AdminSalesChannelsTypes.GmsPlayTrack[]
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.GmsPlayTrack[]
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListPublishableKeys
			input: {
				query: {
					salesChannelUuids?: string[]
					pointOfSaleUuids?: string[]
				}
			}
			response: AdminSalesChannelsTypes.PublishableKey[]
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.PublishableKey[]
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreatePublishableKey
			input: {
				body: {
					name: string
					salesChannelUuids?: string[]
					pointOfSaleUuid?: string
					marketingChannelUuid?: string
				}
			}
			response: AdminSalesChannelsTypes.PublishableKey
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.PublishableKey
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetPublishableKey
			input: {
				path: {
					publishableKeyUuid: string
				}
			}
			response: AdminSalesChannelsTypes.PublishableKey
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.PublishableKey
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdatePublishableKey
			input: {
				path: {
					publishableKeyUuid: string
				}
				body: {
					name?: string
					salesChannelUuids?: string[]
					pointOfSaleUuid?: string
					marketingChannelUuid?: string | null
				}
			}
			response: AdminSalesChannelsTypes.PublishableKey
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.PublishableKey
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeletePublishableKey
			input: {
				path: {
					publishableKeyUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateSecretKey
			input: {
				body: {
					name: string
					salesChannelUuids?: string[]
					pointOfSaleUuid?: string
					admin?: boolean
					developmentMode?: boolean
				}
			}
			response: AdminSalesChannelsTypes.ApiKeyCreatedResponse
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.ApiKeyCreatedResponse
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateSecretKey
			input: {
				path: {
					secretKeyUuid: string
				}
				body: {
					developmentMode: boolean
				}
			}
			response: AdminSalesChannelsTypes.ApiKey
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminSalesChannelsTypes.ApiKey; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListDevices
			input: never
			response: AdminDevicesTypes.DeviceListItem[]
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminDevicesTypes.DeviceListItem[]; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateDevice
			input: {
				body: {
					name: string
					identifier?: string
					allowedOperatingModes?: AdminSalesChannelsTypes.OperatingModeType[]
					pointOfSaleUuid?: string
					marketingChannelUuid?: string
				}
			}
			response: AdminDevicesTypes.Device
			errorResponses: { isSuccess: false; status: 400; response: string }
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminDevicesTypes.Device; raw?: AxiosResponse }
				| ({ isSuccess: false; status: 400; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.GetCurrentDevice
			input: never
			response: AdminDevicesTypes.CurrentDeviceInfo
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminDevicesTypes.CurrentDeviceInfo
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetDeviceInfo
			input: never
			response: AdminDevicesTypes.DeviceInfo
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminDevicesTypes.DeviceInfo; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ReportDeviceStatus
			input: {
				body: AdminSalesChannelsTypes.PointOfSaleDeviceStatusReport
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UnenrollCurrentDevice
			input: never
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetDevice
			input: {
				path: {
					deviceUuid: string
				}
			}
			response: AdminDevicesTypes.Device
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminDevicesTypes.Device; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateDevice
			input: {
				path: {
					deviceUuid: string
				}
				body: {
					name?: string
					identifier?: string
					allowedOperatingModes?: AdminSalesChannelsTypes.OperatingModeType[]
					marketingChannelUuid?: string | null
					defaultPaymentMethod?: string | null
					forcedOrientation?: AdminSalesChannelsTypes.ForcedOrientationType | null
					language?: string | null
					showPrinterDisconnected?: boolean | null
					productListColumns?: number | null
					browseEnabled?: AdminSalesChannelsTypes.PosMutationPermissionType | null
					adjustQuantity?: AdminSalesChannelsTypes.PosMutationPermissionType | null
					clearCart?: AdminSalesChannelsTypes.PosMutationPermissionType | null
					itemDeletion?: AdminSalesChannelsTypes.PosMutationPermissionType | null
					orderRestart?: AdminSalesChannelsTypes.PosMutationPermissionType | null
					splitPercentHorizontal?: number | null
					splitPercentVertical?: number | null
					itemAddedSound?: string | null
					productNotFoundSound?: string | null
					addToCartFailedSound?: string | null
					paymentSuccessSound?: string | null
					paymentFailedSound?: string | null
					logStreamLevel?: AdminSalesChannelsTypes.LogStreamLevelType | null
					logStreamId?: string | null
					forcedFormFactor?: AdminSalesChannelsTypes.ForcedFormFactorType | null
					inactivityThresholdSeconds?: number | null
					abandonCountdownSeconds?: number | null
					coolerReadyTimeoutSeconds?: number | null
					safeAreaInsets?: AdminSalesChannelsTypes.SafeAreaInsetOverrides | null
					checkoutModeTheme?: AdminSalesChannelsTypes.CheckoutModeTheme | null
					checkoutModeIdleTimeoutSeconds?: number | null
				}
			}
			response: AdminDevicesTypes.Device
			errorResponses: { isSuccess: false; status: 400; response: string }
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminDevicesTypes.Device; raw?: AxiosResponse }
				| ({ isSuccess: false; status: 400; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.DeleteDevice
			input: {
				path: {
					deviceUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.LinkDeviceToPointOfSale
			input: {
				path: {
					deviceUuid: string
				}
				body: {
					pointOfSaleUuid: string
				}
			}
			response: AdminDevicesTypes.Device
			errorResponses: { isSuccess: false; status: 400; response: string }
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminDevicesTypes.Device; raw?: AxiosResponse }
				| ({ isSuccess: false; status: 400; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.UnlinkDeviceFromPointOfSale
			input: {
				path: {
					deviceUuid: string
				}
			}
			response: AdminDevicesTypes.Device
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminDevicesTypes.Device; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateDeviceSecretKey
			input: {
				path: {
					deviceUuid: string
				}
				body: {
					name: string
					developmentMode?: boolean
				}
			}
			response: AdminSalesChannelsTypes.ApiKeyCreatedResponse
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.ApiKeyCreatedResponse
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetDeviceStatus
			input: {
				path: {
					deviceUuid: string
				}
			}
			response: {
				status?: AdminSalesChannelsTypes.PointOfSaleDeviceStatus | null
				online: boolean
				amapi?: AdminSalesChannelsTypes.PointOfSaleAmapiStatus | null
				enrollment?: AdminSalesChannelsTypes.PointOfSaleEnrolledDevice | null
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							status?: AdminSalesChannelsTypes.PointOfSaleDeviceStatus | null
							online: boolean
							amapi?: AdminSalesChannelsTypes.PointOfSaleAmapiStatus | null
							enrollment?: AdminSalesChannelsTypes.PointOfSaleEnrolledDevice | null
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.RefreshDeviceStatus
			input: {
				path: {
					deviceUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.LookupDeviceEnrollmentByCodeForDevice
			input: {
				path: {
					deviceUuid: string
				} & {
					code: string
				}
			}
			response: AdminSalesChannelsTypes.DeviceEnrollmentLookupResponse
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminSalesChannelsTypes.DeviceEnrollmentLookupResponse
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.EnrollDevice
			input: {
				path: {
					deviceUuid: string
				}
				body: {
					code: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UnenrollDevice
			input: {
				path: {
					deviceUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteDeviceGmsDevice
			input: {
				path: {
					deviceUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateDeviceGmsEnrollment
			input: {
				path: {
					deviceUuid: string
				}
				body: {
					wifiSsid?: string
					wifiPassword?: string
					policyPresets?: AdminSalesChannelsTypes.GmsPolicyPresetType[]
				}
			}
			response: {
				qrCode: string
				expiresAt: string
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							qrCode: string
							expiresAt: string
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.SyncDeviceGmsPolicy
			input: {
				path: {
					deviceUuid: string
				}
				body: {
					minimumVersionCode?: number | null
					policyPresets?: AdminSalesChannelsTypes.GmsPolicyPresetType[]
					wifiNetworks?: AdminSalesChannelsTypes.GmsWifiNetworkInput[]
					trackId?: string | null
					policyOverrides?: any | null
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.RebootDeviceGmsDevice
			input: {
				path: {
					deviceUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListProducts
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					sortBy?: 'title' | 'status'
					sortOrder?: 'desc' | 'asc'
					groupUuids?: string[]
					categoryUuids?: string[]
					salesChannels?: string[]
					status?: AdminProductsTypes.ProductStatusType[]
					pricingMethod?: CommonTypes.PricingMethodType[]
				}
			}
			response: {
				products: AdminProductsTypes.ProductListItem[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							products: AdminProductsTypes.ProductListItem[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateProduct
			input: {
				body: {
					title: string
					subtitle?: string
					description?: string
					status: AdminProductsTypes.ProductStatusType
					salesChannelUuids?: string[]
					barcodes?: string[]
					sku?: string
					pricingMethod?: CommonTypes.PricingMethodType
				}
			}
			response: AdminProductsTypes.Product
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.Product; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListProductGroupsForPointOfSale
			input: {
				path: {
					pointOfSaleUuid: string
				}
				query: {
					q?: string
					limit?: number
					offset?: number
					sortOrder?: 'desc' | 'asc'
				}
			}
			response: {
				groups: AdminProductsTypes.PointOfSaleProductGroup[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							groups: AdminProductsTypes.PointOfSaleProductGroup[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateProductGroupsForPointOfSale
			input: {
				path: {
					pointOfSaleUuid: string
				}
				body: {
					groups: {
						productGroupUuid: string
						icon?: string
						isDefault?: boolean
					}[]
				}
			}
			response: {
				groups: AdminProductsTypes.PointOfSaleProductGroup[]
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							groups: AdminProductsTypes.PointOfSaleProductGroup[]
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetProductMenu
			input: {
				path: {
					pointOfSaleUuid: string
				}
				query: {
					q?: string
					salesChannelUuid?: string
				}
			}
			response: AdminProductsTypes.ProductMenuItem[]
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminProductsTypes.ProductMenuItem[]
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListAvailableProductsForSalesChannel
			input: {
				path: {
					salesChannelUuid: string
				}
				query: {
					q?: string
					limit?: number
					offset?: number
					sortOrder?: 'desc' | 'asc'
					groupUuids?: string[]
					categoryUuids?: string[]
				}
			}
			response: {
				products: AdminProductsTypes.AvailableProductListItem[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							products: AdminProductsTypes.AvailableProductListItem[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetProductFromBarcode
			input: {
				path: {
					barcode: string
				}
			}
			response: {
				product: AdminProductsTypes.Product
				calculatedPrices: {
					salesChannelUuid: string
					price: CommonTypes.Amount
				}[]
			}
			errorResponses:
				| {
						isSuccess: false
						status: 404
						type: 'BARCODE_NOT_FOUND'
						data: {
							barcode: string
						}
						message?: string
				  }
				| { isSuccess: false; status: number; type: 'UNKNOWN' }
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							product: AdminProductsTypes.Product
							calculatedPrices: {
								salesChannelUuid: string
								price: CommonTypes.Amount
							}[]
						}
						raw?: AxiosResponse
				  }
				| {
						isSuccess: false
						status: 404
						type: 'BARCODE_NOT_FOUND'
						data: {
							barcode: string
						}
						message?: string
				  }
				| { isSuccess: false; status: number; type: 'UNKNOWN' }
	  }
	| {
			endpoint: Endpoint.ListProductGroups
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					sortBy?: 'name' | 'productCount'
					sortOrder?: 'desc' | 'asc'
				}
			}
			response: {
				groups: AdminProductsTypes.ProductGroupListItem[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							groups: AdminProductsTypes.ProductGroupListItem[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateProductGroup
			input: {
				body: {
					name: string
				}
			}
			response: AdminProductsTypes.ProductGroup
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.ProductGroup; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetProductGroup
			input: {
				path: {
					groupUuid: string
				}
			}
			response: AdminProductsTypes.ProductGroup
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.ProductGroup; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteProductGroup
			input: {
				path: {
					groupUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateProductGroup
			input: {
				path: {
					groupUuid: string
				}
				body: {
					name: string
				}
			}
			response: AdminProductsTypes.ProductGroup
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.ProductGroup; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.SetProductGroupImage
			input: {
				path: {
					groupUuid: string
				}
				body: {
					assetUuid: string
				}
			}
			response: AdminProductsTypes.ProductGroup
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.ProductGroup; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteProductGroupImage
			input: {
				path: {
					groupUuid: string
				}
			}
			response: AdminProductsTypes.ProductGroup
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.ProductGroup; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.AddProductsToProductGroup
			input: {
				path: {
					groupUuid: string
				}
				body: {
					productUuids: string[]
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListProductGroupFees
			input: {
				path: {
					groupUuid: string
				}
			}
			response: AdminProductsTypes.Fee[]
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.Fee[]; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateProductGroupFee
			input: {
				path: {
					groupUuid: string
				}
				body: {
					name: string
					prices: AdminProductsTypes.PriceInput[]
				}
			}
			response: AdminProductsTypes.Fee
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.Fee; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetProductGroupFee
			input: {
				path: {
					groupUuid: string
				} & {
					feeUuid: string
				}
			}
			response: AdminProductsTypes.Fee
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.Fee; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteProductGroupFee
			input: {
				path: {
					groupUuid: string
				} & {
					feeUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateProductGroupFee
			input: {
				path: {
					groupUuid: string
				} & {
					feeUuid: string
				}
				body: {
					name: string
					prices: AdminProductsTypes.PriceInput[]
				}
			}
			response: AdminProductsTypes.Fee
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.Fee; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListProductCategories
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
				}
			}
			response: {
				categories: AdminProductsTypes.ProductCategory[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							categories: AdminProductsTypes.ProductCategory[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateProductCategory
			input: {
				body: {
					name: string
					parentCategoryUuid?: string
				}
			}
			response: AdminProductsTypes.ProductCategory
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.ProductCategory; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetProductCategoryHierarchy
			input: never
			response: {
				categories: AdminProductsTypes.ProductCategory[]
				hierarchy: AdminProductsTypes.ProductCategory[]
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							categories: AdminProductsTypes.ProductCategory[]
							hierarchy: AdminProductsTypes.ProductCategory[]
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetProductCategory
			input: {
				path: {
					categoryUuid: string
				}
			}
			response: AdminProductsTypes.ProductCategory
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.ProductCategory; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteProductCategory
			input: {
				path: {
					categoryUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateProductCategory
			input: {
				path: {
					categoryUuid: string
				}
				body: {
					name: string
					parentCategoryUuid?: string
				}
			}
			response: AdminProductsTypes.ProductCategory
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.ProductCategory; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.SetProductCategoryImage
			input: {
				path: {
					categoryUuid: string
				}
				body: {
					assetUuid: string
				}
			}
			response: AdminProductsTypes.ProductCategory
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.ProductCategory; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteProductCategoryImage
			input: {
				path: {
					categoryUuid: string
				}
			}
			response: AdminProductsTypes.ProductCategory
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.ProductCategory; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetProduct
			input: {
				path: {
					productUuid: string
				}
			}
			response: AdminProductsTypes.Product
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.Product; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteProduct
			input: {
				path: {
					productUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateProduct
			input: {
				path: {
					productUuid: string
				}
				body: {
					title?: string
					subtitle?: string
					description?: string
					status?: AdminProductsTypes.ProductStatusType
					barcodes?: string[]
					sku?: string
					pricingMethod?: CommonTypes.PricingMethodType
				}
			}
			response: AdminProductsTypes.Product
			errorResponses: { isSuccess: false; status: 404; response: any }
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.Product; raw?: AxiosResponse }
				| ({ isSuccess: false; status: 404; response: any } & { error?: any })
	  }
	| {
			endpoint: Endpoint.GetProductEdit
			input: {
				path: {
					productUuid: string
				}
			}
			response: {
				product: AdminProductsTypes.Product
				salesChannels: {
					uuid: string
					name: string
				}[]
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							product: AdminProductsTypes.Product
							salesChannels: {
								uuid: string
								name: string
							}[]
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListProductBarcodes
			input: {
				path: {
					productUuid: string
				}
			}
			response: string[]
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: string[]; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateProductBarcode
			input: {
				path: {
					productUuid: string
				}
				body: {
					barcode: string
					unitOfMeasureUuid?: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteProductBarcode
			input: {
				path: {
					productUuid: string
				} & {
					barcode: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateProductUnitOfMeasure
			input: {
				path: {
					productUuid: string
				}
				body: AdminProductsTypes.UnitOfMeasureInput
			}
			response: AdminProductsTypes.UnitOfMeasure
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.UnitOfMeasure; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.SetProductBaseUnit
			input: {
				path: {
					productUuid: string
				}
				body: {
					unitOfMeasureUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateProductUnitOfMeasure
			input: {
				path: {
					productUuid: string
				} & {
					unitUuid: string
				}
				body: AdminProductsTypes.UnitOfMeasureInput
			}
			response: AdminProductsTypes.UnitOfMeasure
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.UnitOfMeasure; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteProductUnitOfMeasure
			input: {
				path: {
					productUuid: string
				} & {
					unitUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetProductPricing
			input: {
				path: {
					productUuid: string
				}
			}
			response: {
				pricingMethod: CommonTypes.PricingMethodType
				prices: AdminProductsTypes.Price[]
				unitsOfMeasure?: {
					uuid: string
					code: string
					name?: string
					isBase: boolean
				}[]
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							pricingMethod: CommonTypes.PricingMethodType
							prices: AdminProductsTypes.Price[]
							unitsOfMeasure?: {
								uuid: string
								code: string
								name?: string
								isBase: boolean
							}[]
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateProductPricing
			input: {
				path: {
					productUuid: string
				}
				body: AdminProductsTypes.PriceInput[]
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetProductOrganization
			input: {
				path: {
					productUuid: string
				}
			}
			response: AdminProductsTypes.ProductOrganization
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminProductsTypes.ProductOrganization
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateProductOrganization
			input: {
				path: {
					productUuid: string
				}
				body: {
					groups: string[]
					categories: string[]
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListProductImages
			input: {
				path: {
					productUuid: string
				}
			}
			response: AdminProductsTypes.ProductImage[]
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.ProductImage[]; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.AttachProductImage
			input: {
				path: {
					productUuid: string
				}
				body: {
					assetUuid: string
					variantUuid?: string
					position?: number
					isPrimary?: boolean
				}
			}
			response: AdminProductsTypes.ProductImage
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.ProductImage; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ReorderProductImages
			input: {
				path: {
					productUuid: string
				}
				body: {
					uuid: string
					position: number
				}[]
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteProductImage
			input: {
				path: {
					productUuid: string
				} & {
					imageUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.SetPrimaryProductImage
			input: {
				path: {
					productUuid: string
				} & {
					imageUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListProductVariants
			input: {
				path: {
					productUuid: string
				}
			}
			response: AdminProductsTypes.ProductVariant[]
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminProductsTypes.ProductVariant[]
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateProductVariant
			input: {
				path: {
					productUuid: string
				}
				body: AdminProductsTypes.ProductVariant
			}
			response: AdminProductsTypes.ProductVariant
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.ProductVariant; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetProductVariant
			input: {
				path: {
					productUuid: string
				} & {
					variantUuid: string
				}
			}
			response: AdminProductsTypes.ProductVariant
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.ProductVariant; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateProductVariant
			input: {
				path: {
					productUuid: string
				} & {
					variantUuid: string
				}
				body: {
					trackInventory?: boolean
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateVariantBarcode
			input: {
				path: {
					productUuid: string
				} & {
					variantUuid: string
				}
				body: {
					barcode: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListVariantBarcodes
			input: {
				path: {
					productUuid: string
				} & {
					variantUuid: string
				}
			}
			response: string[]
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: string[]; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteVariantBarcode
			input: {
				path: {
					productUuid: string
				} & {
					variantUuid: string
				} & {
					barcode: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetVariantPricing
			input: {
				path: {
					productUuid: string
				} & {
					variantUuid: string
				}
			}
			response: AdminProductsTypes.Price[]
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminProductsTypes.Price[]; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateVariantPricing
			input: {
				path: {
					productUuid: string
				} & {
					variantUuid: string
				}
				body: AdminProductsTypes.PriceInput[]
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListUnitsOfMeasure
			input: never
			response: AdminProductsTypes.CatalogUnitOfMeasure[]
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminProductsTypes.CatalogUnitOfMeasure[]
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateUnitOfMeasure
			input: {
				body: AdminProductsTypes.CatalogUnitOfMeasureInput
			}
			response: AdminProductsTypes.CatalogUnitOfMeasure
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminProductsTypes.CatalogUnitOfMeasure
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateUnitOfMeasure
			input: {
				path: {
					unitUuid: string
				}
				body: AdminProductsTypes.CatalogUnitOfMeasureInput
			}
			response: AdminProductsTypes.CatalogUnitOfMeasure
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminProductsTypes.CatalogUnitOfMeasure
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteUnitOfMeasure
			input: {
				path: {
					unitUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ExportProducts
			input: {
				body: {
					format: any
					schema: any
					salesChannelUuid: string
				}
			}
			response: any
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: any; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ImportProducts
			input: {
				query: {
					conflictMode?: AdminProductsTypes.ImportConflictModeType
				}
				body: any
			}
			response: {
				created: number
				updated: number
				errored: number
				errors: AdminProductsTypes.ValidateProductImportError[]
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							created: number
							updated: number
							errored: number
							errors: AdminProductsTypes.ValidateProductImportError[]
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ValidateProductImport
			input: {
				query: {
					conflictMode?: AdminProductsTypes.ImportConflictModeType
				}
				body: any
			}
			response: AdminProductsTypes.ValidateProductImportResponse
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminProductsTypes.ValidateProductImportResponse
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListAssets
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					category?: CommonTypes.AssetCategoryType[]
					status?: CommonTypes.AssetStatusType[]
					tags?: string[]
					usage?: CommonTypes.AssetUsageFilterType
					channelUuids?: string[]
					contentUuids?: string[]
				}
			}
			response: {
				assets: CommonTypes.Asset[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							assets: CommonTypes.Asset[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.InitAssetUpload
			input: {
				body: {
					filename: string
					contentType: string
					size: number
					category: CommonTypes.AssetCategoryType
					tags?: string[]
				}
			}
			response: AdminAssetsTypes.InitAssetUploadResponse
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminAssetsTypes.InitAssetUploadResponse
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListAssetTags
			input: {
				query: {
					category: CommonTypes.AssetCategoryType
				}
			}
			response: {
				tags: AdminAssetsTypes.AssetTagEntry[]
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							tags: AdminAssetsTypes.AssetTagEntry[]
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateAssetTag
			input: {
				body: {
					name: string
					category: CommonTypes.AssetCategoryType
				}
			}
			response: AdminAssetsTypes.AssetTagEntry
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminAssetsTypes.AssetTagEntry; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.RemoveTagFromAssets
			input: {
				body: {
					tag: string
					category: CommonTypes.AssetCategoryType
				}
			}
			response: {
				removedFromAssetCount: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							removedFromAssetCount: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.RenameAssetTag
			input: {
				body: {
					fromName: string
					toName: string
					category: CommonTypes.AssetCategoryType
				}
			}
			response: {
				renamedOnAssetCount: number
				merged: boolean
				tag: AdminAssetsTypes.AssetTagEntry
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							renamedOnAssetCount: number
							merged: boolean
							tag: AdminAssetsTypes.AssetTagEntry
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetAsset
			input: {
				path: {
					assetUuid: string
				}
			}
			response: CommonTypes.Asset
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: CommonTypes.Asset; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateAsset
			input: {
				path: {
					assetUuid: string
				}
				body: {
					tags: string[]
				}
			}
			response: CommonTypes.Asset
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: CommonTypes.Asset; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteAsset
			input: {
				path: {
					assetUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CompleteAssetUpload
			input: {
				path: {
					assetUuid: string
				}
			}
			response: CommonTypes.Asset
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: CommonTypes.Asset; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListMarketingChannels
			input: never
			response: AdminMarketingChannelsTypes.MarketingChannel[]
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminMarketingChannelsTypes.MarketingChannel[]
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateMarketingChannel
			input: {
				body: {
					name: string
					description?: string
					surfaces?: AdminMarketingContentTypes.MarketingSurfaceType[]
					publishableKeyUuids?: string[]
				}
			}
			response: AdminMarketingChannelsTypes.MarketingChannel
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminMarketingChannelsTypes.MarketingChannel
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetMarketingChannel
			input: {
				path: {
					marketingChannelUuid: string
				}
			}
			response: AdminMarketingChannelsTypes.MarketingChannel
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminMarketingChannelsTypes.MarketingChannel
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateMarketingChannel
			input: {
				path: {
					marketingChannelUuid: string
				}
				body: {
					name?: string
					description?: string | null
					surfaces?: AdminMarketingContentTypes.MarketingSurfaceType[]
					publishableKeyUuids?: string[]
				}
			}
			response: AdminMarketingChannelsTypes.MarketingChannel
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminMarketingChannelsTypes.MarketingChannel
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteMarketingChannel
			input: {
				path: {
					marketingChannelUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetFeedLayout
			input: {
				path: {
					marketingChannelUuid: string
				}
				query: {
					surface?: AdminMarketingContentTypes.MarketingSurfaceType
				}
			}
			response: AdminMarketingChannelsTypes.FeedLayout
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminMarketingChannelsTypes.FeedLayout
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ReplaceFeedLayoutBlocks
			input: {
				path: {
					marketingChannelUuid: string
				}
				query: {
					surface?: AdminMarketingContentTypes.MarketingSurfaceType
				}
				body: {
					blocks: {
						kind: AdminMarketingContentTypes.ContentBlockKindType
						type?: 'BANNER' | 'LIST' | 'MODAL' | 'SEPARATOR'
						data?: any
					}[]
				}
			}
			response: AdminMarketingChannelsTypes.FeedLayout
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminMarketingChannelsTypes.FeedLayout
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetChannelLayout
			input: {
				path: {
					marketingChannelUuid: string
				}
				query: {
					surface?: AdminMarketingContentTypes.MarketingSurfaceType
					screenState?: AdminMarketingContentTypes.MarketingScreenStateType
				}
			}
			response: AdminMarketingChannelsTypes.ChannelLayout
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminMarketingChannelsTypes.ChannelLayout
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ReplaceChannelLayout
			input: {
				path: {
					marketingChannelUuid: string
				}
				query: {
					surface?: AdminMarketingContentTypes.MarketingSurfaceType
					screenState?: AdminMarketingContentTypes.MarketingScreenStateType
				}
				body: {
					contentUuids: string[]
				}
			}
			response: AdminMarketingChannelsTypes.ChannelLayout
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminMarketingChannelsTypes.ChannelLayout
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetChannelResolvedContent
			input: {
				path: {
					marketingChannelUuid: string
				}
				query: {
					surface?: AdminMarketingContentTypes.MarketingSurfaceType
					screenState?: AdminMarketingContentTypes.MarketingScreenStateType
				}
			}
			response: AdminMarketingChannelsTypes.ResolvedContentItem[]
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminMarketingChannelsTypes.ResolvedContentItem[]
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListMarketingContent
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					status?: AdminMarketingContentTypes.MarketingContentStatusType[]
					windowStatus?: ('ACTIVE' | 'SCHEDULED' | 'ENDED' | 'DRAFT')[]
					formats?: AdminMarketingContentTypes.MarketingContentFormatType[]
					channels?: string[]
				}
			}
			response: {
				content: AdminMarketingContentTypes.MarketingContent[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							content: AdminMarketingContentTypes.MarketingContent[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateMarketingContent
			input: {
				body: {
					name: string
					description?: string
					format?: AdminMarketingContentTypes.MarketingContentFormatType
					status?: AdminMarketingContentTypes.MarketingContentStatusType
					startsAt?: number
					endsAt?: number
					blocks?: {
						type: 'BANNER' | 'LIST' | 'MODAL' | 'SEPARATOR'
						data: any
					}[]
				}
			}
			response: AdminMarketingContentTypes.MarketingContentWithBlocks
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminMarketingContentTypes.MarketingContentWithBlocks
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetMarketingContent
			input: {
				path: {
					contentUuid: string
				}
			}
			response: AdminMarketingContentTypes.MarketingContentWithBlocks
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminMarketingContentTypes.MarketingContentWithBlocks
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateMarketingContent
			input: {
				path: {
					contentUuid: string
				}
				body: {
					name?: string
					description?: string | null
					status?: AdminMarketingContentTypes.MarketingContentStatusType
					startsAt?: number | null
					endsAt?: number | null
				}
			}
			response: AdminMarketingContentTypes.MarketingContentWithBlocks
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminMarketingContentTypes.MarketingContentWithBlocks
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteMarketingContent
			input: {
				path: {
					contentUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ReplaceMarketingContentBlocks
			input: {
				path: {
					contentUuid: string
				}
				body: {
					blocks: {
						type: 'BANNER' | 'LIST' | 'MODAL' | 'SEPARATOR'
						data: any
					}[]
				}
			}
			response: AdminMarketingContentTypes.MarketingContentWithBlocks
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminMarketingContentTypes.MarketingContentWithBlocks
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DuplicateMarketingContent
			input: {
				path: {
					contentUuid: string
				}
			}
			response: AdminMarketingContentTypes.MarketingContentWithBlocks
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminMarketingContentTypes.MarketingContentWithBlocks
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListOrders
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					sortBy?: 'date' | 'displayId' | 'total'
					sortOrder?: 'desc' | 'asc'
					salesChannelUuids?: string[]
					pointOfSaleUuids?: string[]
					fulfillmentStatuses?: AdminOrdersTypes.OrderFulfillmentStatusType[]
					paymentStatus?: CommonTypes.OrderPaymentStatusType[]
					minAmount?: number
					maxAmount?: number
					fromDate?: number
					toDate?: number
					customerUuid?: string
					customerCardUuid?: string
				}
			}
			response: {
				orders: AdminOrdersTypes.OrderListItem[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							orders: AdminOrdersTypes.OrderListItem[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetOrder
			input: {
				path: {
					orderUuid: string
				}
			}
			response: AdminOrdersTypes.Order
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminOrdersTypes.Order; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.RefundOrder
			input: {
				path: {
					orderUuid: string
				}
				body:
					| {
							type: 'ITEM_BASED'
							items: {
								orderItemUuid: string
								quantity: number
								restock?: boolean
							}[]
							additionalAmount?: CommonTypes.Amount
							note?: string
					  }
					| {
							type: 'AMOUNT_ONLY'
							amount: CommonTypes.Amount
							note?: string
					  }
			}
			response: {
				success: boolean
				refundUuid: string
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
							refundUuid: string
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CancelOrder
			input: {
				path: {
					orderUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetExitCode
			input: {
				path: {
					orderUuid: string
				}
			}
			response:
				| {
						enabled: true
						format: string
						exitCode: string
				  }
				| {
						enabled: false
				  }
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response:
							| {
									enabled: true
									format: string
									exitCode: string
							  }
							| {
									enabled: false
							  }
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetOrderReceipt
			input: {
				path: {
					orderUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetOrderReceiptUrl
			input: {
				path: {
					orderUuid: string
				}
			}
			response: {
				receiptUrl: string
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							receiptUrl: string
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.InvalidateOrderReceipt
			input: {
				path: {
					orderUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateOrderReceiptLink
			input: {
				path: {
					orderUuid: string
				}
			}
			response: {
				url: string
				expiresAt: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							url: string
							expiresAt: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateFulfillmentStatus
			input: {
				path: {
					orderUuid: string
				}
				body: {
					status: CommonTypes.FulfillmentStatusType
				}
			}
			response: {
				status: CommonTypes.FulfillmentStatusType
			}
			errorResponses: { isSuccess: false; status: 404; response: any }
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							status: CommonTypes.FulfillmentStatusType
						}
						raw?: AxiosResponse
				  }
				| ({ isSuccess: false; status: 404; response: any } & { error?: any })
	  }
	| {
			endpoint: Endpoint.GetOrderTransaction
			input: {
				path: {
					orderUuid: string
				} & {
					transactionUuid: string
				}
			}
			response: AdminOrdersTypes.OrderTransaction
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminOrdersTypes.OrderTransaction; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ExportOrders
			input: {
				body: {
					format: 'CSV' | 'JSON'
					startDate?: number
					endDate?: number
				}
			}
			response: any
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: any; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateBagCheck
			input: {
				body: {
					orderUuid: string
				}
			}
			response: AdminOrdersTypes.BagCheck
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminOrdersTypes.BagCheck; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetBagCheck
			input: {
				path: {
					checkUuid: string
				}
			}
			response: AdminOrdersTypes.BagCheck
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminOrdersTypes.BagCheck; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.BagCheckAddItem
			input: {
				path: {
					checkUuid: string
				}
				body: {
					barcode: string
				}
			}
			response: {
				bagCheck: AdminOrdersTypes.BagCheck
				itemInfo: {
					variantUuid: string
					pricingMethod: 'PER_UNIT' | 'PRICE_EMBEDDED' | 'WEIGHT_EMBEDDED'
				}
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							bagCheck: AdminOrdersTypes.BagCheck
							itemInfo: {
								variantUuid: string
								pricingMethod: 'PER_UNIT' | 'PRICE_EMBEDDED' | 'WEIGHT_EMBEDDED'
							}
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.BagCheckUpdateItemQuantity
			input: {
				path: {
					checkUuid: string
				} & {
					itemUuid: string
				}
				body: {
					quantityChange?: number
					removeFromCart?: boolean
				}
			}
			response: AdminOrdersTypes.BagCheck
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminOrdersTypes.BagCheck; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.RestartBagCheck
			input: {
				path: {
					checkUuid: string
				}
			}
			response: AdminOrdersTypes.BagCheck
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminOrdersTypes.BagCheck; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.BagCheckApprove
			input: {
				path: {
					checkUuid: string
				}
			}
			response: CommonTypes.GenericSuccess
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: CommonTypes.GenericSuccess; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.BagCheckReject
			input: {
				path: {
					checkUuid: string
				}
			}
			response: CommonTypes.GenericSuccess
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: CommonTypes.GenericSuccess; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListPromotions
			input: {
				query: {
					q?: string
					limit?: string
					offset?: string
					sortBy?: 'name' | 'enabled' | 'rank' | 'startDate' | 'endDate'
					sortOrder?: 'asc' | 'desc'
					salesChannels?: string[]
					promotionGroups?: string[]
					status?: AdminPromotionsTypes.PromotionScheduleStatusType[]
				}
			}
			response: {
				promotions: AdminPromotionsTypes.PromotionListItem[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							promotions: AdminPromotionsTypes.PromotionListItem[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreatePromotion
			input: {
				body: {
					name: string
					displayTitle?: string
					salesChannels: string[]
					salesChannelGroups?: string[]
					startDate?: number
					endDate?: number
					discountDefinition?: AdminPromotionsTypes.DiscountDefinition
					applicationRule?: AdminPromotionsTypes.ApplicationRule
					shouldOverridePrice?: boolean
					applyToAllProducts?: boolean
					productGroupUuids?: string[]
					productUuids?: string[]
					productCategoryUuids?: string[]
					customerUuids?: string[]
					customerGroupUuids?: string[]
					daysOfWeek?: AdminPromotionsTypes.PromotionDayOfWeek[]
					prices?: AdminProductsTypes.PriceInput[]
					includeFees?: boolean
					enabled?: boolean
					rank?: number
					appliesToAllUnits?: boolean
					unitOfMeasureUuid?: string
				}
			}
			response: AdminPromotionsTypes.Promotion
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminPromotionsTypes.Promotion; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetPromotion
			input: {
				path: {
					promotionUuid: string
				}
			}
			response: AdminPromotionsTypes.Promotion
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminPromotionsTypes.Promotion; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeletePromotion
			input: {
				path: {
					promotionUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdatePromotion
			input: {
				path: {
					promotionUuid: string
				}
				body: {
					name?: string
					displayTitle?: string
					startDate?: number
					endDate?: number
					discountDefinition?: AdminPromotionsTypes.DiscountDefinition
					applicationRule?: AdminPromotionsTypes.ApplicationRule
					shouldOverridePrice?: boolean
					salesChannels?: string[]
					salesChannelGroups?: string[]
					applyToAllProducts?: boolean
					productGroupUuids?: string[]
					productUuids?: string[]
					productCategoryUuids?: string[]
					customerUuids?: string[]
					customerGroupUuids?: string[]
					daysOfWeek?: AdminPromotionsTypes.PromotionDayOfWeek[]
					prices?: AdminProductsTypes.PriceInput[]
					includeFees?: boolean
					enabled?: boolean
					rank?: number
					appliesToAllUnits?: boolean
					unitOfMeasureUuid?: string
				}
			}
			response: AdminPromotionsTypes.Promotion
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminPromotionsTypes.Promotion; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListPromotionGroups
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					uuids?: string[]
					sortBy?: 'name'
					sortOrder?: 'desc' | 'asc'
				}
			}
			response: {
				promotionGroups: AdminPromotionGroupsTypes.PromotionGroup[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							promotionGroups: AdminPromotionGroupsTypes.PromotionGroup[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListCountries
			input: never
			response: AdminCountryTypes.Country[]
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminCountryTypes.Country[]; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetCountry
			input: {
				path: {
					countryCode: AdminCountryTypes.CountryCodeType
				}
			}
			response: AdminCountryTypes.Country
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminCountryTypes.Country; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListCountryTaxRates
			input: {
				path: {
					countryCode: AdminCountryTypes.CountryCodeType
				}
			}
			response: AdminCountryTypes.TaxRate[]
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminCountryTypes.TaxRate[]; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListTaxRates
			input: never
			response: AdminCountryTypes.TaxRate[]
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminCountryTypes.TaxRate[]; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetAvailableExports
			input: never
			response: {
				pricer: boolean
				visma: boolean
				digiScale: boolean
				saft: boolean
				products: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							pricer: boolean
							visma: boolean
							digiScale: boolean
							saft: boolean
							products: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.PricerProductExport
			input: {
				body: {
					salesChannelUuid: string
				}
			}
			response: string
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: string; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.VismaExport
			input: {
				body: {
					startDate: number
					endDate?: number
				}
			}
			response: {
				s3Path: string
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							s3Path: string
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DigiScaleProductExport
			input: {
				body: {
					salesChannelUuids: string[]
					groupUuids: string[]
				}
			}
			response: any
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: any; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetSAFTExportInfo
			input: never
			response: {
				isEnabled: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							isEnabled: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.SAFTExportCashRegister
			input: {
				body: {
					year: number
					month: number
				}
			}
			response: string
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: string; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.SAFTExportFinancial
			input: {
				body: {
					startDate: number
					endDate?: number
				}
			}
			response: string
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: string; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListGiftCards
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					sortOrder?: 'desc' | 'asc'
					sortBy?: 'name' | 'code' | 'status'
					code?: string
					status?: AdminGiftCardTypes.GiftCardStatusType
					currencyCode?: string
				}
			}
			response: {
				giftCards: AdminGiftCardTypes.GiftCard[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							giftCards: AdminGiftCardTypes.GiftCard[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateGiftCard
			input: {
				body: {
					name: string
					amount: CommonTypes.Amount
					currencyCode: string
				}
			}
			response: AdminGiftCardTypes.GiftCard
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminGiftCardTypes.GiftCard; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetGiftCard
			input: {
				path: {
					giftCardUuid: string
				}
			}
			response: {
				uuid: string
				name: string
				code: string
				amount: CommonTypes.Amount
				currencyCode: string
				status: AdminGiftCardTypes.GiftCardStatusType
				redemptions: {
					uuid: string
					amount: CommonTypes.Amount
					currencyCode: string
					status: AdminGiftCardTypes.GiftCardRedemptionStatusType
					orderUuid: string
					appliedAt?: number
					createdAt: number
				}[]
				createdAt: number
				updatedAt: number
			}
			errorResponses: { isSuccess: false; status: 404; response: any }
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							uuid: string
							name: string
							code: string
							amount: CommonTypes.Amount
							currencyCode: string
							status: AdminGiftCardTypes.GiftCardStatusType
							redemptions: {
								uuid: string
								amount: CommonTypes.Amount
								currencyCode: string
								status: AdminGiftCardTypes.GiftCardRedemptionStatusType
								orderUuid: string
								appliedAt?: number
								createdAt: number
							}[]
							createdAt: number
							updatedAt: number
						}
						raw?: AxiosResponse
				  }
				| ({ isSuccess: false; status: 404; response: any } & { error?: any })
	  }
	| {
			endpoint: Endpoint.UpdateGiftCard
			input: {
				path: {
					giftCardUuid: string
				}
				body: {
					name?: string
				}
			}
			response: AdminGiftCardTypes.GiftCard
			errorResponses: { isSuccess: false; status: 404; response: any }
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminGiftCardTypes.GiftCard; raw?: AxiosResponse }
				| ({ isSuccess: false; status: 404; response: any } & { error?: any })
	  }
	| {
			endpoint: Endpoint.DeleteGiftCard
			input: {
				path: {
					giftCardUuid: string
				}
			}
			response: Record<never, never>
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: Record<never, never>; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListCompanies
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					sortOrder?: 'desc' | 'asc'
					sortBy?: 'name' | 'email' | 'phone' | 'externalId' | 'settlementCount'
					name?: string
					externalId?: string
				}
			}
			response: {
				companies: AdminCompaniesTypes.Company[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							companies: AdminCompaniesTypes.Company[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateCompany
			input: {
				body: {
					name: string
					email?: string
					phone?: string
					orgNumber?: string
					externalId?: string
				}
			}
			response: AdminCompaniesTypes.Company
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminCompaniesTypes.Company; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetCompany
			input: {
				path: {
					companyUuid: string
				}
			}
			response: AdminCompaniesTypes.CompanyWithDetails
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminCompaniesTypes.CompanyWithDetails
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateCompany
			input: {
				path: {
					companyUuid: string
				}
				body: {
					name?: string
					email?: string | null
					phone?: string | null
					orgNumber?: string | null
					externalId?: string
				}
			}
			response: AdminCompaniesTypes.Company
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminCompaniesTypes.Company; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteCompany
			input: {
				path: {
					companyUuid: string
				}
			}
			response: void
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: void; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateBusinessCard
			input: {
				path: {
					companyUuid: string
				}
				body: {
					name: string
					cardNumber: string
					externalId?: string
					customerUuid?: string
				}
			}
			response: AdminCompaniesTypes.BusinessCard & {
				pin: string
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminCompaniesTypes.BusinessCard & {
							pin: string
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListCompanySettlements
			input: {
				path: {
					companyUuid: string
				}
				query: {
					q?: string
					limit?: number
					offset?: number
					sortOrder?: 'desc' | 'asc'
				}
			}
			response: {
				settlements: AdminCompaniesTypes.Settlement[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							settlements: AdminCompaniesTypes.Settlement[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateSettlement
			input: {
				path: {
					companyUuid: string
				}
				body: {
					periodStart: number
					periodEnd: number
				}
			}
			response: AdminCompaniesTypes.Settlement
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminCompaniesTypes.Settlement; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListBusinessCards
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					sortOrder?: 'desc' | 'asc'
					sortBy?: 'name' | 'cardNumber' | 'status' | 'externalId'
					name?: string
					cardNumber?: string
					status?: AdminCompaniesTypes.BusinessCardStatusType
					externalId?: string
					companyUuid?: string
					customerUuid?: string
					assignedToCustomer?: 'true' | 'false'
				}
			}
			response: {
				cards: AdminCompaniesTypes.BusinessCard[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							cards: AdminCompaniesTypes.BusinessCard[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetBusinessCard
			input: {
				path: {
					cardUuid: string
				}
			}
			response: AdminCompaniesTypes.BusinessCard
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminCompaniesTypes.BusinessCard; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateBusinessCard
			input: {
				path: {
					cardUuid: string
				}
				body: {
					name?: string
					status?: AdminCompaniesTypes.BusinessCardStatusType
					externalId?: string
					companyUuid?: string | null
					customerUuid?: string | null
				}
			}
			response: AdminCompaniesTypes.BusinessCard
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminCompaniesTypes.BusinessCard; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteBusinessCard
			input: {
				path: {
					cardUuid: string
				}
			}
			response: CommonTypes.GenericSuccess
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: CommonTypes.GenericSuccess; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ResetBusinessCardPin
			input: {
				path: {
					cardUuid: string
				}
			}
			response: {
				uuid: string
				pin: string
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							uuid: string
							pin: string
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.VerifyBusinessCardPin
			input: {
				path: {
					cardUuid: string
				}
				body: {
					pin: string
				}
			}
			response: {
				success: boolean
				error?: string
				message?: string
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
							error?: string
							message?: string
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetBusinessCardTransactions
			input: {
				path: {
					cardUuid: string
				}
				query: {
					q?: string
					limit?: number
					offset?: number
					sortOrder?: 'desc' | 'asc'
				}
			}
			response: {
				transactions: AdminCompaniesTypes.BusinessCardTransaction[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							transactions: AdminCompaniesTypes.BusinessCardTransaction[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetSettlement
			input: {
				path: {
					settlementUuid: string
				}
			}
			response: AdminCompaniesTypes.SettlementWithTransactions
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminCompaniesTypes.SettlementWithTransactions
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.MarkSettlementSettled
			input: {
				path: {
					settlementUuid: string
				}
			}
			response: {
				uuid: string
				settledAt: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							uuid: string
							settledAt: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetAnalytics
			input: {
				query: {
					interval: AdminAnalyticsTypes.AnalyticsIntervalType
					periodStart?: string
					comparePeriod?: string
					salesChannelUuids?: string[]
					salesChannelGroupUuids?: string[]
					compareSalesChannelUuids?: string[]
				}
			}
			response: AdminAnalyticsTypes.AnalyticsResponse
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminAnalyticsTypes.AnalyticsResponse
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetBasketAnalysis
			input: {
				query: {
					interval: AdminAnalyticsTypes.AnalyticsIntervalType
					periodStart?: string
					productUuids?: string[]
					categoryUuids?: string[]
					excludeProductUuids?: string[]
					excludeCategoryUuids?: string[]
					salesChannelUuids?: string[]
					pointOfSaleUuid?: string
					minSupport?: number
					productSortBy?: AdminAnalyticsTypes.BasketPairSortFieldType
					productSortOrder?: AdminAnalyticsTypes.BasketSortOrderType
					categorySortBy?: AdminAnalyticsTypes.BasketPairSortFieldType
					categorySortOrder?: AdminAnalyticsTypes.BasketSortOrderType
				}
			}
			response: AdminAnalyticsTypes.BasketAnalysisResponse
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminAnalyticsTypes.BasketAnalysisResponse
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetUserAnalytics
			input: {
				query: {
					interval: AdminAnalyticsTypes.AnalyticsIntervalType
					periodStart?: string
					comparePeriod?: string
				}
			}
			response: AdminAnalyticsTypes.UserAnalyticsResponse
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminAnalyticsTypes.UserAnalyticsResponse
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetRevenueReport
			input: {
				query: {
					interval: AdminAnalyticsTypes.AnalyticsIntervalType
					periodStart?: string
					comparePeriod?: string
					salesChannelUuids?: string[]
					compareSalesChannelUuids?: string[]
					groupBy?: AdminAnalyticsTypes.RevenueReportGroupByType
				}
			}
			response: AdminAnalyticsTypes.RevenueReportResponse
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminAnalyticsTypes.RevenueReportResponse
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetProductReport
			input: {
				query: {
					interval: AdminAnalyticsTypes.AnalyticsIntervalType
					periodStart?: string
					comparePeriod?: string
					salesChannelUuids?: string[]
					compareSalesChannelUuids?: string[]
					productUuids?: string[]
					sortBy?: AdminAnalyticsTypes.ProductReportSortFieldType
					sortOrder?: AdminAnalyticsTypes.BasketSortOrderType
					limit?: number
					offset?: number
				}
			}
			response: AdminAnalyticsTypes.ProductReportResponse
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminAnalyticsTypes.ProductReportResponse
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListCustomers
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					sortBy?: 'name' | 'createdAt' | 'email'
					sortOrder?: 'desc' | 'asc'
					firstName?: string
					lastName?: string
					email?: string
					phone?: string
					ssn?: string
					externalId?: string
				}
			}
			response: {
				customers: AdminCustomersTypes.Customer[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							customers: AdminCustomersTypes.Customer[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateCustomer
			input: {
				body: AdminCustomersTypes.CustomerParams
			}
			response: AdminCustomersTypes.Customer
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminCustomersTypes.Customer; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetCustomer
			input: {
				path: {
					customerUuid: string
				}
			}
			response: AdminCustomersTypes.Customer
			errorResponses: { isSuccess: false; status: 404; response: any }
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminCustomersTypes.Customer; raw?: AxiosResponse }
				| ({ isSuccess: false; status: 404; response: any } & { error?: any })
	  }
	| {
			endpoint: Endpoint.UpdateCustomer
			input: {
				path: {
					customerUuid: string
				}
				body: AdminCustomersTypes.CustomerParams
			}
			response: AdminCustomersTypes.Customer
			errorResponses: { isSuccess: false; status: 404; response: any }
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminCustomersTypes.Customer; raw?: AxiosResponse }
				| ({ isSuccess: false; status: 404; response: any } & { error?: any })
	  }
	| {
			endpoint: Endpoint.RevokeCustomerTokens
			input: {
				path: {
					customerUuid: string
				}
			}
			response: {
				revokedAt: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							revokedAt: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.AssumeCustomerToken
			input: {
				path: {
					customerUuid: string
				}
			}
			response: {
				token: string
				expiresAt: number
				customerUuid: string
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							token: string
							expiresAt: number
							customerUuid: string
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListCustomerGroups
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					sortBy?: 'name' | 'createdAt'
					sortOrder?: 'desc' | 'asc'
				}
			}
			response: {
				customerGroups: AdminCustomerGroupsTypes.CustomerGroup[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							customerGroups: AdminCustomerGroupsTypes.CustomerGroup[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateCustomerGroup
			input: {
				body: {
					name: string
					description?: string
					externalId?: string
					customerUuids?: string[]
				}
			}
			response: AdminCustomerGroupsTypes.CustomerGroup
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminCustomerGroupsTypes.CustomerGroup
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetCustomerGroup
			input: {
				path: {
					customerGroupUuid: string
				}
			}
			response: AdminCustomerGroupsTypes.CustomerGroup
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminCustomerGroupsTypes.CustomerGroup
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateCustomerGroup
			input: {
				path: {
					customerGroupUuid: string
				}
				body: {
					name?: string
					description?: string
					externalId?: string
					customerUuids?: string[]
				}
			}
			response: AdminCustomerGroupsTypes.CustomerGroup
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminCustomerGroupsTypes.CustomerGroup
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteCustomerGroup
			input: {
				path: {
					customerGroupUuid: string
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: boolean
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListLoyaltyCards
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					sortOrder?: 'desc' | 'asc'
					sortBy?: 'name' | 'cardNumber' | 'status'
					name?: string
					cardNumber?: string
					status?: AdminLoyaltyCardTypes.LoyaltyCardStatusType
					customerUuid?: string
					externalSource?: string
				}
			}
			response: {
				cards: AdminLoyaltyCardTypes.LoyaltyCard[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							cards: AdminLoyaltyCardTypes.LoyaltyCard[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateLoyaltyCard
			input: {
				body: {
					name: string
					cardNumber: string
					customerUuid?: string
					initialPoints?: number
					externalId?: string
				}
			}
			response: AdminLoyaltyCardTypes.LoyaltyCard
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminLoyaltyCardTypes.LoyaltyCard; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetLoyaltyCard
			input: {
				path: {
					cardUuid: string
				}
			}
			response: AdminLoyaltyCardTypes.LoyaltyCard
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminLoyaltyCardTypes.LoyaltyCard; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateLoyaltyCard
			input: {
				path: {
					cardUuid: string
				}
				body: {
					name?: string
					status?: AdminLoyaltyCardTypes.LoyaltyCardStatusType
					customerUuid?: string | null
					availablePoints?: number
					totalPoints?: number
				}
			}
			response: AdminLoyaltyCardTypes.LoyaltyCard
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminLoyaltyCardTypes.LoyaltyCard; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteLoyaltyCard
			input: {
				path: {
					cardUuid: string
				}
			}
			response: Record<never, never>
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: Record<never, never>; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetLoyaltyCardRedemptions
			input: {
				path: {
					cardUuid: string
				}
				query: {
					q?: string
					limit?: number
					offset?: number
					sortOrder?: 'desc' | 'asc'
				}
			}
			response: {
				redemptions: AdminLoyaltyCardTypes.LoyaltyCardRedemption[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							redemptions: AdminLoyaltyCardTypes.LoyaltyCardRedemption[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetDashboardFeatures
			input: never
			response: AdminDashboardFeaturesTypes.DashboardFeatures
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminDashboardFeaturesTypes.DashboardFeatures
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.SubmitDeveloperFeedback
			input: {
				body: {
					title: string
					body?: string
					type: 'small-fix' | 'bug' | 'enhancement' | 'note'
					app: 'dashboard' | 'storefront' | 'customer-app' | 'merchant-app'
					appVersion?: string
					route?: string
					deviceInfo?: string
				}
			}
			response: {
				identifier: string
				url: string
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							identifier: string
							url: string
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListInventoryLocations
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
				}
			}
			response: {
				inventoryLocations: AdminInventoryTypes.InventoryLocationListItem[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							inventoryLocations: AdminInventoryTypes.InventoryLocationListItem[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateInventoryLocation
			input: {
				body: {
					name: string
				}
			}
			response: AdminInventoryTypes.InventoryLocationListItem
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.InventoryLocationListItem
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.SearchInventoryVariants
			input: {
				query: {
					q: string
					inventoryLocationUuid?: string
					limit?: number
				}
			}
			response: {
				variants: AdminInventoryTypes.InventoryVariantSearchItem[]
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							variants: AdminInventoryTypes.InventoryVariantSearchItem[]
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetInventoryLocation
			input: {
				path: {
					inventoryLocationUuid: string
				}
			}
			response: AdminInventoryTypes.InventoryLocationDetail
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.InventoryLocationDetail
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateInventoryLocation
			input: {
				path: {
					inventoryLocationUuid: string
				}
				body: {
					name: string
					salesChannelUuids?: string[]
				}
			}
			response: AdminInventoryTypes.InventoryLocationDetail
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.InventoryLocationDetail
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ProvisionInventoryLocationLevels
			input: {
				path: {
					inventoryLocationUuid: string
				}
				body: {
					batchSize?: number
					dryRun?: boolean
				}
			}
			response: AdminInventoryTypes.BackfillInventoryLevelsResult
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.BackfillInventoryLevelsResult
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetInventorySettings
			input: never
			response: AdminInventoryTypes.InventorySettings
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.InventorySettings
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateInventorySettings
			input: {
				body: {
					enabled?: boolean
					deductOnOrderComplete?: boolean
					blockOversell?: boolean
					restockOnReturn?: boolean
					hideOutOfStock?: boolean
				}
			}
			response: AdminInventoryTypes.InventorySettings
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.InventorySettings
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListInventoryLevels
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					sortBy?: 'quantityOnHand' | 'reorderPoint'
					sortOrder?: 'asc' | 'desc'
					inventoryLocationUuid?: string
					lowStockOnly?: boolean
					stockStatus?: AdminInventoryTypes.InventoryStockStatusType
				}
			}
			response: {
				inventoryLevels: AdminInventoryTypes.InventoryLevelListItem[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							inventoryLevels: AdminInventoryTypes.InventoryLevelListItem[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetInventorySummary
			input: {
				query: {
					inventoryLocationUuid?: string
				}
			}
			response: AdminInventoryTypes.InventorySummary
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.InventorySummary
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetInventoryLevel
			input: {
				path: {
					inventoryLevelUuid: string
				}
			}
			response: AdminInventoryTypes.InventoryLevelDetail
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.InventoryLevelDetail
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateInventoryLevel
			input: {
				path: {
					inventoryLevelUuid: string
				}
				body: {
					reorderPoint?: number
					reorderQuantity?: number
				}
			}
			response: AdminInventoryTypes.InventoryLevelDetail
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.InventoryLevelDetail
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.AdjustInventoryLevel
			input: {
				path: {
					inventoryLevelUuid: string
				}
				body: {
					quantityDelta: number
					reason?: string
				}
			}
			response: AdminInventoryTypes.InventoryLevelDetail
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.InventoryLevelDetail
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListStockMovements
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					sortBy?: 'createdAt' | 'type' | 'quantityDelta' | 'quantityAfter' | 'reason'
					sortOrder?: 'asc' | 'desc'
					inventoryLocationUuid?: string
					variantUuid?: string
					type?: AdminInventoryTypes.StockMovementTypeType
					fromDate?: number
					toDate?: number
				}
			}
			response: {
				stockMovements: AdminInventoryTypes.StockMovementListItem[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							stockMovements: AdminInventoryTypes.StockMovementListItem[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListSuppliers
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					sortBy?: 'name' | 'currencyCode' | 'email' | 'externalId'
					sortOrder?: 'asc' | 'desc'
				}
			}
			response: {
				suppliers: AdminInventoryTypes.Supplier[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							suppliers: AdminInventoryTypes.Supplier[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateSupplier
			input: {
				body: {
					name: string
					currencyCode?: string
					email?: string
					phone?: string
					externalId?: string
				}
			}
			response: AdminInventoryTypes.Supplier
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminInventoryTypes.Supplier; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetSupplier
			input: {
				path: {
					supplierUuid: string
				}
			}
			response: AdminInventoryTypes.Supplier
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminInventoryTypes.Supplier; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateSupplier
			input: {
				path: {
					supplierUuid: string
				}
				body: {
					name?: string
					currencyCode?: string
					email?: string
					phone?: string
					externalId?: string
				}
			}
			response: AdminInventoryTypes.Supplier
			errorResponses: never
			noThrowResult:
				| { isSuccess: true; status: number; response: AdminInventoryTypes.Supplier; raw?: AxiosResponse }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListPurchaseOrders
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					sortBy?: 'referenceNumber' | 'supplierName' | 'lineCount' | 'status'
					sortOrder?: 'asc' | 'desc'
					inventoryLocationUuid?: string
					status?: AdminInventoryTypes.PurchaseOrderStatusType
				}
			}
			response: {
				purchaseOrders: AdminInventoryTypes.PurchaseOrderListItem[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							purchaseOrders: AdminInventoryTypes.PurchaseOrderListItem[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreatePurchaseOrder
			input: {
				body: {
					inventoryLocationUuid: string
					supplierUuid?: string
					currencyCode?: string
					referenceNumber?: string
					expectedAt?: number
					notes?: string
					lines: {
						variantUuid: string
						orderedQuantity: number
						unitCost?: CommonTypes.Amount
					}[]
				}
			}
			response: AdminInventoryTypes.PurchaseOrderDetail
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.PurchaseOrderDetail
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateReplenishmentPurchaseOrders
			input: {
				body: {
					inventoryLocationUuid: string
				}
			}
			response: {
				purchaseOrders: AdminInventoryTypes.PurchaseOrderDetail[]
				created: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							purchaseOrders: AdminInventoryTypes.PurchaseOrderDetail[]
							created: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetPurchaseOrder
			input: {
				path: {
					purchaseOrderUuid: string
				}
			}
			response: AdminInventoryTypes.PurchaseOrderDetail
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.PurchaseOrderDetail
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ReceivePurchaseOrder
			input: {
				path: {
					purchaseOrderUuid: string
				}
				body: {
					lines: {
						lineUuid: string
						receivedQuantity: number
					}[]
					notes?: string
				}
			}
			response: AdminInventoryTypes.PurchaseOrderDetail
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.PurchaseOrderDetail
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.MarkPurchaseOrderOrdered
			input: {
				path: {
					purchaseOrderUuid: string
				}
			}
			response: AdminInventoryTypes.PurchaseOrderDetail
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.PurchaseOrderDetail
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CancelPurchaseOrder
			input: {
				path: {
					purchaseOrderUuid: string
				}
			}
			response: AdminInventoryTypes.PurchaseOrderDetail
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.PurchaseOrderDetail
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListInventoryTransfers
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					sortBy?: 'lineCount' | 'status'
					sortOrder?: 'asc' | 'desc'
					status?: AdminInventoryTypes.InventoryTransferStatusType
				}
			}
			response: {
				inventoryTransfers: AdminInventoryTypes.InventoryTransferListItem[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							inventoryTransfers: AdminInventoryTypes.InventoryTransferListItem[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateInventoryTransfer
			input: {
				body: {
					fromInventoryLocationUuid: string
					toInventoryLocationUuid: string
					notes?: string
					lines: {
						variantUuid: string
						quantity: number
					}[]
				}
			}
			response: AdminInventoryTypes.InventoryTransferDetail
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.InventoryTransferDetail
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetInventoryTransfer
			input: {
				path: {
					inventoryTransferUuid: string
				}
			}
			response: AdminInventoryTypes.InventoryTransferDetail
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.InventoryTransferDetail
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ShipInventoryTransfer
			input: {
				path: {
					inventoryTransferUuid: string
				}
			}
			response: AdminInventoryTypes.InventoryTransferDetail
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.InventoryTransferDetail
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ReceiveInventoryTransfer
			input: {
				path: {
					inventoryTransferUuid: string
				}
			}
			response: AdminInventoryTypes.InventoryTransferDetail
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.InventoryTransferDetail
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CancelInventoryTransfer
			input: {
				path: {
					inventoryTransferUuid: string
				}
			}
			response: AdminInventoryTypes.InventoryTransferDetail
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.InventoryTransferDetail
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetInventoryReportSummary
			input: {
				query: {
					inventoryLocationUuid?: string
				}
			}
			response: AdminInventoryTypes.InventoryReportSummary
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.InventoryReportSummary
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListVariantSuppliers
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
					variantUuid?: string
					supplierUuid?: string
				}
			}
			response: {
				variantSuppliers: AdminInventoryTypes.VariantSupplier[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							variantSuppliers: AdminInventoryTypes.VariantSupplier[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpsertVariantSupplier
			input: {
				body: {
					variantUuid: string
					supplierUuid: string
					purchasePrice: CommonTypes.Amount
					currencyCode: string
					supplierProductCode?: string
					isPreferred?: boolean
				}
			}
			response: AdminInventoryTypes.VariantSupplier
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.VariantSupplier
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.SetPreferredVariantSupplier
			input: {
				path: {
					variantSupplierUuid: string
				}
			}
			response: AdminInventoryTypes.VariantSupplier
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminInventoryTypes.VariantSupplier
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteVariantSupplier
			input: {
				path: {
					variantSupplierUuid: string
				}
			}
			response: {
				success: true
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							success: true
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListIntegrations
			input: never
			response: AdminIntegrationsTypes.IntegrationSummary[]
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminIntegrationsTypes.IntegrationSummary[]
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetTeyaIntegration
			input: never
			response: AdminIntegrationsTypes.TeyaIntegration
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminIntegrationsTypes.TeyaIntegration
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateTeyaConnectUrl
			input: never
			response: {
				authorizeUrl: string
			}
			errorResponses:
				| { isSuccess: false; status: 404; response: string }
				| { isSuccess: false; status: 409; response: string }
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							authorizeUrl: string
						}
						raw?: AxiosResponse
				  }
				| ({ isSuccess: false; status: 404; response: string } & { error?: any })
				| ({ isSuccess: false; status: 409; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.DisconnectTeya
			input: never
			response: AdminIntegrationsTypes.TeyaIntegration
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminIntegrationsTypes.TeyaIntegration
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.ListTeyaStores
			input: never
			response: {
				stores: AdminIntegrationsTypes.TeyaStore[]
			}
			errorResponses:
				| { isSuccess: false; status: 409; response: string }
				| { isSuccess: false; status: 502; response: string }
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							stores: AdminIntegrationsTypes.TeyaStore[]
						}
						raw?: AxiosResponse
				  }
				| ({ isSuccess: false; status: 409; response: string } & { error?: any })
				| ({ isSuccess: false; status: 502; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.ListTeyaTerminals
			input: {
				path: {
					storeId: string
				}
			}
			response: {
				terminals: AdminIntegrationsTypes.TeyaTerminal[]
			}
			errorResponses:
				| { isSuccess: false; status: 409; response: string }
				| { isSuccess: false; status: 502; response: string }
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							terminals: AdminIntegrationsTypes.TeyaTerminal[]
						}
						raw?: AxiosResponse
				  }
				| ({ isSuccess: false; status: 409; response: string } & { error?: any })
				| ({ isSuccess: false; status: 502; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.RegisterRapydDevice
			input: {
				body: {
					serialNumber: string
				}
			}
			response: {
				status: string
			}
			errorResponses:
				| { isSuccess: false; status: 409; response: string }
				| { isSuccess: false; status: 502; response: string }
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							status: string
						}
						raw?: AxiosResponse
				  }
				| ({ isSuccess: false; status: 409; response: string } & { error?: any })
				| ({ isSuccess: false; status: 502; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.PollRapydDeviceToken
			input: {
				path: {
					serialNumber: string
				}
			}
			response: AdminIntegrationsTypes.RapydDeviceTokenStatus
			errorResponses:
				| { isSuccess: false; status: 409; response: string }
				| { isSuccess: false; status: 502; response: string }
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminIntegrationsTypes.RapydDeviceTokenStatus
						raw?: AxiosResponse
				  }
				| ({ isSuccess: false; status: 409; response: string } & { error?: any })
				| ({ isSuccess: false; status: 502; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.GetIntegrationConfig
			input: {
				path: {
					provider: AdminIntegrationsTypes.IntegrationProviderType
				}
			}
			response: AdminIntegrationsTypes.IntegrationConfig
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminIntegrationsTypes.IntegrationConfig
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.PutIntegrationGlobalConfig
			input: {
				path: {
					provider: AdminIntegrationsTypes.IntegrationProviderType
				}
				body: {
					values: any
				}
			}
			response: AdminIntegrationsTypes.IntegrationConfig
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminIntegrationsTypes.IntegrationConfig
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.CreateIntegrationOverride
			input: {
				path: {
					provider: AdminIntegrationsTypes.IntegrationProviderType
				}
				body: {
					targetUuid: string
					values: any
				}
			}
			response: AdminIntegrationsTypes.IntegrationConfig
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminIntegrationsTypes.IntegrationConfig
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.UpdateIntegrationOverride
			input: {
				path: {
					provider: AdminIntegrationsTypes.IntegrationProviderType
				} & {
					featureId: string
				}
				body: {
					values: any
				}
			}
			response: AdminIntegrationsTypes.IntegrationConfig
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminIntegrationsTypes.IntegrationConfig
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.DeleteIntegrationOverride
			input: {
				path: {
					provider: AdminIntegrationsTypes.IntegrationProviderType
				} & {
					featureId: string
				}
			}
			response: AdminIntegrationsTypes.IntegrationConfig
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminIntegrationsTypes.IntegrationConfig
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetBillingPlan
			input: never
			response: AdminBillingTypes.BillingPlanResponse
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminBillingTypes.BillingPlanResponse
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.AcceptBillingPlan
			input: never
			response: AdminBillingTypes.BillingPlanResponse
			errorResponses:
				| { isSuccess: false; status: 403; response: string }
				| { isSuccess: false; status: 409; response: string }
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: AdminBillingTypes.BillingPlanResponse
						raw?: AxiosResponse
				  }
				| ({ isSuccess: false; status: 403; response: string } & { error?: any })
				| ({ isSuccess: false; status: 409; response: string } & { error?: any })
	  }
	| {
			endpoint: Endpoint.GetAppUpdateBranches
			input: never
			response: {
				branches: CommonTypes.AppUpdateBranch[]
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							branches: CommonTypes.AppUpdateBranch[]
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }
	| {
			endpoint: Endpoint.GetAppUpdates
			input: {
				path: {
					branchName: string
				}
				query: {
					q?: string
					limit?: number
					offset?: number
				}
			}
			response: {
				updates: CommonTypes.AppUpdate[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
			noThrowResult:
				| {
						isSuccess: true
						status: number
						response: {
							updates: CommonTypes.AppUpdate[]
							count: number
							limit: number
							offset: number
						}
						raw?: AxiosResponse
				  }
				| { isSuccess: false; status: number; error?: any; response?: any }
	  }

export const KnownErrorDefinitions = {
	BARCODE_NOT_FOUND: { status: 404 as const, hasData: true as const },
	USER_ALREADY_EXISTS: { status: 409 as const, hasData: true as const }
} as const
export type KnownErrorType = keyof typeof KnownErrorDefinitions

export const EndpointKnownErrorValidators = {
	[Endpoint.CreateInvite]: z.object({
		type: z.enum(['USER_ALREADY_EXISTS']),
		message: z.string().optional(),
		data: z.object({
			email: z.string()
		})
	}),
	[Endpoint.GetProductFromBarcode]: z.object({
		type: z.enum(['BARCODE_NOT_FOUND']),
		message: z.string().optional(),
		data: z.object({
			barcode: z.string()
		})
	})
} as const

export type EndpointInput<T extends Endpoint> = Extract<EndpointDefinitions, { endpoint: T }>['input'] extends never
	? Record<string, never>
	: Extract<EndpointDefinitions, { endpoint: T }>['input']
export type EndpointPath<T extends Endpoint, TDefault = never> =
	EndpointInput<T> extends { path: infer P } ? P : TDefault
export type EndpointBody<T extends Endpoint, TDefault = never> =
	EndpointInput<T> extends { body: infer B } ? B : TDefault
export type EndpointQuery<T extends Endpoint, TDefault = never> =
	EndpointInput<T> extends { query: infer Q } ? Q : TDefault
export type EndpointHeaders<T extends Endpoint, TDefault = never> =
	EndpointInput<T> extends { headers: infer H } ? H : TDefault
export type EndpointResponse<T extends Endpoint> = Extract<EndpointDefinitions, { endpoint: T }>['response']
export type EndpointErrorResponses<T extends Endpoint> = Extract<EndpointDefinitions, { endpoint: T }>['errorResponses']
export type EndpointKnownError<T extends Endpoint> = Exclude<EndpointErrorResponses<T>, { type: 'UNKNOWN' } | never>
export type EndpointPathAndQueryUnion<T extends Endpoint> = EndpointPath<T, unknown> & EndpointQuery<T, unknown>
export type EndpointNoThrowResult<T extends Endpoint> = Extract<EndpointDefinitions, { endpoint: T }>['noThrowResult']
